// Generated from the production UI baseline. Do not edit directly.
import { stateClient } from '../lib/state-client';
import { launchPlanClient } from '../lib/launch-plan-client';
import { api } from '../lib/api';

export async function mountLegacyApp(currentUser) {
const sections = [
      {
        id: 'home',
        label: '品牌主页',
        en: 'Brand Home',
        title: '佩戴属于你的<span class="accent">神话</span>',
        summary: 'AngelMyth 陪伴女孩从模仿、尝试走向判断与表达。饰品不是附属装饰，而是她在不同人生阶段选择自己、记录自己的随身印记。'
      },
      {
        id: 'brand-story',
        label: '品牌故事',
        en: 'Brand Story',
        summary: '一个生活在首尔的普通女孩，从18岁走到28岁：她试过许多人的样子，最终学会用自己的判断，决定今天成为谁。'
      },
      {
        id: 'positioning',
        label: '品牌定位',
        en: 'Brand Positioning',
        summary: '定义 AngelMyth 为什么存在、为谁存在，以及在同类品牌中占据什么不可替代的位置。',
        purpose: '把模糊的品牌感觉，收束为一句可指导产品、内容与渠道决策的核心定位。',
        prompts: [
          ['品牌使命', '我们真正想为消费者改变什么？'],
          ['核心价值主张', '消费者选择我们，而不是其他品牌的首要理由。'],
          ['竞争参照系', '我们进入的是哪一类市场，又希望打破哪一种旧标准？'],
          ['品牌人格', '如果品牌是一个人，他的态度、语气与审美边界是什么？']
        ]
      },
      {
        id: 'consumer',
        label: '消费者画像探索',
        en: 'Consumer Portrait',
        summary: '从真实生活方式、购买动机与心理张力出发，构建可用于产品决策的核心人群画像。',
        purpose: '不只描述年龄和收入，更要找到他们正在追求的身份、生活状态与未被满足的需要。',
        prompts: [
          ['核心人群', '年龄、城市、职业、收入与审美倾向。'],
          ['内在动机', '他们通过购买这类产品，想成为怎样的人？'],
          ['消费阻力', '价格、信任、适配度或选择成本中，最大的犹豫是什么？'],
          ['决策触点', '什么内容、人物、场所或口碑最容易促成购买？']
        ],
        choices: [
          [
            ['初入社会的韩系女孩', '18–24岁，大学生、研究生及职场新人；喜欢韩系、甜酷和轻精致风格'],
            ['都市成长型女性', '24–28岁核心成交人群，一二线及新一线城市；品牌整体覆盖18–35岁成长型女性'],
            ['轻熟品质女性', '26–35岁，收入稳定、判断成熟；重视通勤、约会、聚会与礼赠的多场景适配'],
            ['个性表达型女性', '20–35岁，以审美态度聚合；偏爱自由叠戴与甜酷混搭']
          ],
          [
            ['让日常穿搭更完整', '用容易搭配的饰品快速提升通勤、约会和聚会造型的精致感'],
            ['表达正在成长的自己', '把饰品作为成长与自我选择的印记，从模仿逐渐走向自主判断'],
            ['获得轻松可见的情绪奖励', '在完成目标、度过低谷或迎接新阶段时，用小礼物奖励自己'],
            ['建立个人风格与辨识度', '通过叠戴与组合形成独特但不过度张扬的穿搭语言']
          ],
          [
            ['担心实物缺乏质感', '担心颜色、做工和实际效果与图片及模特展示存在落差'],
            ['担心褪色、过敏与不耐用', '关注镀层、材质安全，以及日常佩戴后的耐久程度'],
            ['不知道是否适合自己', '担心尺寸、脸型、肤色及常用服装与产品难以匹配'],
            ['款式太多，缺少购买理由', '同类饰品高度相似，难以判断 AngelMyth 的设计与价值差异']
          ],
          [
            ['真实、多场景的佩戴展示', '不同脸型、肤色及穿衣风格的真人展示，降低适配判断压力'],
            ['材质与工艺证据', '镀层说明、尺寸对照、细节特写及长期佩戴反馈建立品质信任'],
            ['有代入感的成长故事', '用工作、生日、约会及人生变化让饰品与个人经历产生连接'],
            ['闺蜜口碑与审美型达人推荐', '朋友赠送、用户晒单及气质一致的穿搭达人推动购买']
          ]
        ],
        decisions: [
          {
            primary: [1], secondary: [0, 2],
            conclusion: 'AngelMyth面向18–35岁的成长型女性，核心成交人群为24–28岁。18–24岁构成入门与风格探索层，24–28岁承担核心成交，28–35岁承接品质升级与成熟审美。'
          },
          {
            primary: [0, 1, 2], secondary: [],
            conclusion: '购买动机由三股力量共同构成：饰品首先要让日常穿搭更完整，同时成为她表达成长与自主选择的随身印记，并在完成目标、度过低谷或进入新阶段时提供轻量但可见的情绪奖励。产品不能只讲造型，也不能只讲故事，而要同时回应实用、身份与情绪。'
          },
          {
            primary: [2, 3], secondary: [0, 1],
            conclusion: '最大的阻力是“是否适合我”与“为什么值得选它”：消费者面对大量相似款式时，既难判断上身适配，也缺少选择 AngelMyth 的明确理由。实物质感、褪色、过敏与耐用问题虽处于辅助层，却是完成成交所必需的基础信任门槛。'
          },
          {
            primary: [0], secondary: [1, 3],
            conclusion: '真实、多脸型、多场景的佩戴展示是最关键的成交触点，它直接回答“我戴起来会怎样”。材质工艺证据负责消除品质风险，闺蜜口碑、用户晒单与审美型达人推荐负责提供社会认同；三者应组合成“看见适配—确认品质—获得认同”的决策链。'
          }
        ]
      },
      {
        id: 'consumer-scenes',
        label: '消费场景探索',
        en: 'Consumption Scenes',
        summary: '研究消费者在什么情境下被品牌吸引、比较、下单、分享与复购。',
        purpose: '找到消费行为发生的真实上下文，让品牌在正确的时间、地点和情绪中出现。',
        prompts: [
          ['需求触发', '哪一个事件或情绪，让消费者开始寻找这类产品？'],
          ['发现与种草', '消费者在哪里第一次看到我们，什么内容让他停下来？'],
          ['购买决策', '线上与线下分别需要什么证据来完成成交？'],
          ['分享与复购', '什么体验值得被主动表达，并带来下一次购买？']
        ],
        choices: [
          [
            ['身份切换与焕新', '入学、初入职场、换工作或进入新阶段，希望呈现更成熟、更独立的自己'],
            ['自我奖励与情绪疗愈', '完成目标、经历压力或心情低落时，用一件首饰奖励和安慰自己'],
            ['穿搭缺少点睛之笔', '约会、通勤、聚会或拍照前，希望迅速提升精致感与辨识度'],
            ['纪念与关系表达', '生日、周年、节日或毕业时，为自己或重要的人寻找有寓意的礼物']
          ],
          [
            ['小红书穿搭与真实分享', '通过素人或穿搭博主的上身效果、搭配对比和真实体验被种草'],
            ['抖音情绪短片与故事内容', '通过女性成长、身份变化、约会或通勤场景的情绪故事被吸引'],
            ['淘宝天猫搜索与猜你喜欢', '搜索韩系项链、通勤耳环等关键词，被主图、款式和价格带吸引'],
            ['朋友佩戴与线下体验', '因朋友推荐、看到他人佩戴，或在线下试戴后产生兴趣']
          ],
          [
            ['材质工艺与品质可信', '线上看材质、工艺、质检与售后；线下通过触感、重量和做工确认品质'],
            ['真实上身与搭配效果', '线上需要不同脸型、肤色和穿搭实拍；线下需要试戴和搭配建议'],
            ['品牌故事与设计独特性', '理解设计寓意、原创元素，以及品牌与普通韩系饰品的差异'],
            ['口碑、价格与低风险保障', '通过销量评价、达人推荐、合理价格、退换货和过敏保障降低风险']
          ],
          [
            ['包装仪式感与开箱惊喜', '精致包装、祝福卡和适合拍照的开箱体验推动社交分享'],
            ['被夸赞与风格认同', '佩戴后获得称赞，并感到产品准确表达自己的个性与阶段状态'],
            ['系列收藏与持续上新', '通过可叠戴、可组合系列与主题新品推动连续购买'],
            ['会员关系与纪念服务', '通过生日礼、刻字、保养、换新及会员专属款形成长期关系']
          ]
        ],
        decisions: [
          {
            primary: [0, 2], secondary: [1, 3],
            conclusion: '消费需求首先由人生阶段切换与具体穿搭任务共同触发：消费者既想呈现新的身份，也需要在通勤、约会、聚会或拍照前快速完成造型。自我奖励和纪念赠礼则作为辅助动机，强化产品的情绪价值与关系价值。'
          },
          {
            primary: [0, 2], secondary: [1],
            conclusion: '品牌发现应形成“小红书内容种草—淘宝天猫承接搜索”的主路径：用真实上身、搭配对比和素人体验建立向往，再用精准关键词、清晰主图和价格带完成需求承接。抖音负责放大女性成长与场景情绪，承担品牌记忆建设。'
          },
          {
            primary: [1, 2], secondary: [0, 3],
            conclusion: '成交的核心证据不是单纯低价，而是“戴上是否适合我”与“设计是否值得选择”。线上需强化多脸型、多肤色、多场景实拍及设计故事；线下通过试戴和搭配建议完成确认。材质工艺、评价口碑、退换与防过敏保障负责降低最后的风险。'
          },
          {
            primary: [1], secondary: [],
            conclusion: '最值得分享和复购的核心体验，是佩戴后获得他人夸赞，同时感到首饰准确表达了自己的个性与当前人生状态。品牌应把“被看见、被认同”转化为晒单话题、用户故事与真实穿搭内容。'
          }
        ]
      },
      {
        id: 'product-scenes',
        label: '产品使用场景探索',
        en: 'Product Usage Scenes',
        summary: '把产品放回消费者的日常，观察它在不同时间、空间、搭配和任务中的真实作用。',
        purpose: '让每个产品都有明确的使用理由、场景价值和可被内容化的生活画面。',
        prompts: [
          ['核心使用时刻', '产品最常被使用的时间、地点与行为是什么？'],
          ['功能与情绪价值', '它解决什么实际问题，又带来怎样的心理感受？'],
          ['搭配关系', '产品如何与消费者已有物品、穿搭或空间共存？'],
          ['场景内容化', '哪些使用画面最适合转化为影像、文案和社交内容？']
        ],
        choices: [
          [
            ['日常通勤', '办公室、会议与城市移动中的高频佩戴'],
            ['约会聚会', '晚餐、约会、闺蜜聚会与轻社交'],
            ['周末休闲', '逛街、咖啡馆、展览与城市散步'],
            ['旅行度假', '酒店、海边、机场与旅途记录'],
            ['重要仪式', '生日、纪念日、婚礼与庆祝时刻'],
            ['居家独处', '梳妆、试戴、整理与自我欣赏'],
            ['职场身份切换', '面试、提案、晋升或重要会面时强化专业形象'],
            ['下班场景转换', '从办公室直接进入晚餐、约会或社交场合'],
            ['节日主题穿搭', '情人节、圣诞、新年及品牌主题活动中的限定表达'],
            ['拍照与内容创作', '自拍、探店、直播及社交平台发布时形成视觉亮点']
          ],
          [
            ['快速提亮造型', '基础穿搭无需重做，也能形成视觉重点'],
            ['一饰多用', '单戴、叠戴或组合，适应不同场合'],
            ['提升精致感', '让日常状态更完整、更有秩序'],
            ['表达个人风格', '在甜美、冷感、优雅或酷感间自由选择'],
            ['增强自信与仪式感', '佩戴动作帮助进入理想状态'],
            ['承载记忆与关系', '作为自购纪念或闺蜜赠礼保存情感'],
            ['修饰脸型与比例', '通过长度、体积与视觉重心优化脸型和颈部比例'],
            ['降低搭配难度', '提供成套关系和明确建议，减少每天选择的时间成本'],
            ['获得品质安全感', '舒适、不过敏、耐用，让高频佩戴更安心'],
            ['获得他人认同', '通过被注意、被称赞确认自己的审美与状态']
          ],
          [
            ['基础衣橱', '白衬衫、针织衫、T恤、西装与牛仔'],
            ['同系列叠戴', '项链、耳饰、戒指和手链成组使用'],
            ['跨风格混搭', '甜酷、运动、通勤、派对之间切换'],
            ['与包鞋呼应', '用金属色、珍珠或色彩连接配件'],
            ['与妆发呼应', '根据发型、领口与妆容调整视觉重心'],
            ['新旧首饰共存', '与消费者已有基础款组合而非替换'],
            ['不同领口适配', '根据圆领、V领、衬衫及露肩款调整项链结构'],
            ['不同脸型适配', '用耳饰长度、轮廓与体量对应不同脸型'],
            ['金银双色组合', '允许冷暖金属色共同出现，适配更多衣橱和肤色'],
            ['可拆卸组件变化', '通过吊坠、链条和耳饰组件拆装形成多种戴法']
          ],
          [
            ['晨间出门准备', '梳妆台试戴、镜前选择与状态切换'],
            ['通勤一日记录', '从地铁、办公桌到下班约会的连续场景'],
            ['一件多搭挑战', '同一件首饰完成三至五套造型'],
            ['细节特写', '展示光泽、材质、镶嵌和佩戴动作'],
            ['关系型故事', '闺蜜互赠、自购纪念与重要时刻'],
            ['城市生活短片', '咖啡馆、展览、夜晚与旅行的真实片段'],
            ['不同脸型实戴', '同一款由不同脸型、肤色和风格的女性真实展示'],
            ['材质耐用实验', '用防水、耐磨、过敏测试与长期佩戴记录建立信任'],
            ['系列叠戴教程', '用步骤化内容展示单戴、双层和完整套组的变化'],
            ['成长阶段故事', '围绕毕业、入职、晋升、生日与重新出发形成连续叙事']
          ]
        ],
        decisions: [
          {
            selected: [0, 1, 2, 3, 4, 6, 7, 8],
            conclusion: '产品需要覆盖从高频日常到阶段性仪式的完整生活节奏。日常通勤、约会聚会与周末休闲构成基础使用盘；旅行度假、重要仪式和节日主题负责放大情绪与记忆价值；职场身份切换及下班后的场景转换，则要求产品兼顾专业感、精致感和快速改变造型语气的能力。'
          },
          {
            selected: [0, 1, 2, 4, 7, 9],
            conclusion: '产品的核心价值应建立在“容易使用且能带来状态变化”之上：快速提亮基础造型，通过单戴、叠戴和组合实现一饰多用，并降低每天的搭配难度。在此基础上，精致感、佩戴仪式与他人称赞共同帮助消费者确认自己的状态和审美。'
          },
          {
            selected: [0, 1, 2, 3, 4, 6, 7],
            conclusion: '搭配系统应从消费者已有衣橱出发，而不是要求她重新购买整套造型。产品既要适配基础服装、不同领口、脸型和妆发，也要支持同系列叠戴、跨风格混搭以及与包鞋等配件的呼应，由此形成可理解、可复用的场景化组合方法。'
          },
          {
            selected: [0, 1, 2, 3, 4, 5, 6, 8, 9],
            conclusion: '内容应形成“真实生活—搭配教学—品质细节—成长叙事”四层结构：以晨间准备、通勤、约会和城市生活建立代入感；以一件多搭、叠戴教程和不同脸型实戴解决选择问题；以材质与佩戴动作特写建立质感；再通过闺蜜关系与人生阶段故事沉淀品牌情感。'
          }
        ]
      },
      {
        id: 'visual-system',
        label: '品牌视觉识别与产品应用系统',
        en: 'Visual Identity & Product Application',
        summary: '建立从 Slogan、Logo、图形标识到产品载体的统一识别规则，让消费者在没有解释时也能快速认出 AngelMyth。',
        purpose: '把品牌视觉从“好看的图形”变成一套稳定、可复制、能在产品上形成记忆的识别机制。',
        prompts: [
          ['品牌 Slogan', '用一句话表达品牌精神，并适配传播与产品露出。'],
          ['Logo 标识系统', '定义主标、缩写标、最小尺寸与安全空间。'],
          ['品牌图形资产', '建立超级符号、辅助图形、纹样与图形标签。'],
          ['产品应用规范', '明确吊牌、包装、织标、五金、印花等载体的使用逻辑。']
        ]
      },
      {
        id: 'pricing',
        label: '品牌价格体系模型',
        en: 'Pricing Architecture',
        summary: '依据消费者认知、产品角色与渠道结构，搭建清晰且可持续的价格梯度。',
        purpose: '让入门、核心、形象与限量产品各自承担明确任务，避免价格互相冲突。',
        prompts: [
          ['价格带地图', '目标市场的主流、机会与天花板价格分别在哪里？'],
          ['产品价格梯度', '入门款、核心款、形象款与限量款如何分层？'],
          ['价格锚点', '用什么代表性产品建立消费者对品牌价值的判断？'],
          ['折扣边界', '促销、会员与渠道价格如何保持品牌一致性？']
        ]
      },
      {
        id: 'channel-plan',
        label: '品牌渠道布局规划',
        en: 'Channel Launch Plan',
        summary: '按照品牌启动、产品完善与规模扩张三个阶段安排渠道进入顺序，让内容声量、站外流量与站内成交形成清晰闭环。',
        purpose: '明确小红书、抖音、天猫、得物与京东各自承担的推广、转化和品牌背书职责，避免新品牌在初期分散资源。'
      },
      {
        id: 'profit',
        label: '品牌利润模型搭建',
        en: 'Profit Model',
        summary: '按天猫、抖音与得物分别搭建可编辑的费用预算和利润测算模型，让每一次费用调整都能即时看到利润结果。',
        purpose: '统一核算产品、包装、履约、平台、推广、税费和库存成本，为渠道预算与售价决策提供实时数字依据。'
      },
      {
        id: 'materials',
        label: '品牌材质框架选择',
        en: 'Material Framework',
        summary: '用材质建立产品质感、价格感和品牌辨识度，并形成可持续迭代的材料资料库。',
        purpose: '让材料选择同时回应品牌价值、使用体验、供应稳定性和目标成本。',
        prompts: [
          ['核心材质语言', '哪些触感、光泽、重量和结构最能代表品牌？'],
          ['材质等级', '基础、核心与高阶材料如何对应产品价格层级？'],
          ['供应与质量标准', '交期、起订量、色牢度、耐用性等关键门槛。'],
          ['创新与可持续', '哪些新材料或工艺能形成下一阶段竞争优势？']
        ]
      },
      {
        id: 'annual-plan',
        label: '品牌年度上行计划',
        en: 'Annual Growth Plan',
        summary: '把品牌目标拆解为季度主题、产品节奏、内容战役、渠道动作与复盘指标。',
        purpose: '形成一张可执行的年度增长路线图，让品牌建设与销售结果相互支持。',
        prompts: [
          ['年度核心目标', '今年最重要的品牌认知与商业结果是什么？'],
          ['季度增长主题', '每个季度要解决的关键问题与阶段任务。'],
          ['产品与内容节奏', '上新、营销事件和内容栏目如何协同？'],
          ['衡量与复盘', '用哪些领先指标和结果指标判断计划有效？']
        ]
      },
      {
        id: 'product-launch',
        label: '产品开发企划分解',
        en: 'Product Launch Plan',
        summary: '按每一批产品的上架时间，持续建立可编辑、可复制和可复盘的产品开发企划分解。',
        purpose: '把年龄段、使用场景、系列主题与具体款式逐层拆解，形成长期积累的产品开发企划分解库。'
      },
      {
        id: 'style-hit-pool',
        label: 'AngelMyth 各风格爆款池',
        en: 'Style Bestseller Pool',
        summary: '按六种韩系核心风格持续沉淀市场爆款、竞品款式与改款灵感，建立可长期扩充的产品图片资料库。',
        purpose: '让设计师按照统一风格入口持续收集、浏览和调用参考款，为选款、改款、系列规划与市场复盘提供稳定依据。'
      }
    ];

    const navList = document.getElementById('navList');
    const pageContent = document.getElementById('pageContent');
    const breadcrumb = document.getElementById('breadcrumb');
    const sidebar = document.getElementById('sidebar');
    const backdrop = document.getElementById('backdrop');
    const menuBtn = document.getElementById('menuBtn');
    const accountBtn = document.getElementById('accountBtn');
    const toast = document.getElementById('toast');
    const launchModalBackdrop = document.getElementById('launchModalBackdrop');
    const launchModalBody = document.getElementById('launchModalBody');
    const launchModalTitle = document.getElementById('launchModalTitle');
    const launchCloseBtn = document.getElementById('launchCloseBtn');
    const launchCancelBtn = document.getElementById('launchCancelBtn');
    const launchSaveBtn = document.getElementById('launchSaveBtn');
    const launchImageLightbox = document.getElementById('launchImageLightbox');
    const launchLightboxImage = document.getElementById('launchLightboxImage');
    const launchLightboxLabel = document.getElementById('launchLightboxLabel');
    const launchLightboxCount = document.getElementById('launchLightboxCount');
    const launchLightboxClose = document.getElementById('launchLightboxClose');
    const launchLightboxPrev = document.getElementById('launchLightboxPrev');
    const launchLightboxNext = document.getElementById('launchLightboxNext');
    let launchLightboxState = { images:[], index:0, label:'' };
    const storageKey = 'angelmyth-plan-v01';
    const legacyStorageKey = 'andrewmatch-plan-v01';
    const appUser = typeof currentUser === 'undefined'
      ? { id:'angelmyth-creator', username:'angelmyth01', displayName:'AngelMyth 创建者', role:'admin' }
      : currentUser;
    const canManageStylePool = appUser.role === 'admin'
      || appUser.role === 'creator'
      || appUser.username === 'angelmyth01'
      || appUser.id === 'angelmyth-creator';
    const canManageLaunchPlans = canManageStylePool;
    const isReadOnlyUser = appUser.role === 'viewer' || appUser.role === 'readonly';
    stateClient.setCurrentUser(appUser.id, appUser.role);
    const appLaunchPlanClient = typeof launchPlanClient === 'undefined' ? createBrowserLaunchPlanClient() : launchPlanClient;
    const appApi = typeof api === 'undefined' ? null : api;
    stateClient.setStatusHandler((message, kind) => { toast.textContent = message; toast.classList.add('show'); toast.dataset.kind = kind; clearTimeout(saveState.timer); saveState.timer = setTimeout(() => { toast.classList.remove('show'); delete toast.dataset.kind; }, kind === 'error' ? 4000 : 1800); });
    let state = await stateClient.initialize();
    let currentId = location.hash.slice(1) || 'home';
    let launchDraft = null;
    let editingLaunchId = null;
    let launchDraftBaseline = '';
    let launchDraftTimer = null;
    let launchActivePasteTarget = '';
    let launchHoveredPasteTarget = '';
      let launchPlansLoaded = false;
    let launchPresenceTimer = null;
    let launchPresencePlanId = '';
    let launchPresencePath = '*';
    let launchAutoSaveTimer = null;
    let launchSaveRunner = null;
    let launchSaveRequested = false;
    let launchSaveCloseRequested = false;
    let launchSaveInteractiveRequested = false;
    let launchSaveRetryTimer = null;
    let launchTextCompositionActive = false;
    let launchRenderQueued = false;
    // UI-only state: keep long scenes and themes compact while editing without changing saved plan data.
    const launchCollapsedSceneIds = new Set();
    const launchCollapsedThemeIds = new Set();
    const stylePoolDefinitions = [
      { key:'korean-luxury-heiress', title:'韩国奢华千金风格', desc:'华丽精致、璀璨珠宝感、重工镶嵌与宴会礼服氛围。' },
      { key:'heiress', title:'韩系小千金风格', desc:'甜美精致、轻礼服感、珍珠与璀璨细节。' },
      { key:'fresh', title:'韩系小清新风格', desc:'轻盈自然、年轻日常、清透色彩与小体量图形。' },
      { key:'commuter', title:'韩系精致通勤风格', desc:'简约克制、精致金属感、适合办公室与城市日常。' },
      { key:'cool', title:'韩系冷感大女主风格', desc:'利落力量、冷调金属、不对称与锐利几何结构。' },
      { key:'romantic', title:'韩系浪漫风格', desc:'柔美情绪、约会与礼赠场景、花卉与流动线条。' },
      { key:'urban-luxury', title:'韩系都市优雅轻奢风格', desc:'成熟优雅、质感升级、适合职场与品质社交场景。' }
    ];
    const stylePoolData = Object.fromEntries(stylePoolDefinitions.map(item => [item.key, { images:[], page:0, total:0, hasMore:true, loaded:false }]));
    const ajidouPoolData = { images:[], page:0, total:0, hasMore:false, loaded:false };
    // Global scene vocabulary used by every style segment and every new launch plan.
    // Keys include the parent group so duplicate occasions (for example 高级餐厅)
    // remain independently selectable while the saved display stays readable.
    const launchSceneOptions = [
      { core:'高质感社交与重要约会', occasions:['商务晚宴','品牌活动','酒店下午茶','高级餐厅','重要约会','闺蜜庆祝','宴会'] },
      { core:'职场与城市日常', occasions:['写字楼通勤','会议','客户拜访','商务午餐','办公室日常','下班约会'] },
      { core:'校园与轻松日常', occasions:['图书馆','上课','咖啡店','校园散步','画画','音乐练习','周末逛街'] },
      { core:'夜间社交与自我表达', occasions:['酒吧','Livehouse','KTV','夜店','音乐节','派对','街头拍摄','独处夜游'] },
      { core:'恋爱、约会与情绪化生活', occasions:['校园初恋约会','公园散步','花店','艺术展','电影约会','纪念日','旅行'] },
      { core:'成熟女性的品质生活', occasions:['高级餐厅','剧院','展览','商务社交','精品店','城市旅行','朋友聚会'] }
    ];
    const launchSceneKey = (core, occasion) => `${core}::${occasion}`;
    const launchSceneOptionMap = new Map(launchSceneOptions.flatMap(group => group.occasions.map(occasion => [launchSceneKey(group.core, occasion), { ...group, occasion }])));
    function launchSceneSelectionSummary(scene = {}) {
      const selected = Array.isArray(scene.sceneSelections) ? scene.sceneSelections : [];
      const groups = new Map();
      selected.forEach(key => {
        const option = launchSceneOptionMap.get(key);
        if (!option) return;
        if (!groups.has(option.core)) groups.set(option.core, []);
        groups.get(option.core).push(option.occasion);
      });
      return [...groups.entries()].map(([core, occasions]) => `${core}：${occasions.join('、')}`).join('；');
    }
    function launchSceneDisplayName(scene = {}) {
      const summary = launchSceneSelectionSummary(scene);
      const custom = typeof scene.sceneNameCustom === 'string' ? scene.sceneNameCustom.trim() : '';
      return [summary, custom].filter(Boolean).join(summary && custom ? '｜' : '');
    }
    function normalizeLaunchScene(scene = {}) {
      const normalized = { id:createId('scene'), name:'', sceneSelections:[], sceneNameCustom:'', themes:[], ...scene, id:scene.id || createId('scene') };
      normalized.sceneSelections = Array.isArray(scene.sceneSelections) ? scene.sceneSelections.filter(key => launchSceneOptionMap.has(key)) : [];
      normalized.sceneNameCustom = typeof scene.sceneNameCustom === 'string'
        ? scene.sceneNameCustom
        : normalized.sceneSelections.length ? '' : (typeof scene.name === 'string' ? scene.name : '');
      normalized.name = launchSceneDisplayName(normalized) || (typeof scene.name === 'string' ? scene.name : '');
      normalized.themes = Array.isArray(scene.themes) ? scene.themes.map(normalizeLaunchTheme) : [];
      return normalized;
    }
    accountBtn.textContent = appUser.displayName;

    function saveState() {
      stateClient.scheduleSave(state);
      toast.textContent = '正在保存…';
      toast.classList.add('show');
      return true;
    }

    function createBrowserLaunchPlanClient() {
      const databaseName = 'angelmyth-local-launch-plans-v1';
      const storeName = 'plans';
      const decorate = data => ({
        ...data,
        _collaboration:{
          ...(data._collaboration || {}),
          createdBy:data._collaboration?.createdBy || 'local-user',
          creatorName:data._collaboration?.creatorName || '本机用户',
          updatedAt:data.updatedAt || new Date().toISOString(),
          canCreate:canManageLaunchPlans,
          canDelete:canManageLaunchPlans
        }
      });
      const openDatabase = () => new Promise((resolve, reject) => {
        const request = indexedDB.open(databaseName, 1);
        request.onupgradeneeded = () => {
          if (!request.result.objectStoreNames.contains(storeName)) request.result.createObjectStore(storeName, { keyPath:'id' });
        };
        request.onsuccess = () => resolve(request.result);
        request.onerror = () => reject(request.error);
      });
      const getAll = async () => {
        const database = await openDatabase();
        return new Promise((resolve, reject) => {
          const request = database.transaction(storeName, 'readonly').objectStore(storeName).getAll();
          request.onsuccess = () => resolve(request.result || []);
          request.onerror = () => reject(request.error);
        });
      };
      const put = async data => {
        const database = await openDatabase();
        return new Promise((resolve, reject) => {
          const request = database.transaction(storeName, 'readwrite').objectStore(storeName).put(data);
          request.onsuccess = () => resolve();
          request.onerror = () => reject(request.error);
        });
      };
      const remove = async id => {
        const database = await openDatabase();
        return new Promise((resolve, reject) => {
          const request = database.transaction(storeName, 'readwrite').objectStore(storeName).delete(id);
          request.onsuccess = () => resolve();
          request.onerror = () => reject(request.error);
        });
      };
      return {
        async list() {
          const stored = await getAll();
          if (stored.length) return stored.map(decorate);
          const legacyPlans = Array.isArray(state.productLaunchPlans) ? state.productLaunchPlans : [];
          for (const plan of legacyPlans) await put(plan);
          return legacyPlans.map(decorate);
        },
        async save(data) {
          await put(data);
          return { data:decorate(data), autoMerged:false, savedOffline:true };
        },
        async duplicate(data) { await put(data); return decorate(data); },
        async remove(id) { await remove(id); },
        async heartbeat() {},
        async activeEditors() { return []; },
        async clearPresence() {}
      };
    }

    function createId(prefix = 'item') {
      return `${prefix}-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 8)}`;
    }

    function emptyLaunchStyle() {
      return { id:createId('style'), name:'', productLevel:'', category:'', style:'', elements:'', theme:'', material:'', plannedPrice:'', actualPrice:'', outfit:'', description:'' };
    }

    function emptyBasicProduct() {
      return {
        ...emptyLaunchStyle(), id:createId('basic'), designer:'', images:[], referenceImages:[], referenceImageDetails:[], wearImages:[], personaImages:[], plannedRetailPrice:'',
        referenceBrand:'', plannedMaterial:'', plannedCraft:'', plannedElements:'', adaptationDirection:'', personaProfile:''
      };
    }

    function emptyFeaturedProduct() {
      return { id:createId('featured'), image:'', brief:'' };
    }

    function emptyLaunchTheme() {
      return {
        id:createId('theme'), name:'', referenceImages:[], referenceImageDetails:[], wearImages:[], extensionReferenceImages:[], designer:'', rationale:'', extensionPlan:'', plannedCount:'', priceBand:'', materials:'', crafts:'', elements:'', direction:'', finalImages:[], styles:[],
        advice:{ heroShoot:'', detailVisual:'', heroShootImages:[], detailVisualImages:[], onsitePromotion:'', offsitePromotion:'', influencerProfile:'', faceProfile:'', influencerImages:[], faceImages:[], referenceProductUrl:'' }
      };
    }

    function normalizeLaunchStyle(style = {}) {
      return { ...emptyLaunchStyle(), ...style, id:style.id || createId('style') };
    }

    function normalizeBasicProduct(product = {}) {
      const normalized = { ...emptyBasicProduct(), ...product, id:product.id || createId('basic') };
      normalized.images = Array.isArray(product.images) ? product.images : [];
      normalized.referenceImages = Array.isArray(product.referenceImages) ? product.referenceImages : [];
      normalized.referenceImageDetails = Array.isArray(product.referenceImageDetails) ? product.referenceImageDetails : [];
      normalized.wearImages = Array.isArray(product.wearImages) ? product.wearImages : [];
      normalized.personaImages = Array.isArray(product.personaImages) ? product.personaImages : [];
      return normalized;
    }

    function normalizeFeaturedProduct(product = {}) {
      const normalized = { ...emptyFeaturedProduct(), ...product, id:product.id || createId('featured') };
      normalized.image = typeof product.image === 'string' ? product.image : '';
      normalized.brief = typeof product.brief === 'string' ? product.brief : '';
      return normalized;
    }

    function normalizeLaunchTheme(theme = {}) {
      const normalized = { ...emptyLaunchTheme(), ...theme, id:theme.id || createId('theme') };
      normalized.referenceImages = Array.isArray(theme.referenceImages) ? theme.referenceImages : [];
      normalized.referenceImageDetails = Array.isArray(theme.referenceImageDetails) ? theme.referenceImageDetails : [];
      normalized.wearImages = Array.isArray(theme.wearImages) ? theme.wearImages : [];
      normalized.extensionReferenceImages = Array.isArray(theme.extensionReferenceImages) ? theme.extensionReferenceImages : [];
      normalized.finalImages = Array.isArray(theme.finalImages) ? theme.finalImages : [];
      // Keep the per-theme development records aligned with the 50-SKU image
      // capacity. Older plans may contain more rows, but the editor and
      // reports intentionally use the same bounded maximum.
      normalized.styles = Array.isArray(theme.styles) ? theme.styles.slice(0, 50).map(normalizeLaunchStyle) : [];
      normalized.advice = { ...emptyLaunchTheme().advice, ...(theme.advice || {}) };
      normalized.advice.heroShootImages = Array.isArray(theme.advice?.heroShootImages) ? theme.advice.heroShootImages : [];
      normalized.advice.detailVisualImages = Array.isArray(theme.advice?.detailVisualImages) ? theme.advice.detailVisualImages : [];
      normalized.advice.influencerImages = Array.isArray(theme.advice?.influencerImages) ? theme.advice.influencerImages : [];
      normalized.advice.faceImages = Array.isArray(theme.advice?.faceImages) ? theme.advice.faceImages : [];
      return normalized;
    }

    const competitorReferenceDefinitions = [
      { id:'heiress', title:'韩系小千金风' },
      { id:'commuter', title:'韩系精致通勤风格' },
      { id:'fresh', title:'韩系小清新风格' },
      { id:'cool', title:'韩系冷感大女主风格' }
    ];

    function emptyCompetitorReferenceGroups() {
      return competitorReferenceDefinitions.map(group => ({ ...group, brand:'', images:[] }));
    }

    function normalizeCompetitorReferenceGroups(plan = {}) {
      const storedGroups = Array.isArray(plan.competitorReferenceGroups) ? plan.competitorReferenceGroups : [];
      const legacyImages = Array.isArray(plan.cycleReferenceImages) ? plan.cycleReferenceImages : [];
      return competitorReferenceDefinitions.map((definition, groupIndex) => {
        const stored = storedGroups.find(group => group?.id === definition.id) || storedGroups[groupIndex] || {};
        const migratedImages = storedGroups.length ? [] : legacyImages.slice(groupIndex * 30, (groupIndex + 1) * 30);
        return {
          ...stored,
          id:definition.id,
          title:typeof stored.title === 'string' ? stored.title : definition.title,
          brand:typeof stored.brand === 'string' ? stored.brand : '',
          images:(Array.isArray(stored.images) ? stored.images : migratedImages).slice(0, 30)
        };
      });
    }

    function flattenCompetitorReferenceImages(plan) {
      return (plan?.competitorReferenceGroups || []).flatMap(group => Array.isArray(group?.images) ? group.images : []);
    }

    function emptyAssortmentMatrix() {
      return {
        categories:Array.from({ length:5 }, () => ''),
        rows:Array.from({ length:5 }, () => ({ style:'', quantities:Array.from({ length:5 }, () => ''), priceRange:'', elements:'' }))
      };
    }

    function normalizeAssortmentMatrix(value) {
      const source = value && typeof value === 'object' ? value : {};
      const categories = Array.from({ length:5 }, (_, index) => typeof source.categories?.[index] === 'string' ? source.categories[index] : '');
      const rows = Array.from({ length:5 }, (_, rowIndex) => {
        const row = source.rows?.[rowIndex] || {};
        return {
          style:typeof row.style === 'string' ? row.style : '',
          quantities:Array.from({ length:5 }, (_, columnIndex) => typeof row.quantities?.[columnIndex] === 'string' || typeof row.quantities?.[columnIndex] === 'number' ? String(row.quantities[columnIndex]) : ''),
          priceRange:typeof row.priceRange === 'string' ? row.priceRange : '',
          elements:typeof row.elements === 'string' ? row.elements : ''
        };
      });
      return { categories, rows };
    }

    function normalizeLaunchPlan(plan) {
      const normalized = {
        importanceLevel:'', importanceReason:'', cyclePlan:'', ajidouReferenceImages:[], cycleReferenceImages:[], competitorReferenceGroups:[],
        accentColorAnalysisImages:[], baseColorAnalysisImages:[], accentColorAnalysisNote:'', baseColorAnalysisNote:'',
        homepageFeaturedProducts:[], offsiteFeaturedProducts:[],
        cycleStart:'', cycleEnd:'', planningStart:'', planningEnd:'', designStart:'', designEnd:'',
        samplingStart:'', samplingEnd:'', bulkProductionStart:'', bulkProductionEnd:'',
        packagingProductionStart:'', packagingProductionEnd:'', visualDesignStart:'', visualDesignEnd:'',
        promotionStart:'', promotionEnd:'',
        shelvingStart:'', shelvingEnd:'',
        assortmentMatrix:emptyAssortmentMatrix(),
        stylePlanVersion:2,
        ...plan
      };
      normalized.ajidouReferenceImages = Array.isArray(plan.ajidouReferenceImages) ? plan.ajidouReferenceImages : [];
      normalized.accentColorAnalysisImages = Array.isArray(plan.accentColorAnalysisImages) ? plan.accentColorAnalysisImages.slice(0, 5) : [];
      normalized.baseColorAnalysisImages = Array.isArray(plan.baseColorAnalysisImages) ? plan.baseColorAnalysisImages.slice(0, 5) : [];
      normalized.accentColorAnalysisNote = typeof plan.accentColorAnalysisNote === 'string' ? plan.accentColorAnalysisNote : '';
      normalized.baseColorAnalysisNote = typeof plan.baseColorAnalysisNote === 'string' ? plan.baseColorAnalysisNote : '';
      normalized.competitorReferenceGroups = normalizeCompetitorReferenceGroups(plan);
      normalized.cycleReferenceImages = flattenCompetitorReferenceImages(normalized);
      normalized.assortmentMatrix = normalizeAssortmentMatrix(plan.assortmentMatrix);
      normalized.basicProducts = Array.isArray(plan.basicProducts) ? plan.basicProducts.map(normalizeBasicProduct) : [];
      normalized.subwaveBasicProducts = Array.isArray(plan.subwaveBasicProducts) ? plan.subwaveBasicProducts.map(normalizeBasicProduct) : [];
      normalized.homepageFeaturedProducts = Array.isArray(plan.homepageFeaturedProducts) ? plan.homepageFeaturedProducts.slice(0, 6).map(normalizeFeaturedProduct) : [];
      normalized.offsiteFeaturedProducts = Array.isArray(plan.offsiteFeaturedProducts) ? plan.offsiteFeaturedProducts.slice(0, 10).map(normalizeFeaturedProduct) : [];
      const styleSegmentLabels = ['韩式奢华千金风', '韩式精致通勤风格', '韩式小清新 / 小千金风格', '韩系冷感大女主风格'];
      const sourceSegments = Array.isArray(plan.segments) ? plan.segments : [];
      const segments = Array.from({ length:4 }, (_, segmentIndex) => {
        const segment = sourceSegments[segmentIndex] || { id:createId('segment'), scenes:[] };
        return {
          ...segment,
          label:styleSegmentLabels[segmentIndex],
          scenes:(segment.scenes || []).map(normalizeLaunchScene)
        };
      });
      if ((Number(plan.stylePlanVersion) || 0) < 2 && normalized.basicProducts.length) {
        const migratedScenes = normalized.basicProducts.map((product, productIndex) => {
          const style = { ...emptyLaunchStyle(), ...product, id:createId('style'), name:product.name || `历史产品 ${productIndex + 1}`, designer:product.referenceBrand || '' };
          const theme = { ...emptyLaunchTheme(), id:createId('theme'), name:`${product.name || `历史产品 ${productIndex + 1}`} · 待整理主题`, referenceImages:[...(product.referenceImages || [])], finalImages:[...(product.images || [])], designer:product.referenceBrand || '', materials:product.plannedMaterial || '', crafts:product.plannedCraft || '', priceBand:product.plannedPrice || '', elements:product.plannedElements || '', direction:product.adaptationDirection || '', styles:[style] };
          theme.advice.faceImages = [...(product.personaImages || [])];
          theme.advice.faceProfile = product.personaProfile || '';
          return { id:createId('scene'), name:`待整理场景 ${String(productIndex + 1).padStart(2, '0')}`, themes:[theme] };
        });
        segments[3].scenes = [...segments[3].scenes, ...migratedScenes];
        normalized.basicProducts = [];
      }
      normalized.stylePlanVersion = 2;
      normalized.segments = segments;
      return normalized;
    }

    function emptyLaunchPlan() {
      return {
        id: createId('launch'),
        name: '',
        importanceLevel: '',
        importanceReason: '',
        launchDate: '',
        cycleStart: '',
        cycleEnd: '',
        planningStart: '',
        planningEnd: '',
        designStart: '',
        designEnd: '',
        samplingStart: '',
        samplingEnd: '',
        bulkProductionStart: '',
        bulkProductionEnd: '',
        packagingProductionStart: '',
        packagingProductionEnd: '',
        visualDesignStart: '',
        visualDesignEnd: '',
        promotionStart: '',
        promotionEnd: '',
        shelvingStart: '',
        shelvingEnd: '',
        cyclePlan: '',
        assortmentMatrix: emptyAssortmentMatrix(),
        stylePlanVersion:2,
        ajidouReferenceImages: [],
        cycleReferenceImages: [],
        competitorReferenceGroups: emptyCompetitorReferenceGroups(),
        accentColorAnalysisImages: [],
        baseColorAnalysisImages: [],
        accentColorAnalysisNote: '',
        baseColorAnalysisNote: '',
        homepageFeaturedProducts: [],
        offsiteFeaturedProducts: [],
        basicProducts: [],
        subwaveBasicProducts: [],
        createdAt: new Date().toISOString(),
        updatedAt: new Date().toISOString(),
        segments: [
          { id: 'young', label: '韩式奢华千金风', scenes: [] },
          { id: 'core', label: '韩式精致通勤风格', scenes: [] },
          { id: 'mature', label: '韩式小清新 / 小千金风格', scenes: [] },
          { id: 'cool', label: '韩系冷感大女主风格', scenes: [] }
        ]
      };
    }

    function getLaunchPlans() {
      state.productLaunchPlans ||= [];
      state.productLaunchPlans = state.productLaunchPlans.map(normalizeLaunchPlan);
      return state.productLaunchPlans;
    }

    async function refreshLaunchPlans(force = false) {
      if (launchPlansLoaded && !force) return;
      try {
        state.productLaunchPlans = (await appLaunchPlanClient.list()).map(normalizeLaunchPlan);
        launchPlansLoaded = true;
      } catch (error) {
        toast.textContent = error.message || '团队开发计划加载失败，请稍后重试';
        toast.classList.add('show');
      }
    }

    function cloneLaunchPlan(plan) {
      const clone = JSON.parse(JSON.stringify(plan));
      delete clone._collaboration;
      delete clone.createdBy;
      delete clone.creatorName;
      clone.id = createId('launch');
      clone.name = `${plan.name || '产品开发计划'}（副本）`;
      clone.createdAt = new Date().toISOString();
      clone.updatedAt = clone.createdAt;
      clone.segments.forEach(segment => {
        delete segment.createdBy;
        delete segment.creatorName;
        segment.scenes.forEach(scene => {
          scene.id = createId('scene');
          delete scene.createdBy;
          delete scene.creatorName;
          scene.themes.forEach(theme => {
            theme.id = createId('theme');
            delete theme.createdBy;
            delete theme.creatorName;
            theme.styles.forEach(style => { style.id = createId('style'); delete style.createdBy; delete style.creatorName; });
          });
        });
      });
      (clone.basicProducts || []).forEach(product => {
        product.id = createId('basic');
        delete product.createdBy;
        delete product.creatorName;
      });
      (clone.subwaveBasicProducts || []).forEach(product => {
        product.id = createId('basic');
        delete product.createdBy;
        delete product.creatorName;
      });
      (clone.homepageFeaturedProducts || []).forEach(product => { product.id = createId('featured'); });
      (clone.offsiteFeaturedProducts || []).forEach(product => { product.id = createId('featured'); });
      (clone.competitorReferenceGroups || []).forEach(group => {
        delete group.createdBy;
        delete group.creatorName;
      });
      return clone;
    }

    function launchPlanCounts(plan, segment) {
      const scenes = segment.scenes.length;
      const themes = segment.scenes.reduce((sum, scene) => sum + scene.themes.length, 0);
      const styles = segment.scenes.reduce((sum, scene) => sum + scene.themes.reduce((themeSum, theme) => themeSum + theme.styles.length, 0), 0);
      return { scenes, themes, styles };
    }

    const launchImportanceLevels = {
      S: { name:'战役级波段', desc:'品牌首发、双11、三八节等必须打赢的核心战役' },
      A: { name:'重点波段', desc:'承担季度增长、新品主推或关键场景占位' },
      B: { name:'常规波段', desc:'稳定上新节奏，承接日常销售与内容需求' },
      C: { name:'补充波段', desc:'小规模测试、补货或局部风格验证' }
    };

    function launchImportanceBadge(plan) {
      const level = launchImportanceLevels[plan.importanceLevel] ? plan.importanceLevel : '';
      if (!level) return '<span class="launch-priority-badge level-empty">波段未定级</span>';
      const meta = launchImportanceLevels[level];
      const shortName = meta.name.replace('波段', '');
      return `<span class="launch-priority-emblem level-${level.toLowerCase()}" role="img" aria-label="${level}级 · ${escapeHtml(meta.name)}" title="${level}级 · ${escapeHtml(meta.name)}"><span class="launch-priority-letter-stack" data-letter="${level}"><span class="launch-priority-letter">${level}</span></span><span class="launch-priority-emblem-caption">${escapeHtml(shortName)}</span></span>`;
    }

    function productLaunchTemplate(section, index) {
      const plans = getLaunchPlans().slice().sort((a, b) => (b.launchDate || '').localeCompare(a.launchDate || '') || (b.updatedAt || '').localeCompare(a.updatedAt || ''));
      return `
        <section>
          <div class="segment-strip" aria-hidden="true"><span class="young"></span><span class="core"></span><span class="mature"></span></div>
          <div class="launch-page-head">
            <div class="chapter-head">
              <div><div class="chapter-no">Chapter ${String(index).padStart(2, '0')} / ${section.en}</div><h1 class="chapter-title">${section.label}</h1></div>
              <p class="chapter-summary">${section.summary}</p>
            </div>
            ${canManageLaunchPlans ? '<button class="launch-create-btn" type="button" data-launch-new>＋ 新建产品开发计划</button>' : '<span class="launch-subtle-badge launch-plan-readonly-note">仅创建者或管理员可以新建上市计划</span>'}
          </div>
          <div class="chapter-purpose"><div class="purpose-label">计划库 / Planning</div><div class="purpose-text">${section.purpose}</div></div>
          <section class="launch-remix-board" aria-labelledby="launch-remix-title">
            <div class="launch-remix-head">
              <div><div class="launch-remix-kicker">Fixed product adaptation framework</div><h2 class="launch-remix-title" id="launch-remix-title">AngelMyth「3＋1」改款法与 A/B/C 改款等级</h2></div>
              <div class="launch-remix-formula">3 个市场参考输入 ＋ 1 个品牌识别点 ＝ 1 个改款方案</div>
            </div>
            <div class="launch-remix-section">
              <div class="launch-remix-section-head"><strong>3＋1 改款法</strong><span>先拆解市场成功逻辑，再完成 AngelMyth 品牌化表达</span></div>
              <div class="launch-remix-inputs">
                <article class="launch-remix-card tone-a"><div class="launch-remix-card-head"><span class="launch-remix-mark">A</span><h3>主母款 / 市场验证款</h3></div><p>选择市场已验证的爆款，重点参考其<b>品类、整体轮廓、佩戴方式与畅销逻辑</b>。</p></article>
                <article class="launch-remix-card tone-b"><div class="launch-remix-card-head"><span class="launch-remix-mark">B</span><h3>结构与工艺参考款</h3></div><p>参考另一款的<b>链条组合、吊坠比例、耳饰连接、珍珠排列、镶嵌方式或金属工艺</b>。</p></article>
                <article class="launch-remix-card tone-c"><div class="launch-remix-card-head"><span class="launch-remix-mark">C</span><h3>风格与场景参考款</h3></div><p>参考其<b>视觉气质、色彩、细节元素、模特呈现与适用场景</b>，如小千金、通勤、约会或冷感大女主。</p></article>
                <article class="launch-remix-card tone-brand"><div class="launch-remix-card-head"><span class="launch-remix-mark">＋1</span><h3>AngelMyth 品牌化动作</h3></div><p>不可简单拼款。优先加入<b>星芒</b>（核心识别）、<b>猫咪</b>（情感 IP）或<b>四叶草</b>（幸运、守护、礼赠与系列点缀）。</p></article>
              </div>
            </div>
            <div class="launch-remix-section">
              <div class="launch-remix-section-head"><strong>A/B/C 改款等级</strong><span>等级表示改款深度，与上方 A/B/C 参考款来源分别管理</span></div>
              <div class="launch-remix-levels">
                <article class="launch-remix-card tone-a"><div class="launch-remix-card-head"><span class="launch-remix-mark">A</span><h3>轻改款｜基础款与快速跟款</h3></div><p>保留原款约 <b>70%—80%</b> 的畅销逻辑，仅调整颜色、材质、尺寸、局部元素或佩戴方式；适合项链、耳钉、素圈戒指、基础手链等高频款，并必须加入一个小而清晰的品牌细节。</p><p><b>示例：</b>保留项链轮廓，改细链条、加入小星芒吊坠，并调整至 AngelMyth 的价格与材质。</p></article>
                <article class="launch-remix-card tone-b is-core"><div class="launch-remix-card-head"><span class="launch-remix-mark">B</span><h3>组合改款｜核心主力款</h3></div><p>保留 A 款畅销结构，吸收 B 款工艺或局部结构，结合 C 款风格与场景；重新调整比例、材质、元素与佩戴效果，并明确加入星芒或猫咪等品牌识别点。</p><span class="launch-remix-recommend">24—28 岁核心产品的主要改款方式</span></article>
                <article class="launch-remix-card tone-c"><div class="launch-remix-card-head"><span class="launch-remix-mark">C</span><h3>深度改款｜形象款与系列主推款</h3></div><p>只保留原产品的品类逻辑或消费需求，重新设计整体轮廓、结构、材质与视觉重点；强化星芒、猫咪 IP 或独特组合方式，并充分评估成本、工艺、舒适度与市场接受度。</p><p><b>数量原则：</b>不宜过多，仅用于少量核心款或系列视觉款。</p></article>
              </div>
            </div>
          </section>
          <div class="launch-toolbar"><div class="launch-count">共 <strong>${plans.length}</strong> 个开发计划 · 按上架时间排列</div></div>
          ${plans.length ? `
            <div class="launch-plan-grid">
              ${plans.map(plan => `
                <article class="launch-plan-card" data-launch-plan-id="${escapeHtml(plan.id)}">
                  <div class="launch-plan-top">
                    <div><div class="launch-plan-date">上架时间 / ${formatLaunchDate(plan.launchDate)}</div><h2 class="launch-plan-title">${escapeHtml(plan.name || `${formatLaunchDate(plan.launchDate)} 产品开发计划`)}</h2><div class="collab-owner">创建人：${escapeHtml(plan._collaboration?.creatorName || '历史数据')} · 团队协作计划</div></div>
                    <div class="launch-plan-badges">${launchImportanceBadge(plan)}<span class="launch-plan-status">开发中</span></div>
                  </div>
                  <div class="launch-plan-segments">
                    ${plan.segments.map(segment => { const counts = launchPlanCounts(plan, segment); return `<div class="launch-segment-stat"><strong>${segment.label}</strong><span>${counts.scenes} 场景 · ${counts.themes} 主题 · ${counts.styles} 款式</span></div>`; }).join('')}
                    <div class="launch-segment-stat basic"><strong>子波段基本款</strong><span>${plan.subwaveBasicProducts.length} 个直接产品 · 不分场景主题</span></div>
                  </div>
                  <div class="launch-plan-cycle">
                    <div class="launch-plan-cycle-title">本周期改款规划</div>
                    <div class="launch-plan-cycle-copy${plan.cyclePlan?.trim() ? '' : ' empty'}">${escapeHtml(plan.cyclePlan?.trim() || '暂未填写本周期改款规划。')}</div>
                  </div>
                  <div class="launch-plan-actions">
                    ${!isReadOnlyUser ? `<button class="launch-action-btn" type="button" data-launch-edit="${plan.id}">打开并编辑</button>` : ''}
                    ${canManageLaunchPlans ? `<button class="launch-action-btn" type="button" data-launch-duplicate="${plan.id}">复制计划</button>` : ''}
                    ${plan._collaboration?.canDelete ? `<button class="launch-action-btn danger" type="button" data-launch-delete="${plan.id}">删除</button>` : ''}
                  </div>
                </article>
              `).join('')}
            </div>
          ` : `
            <div class="launch-empty">
              <div><div class="launch-empty-icon">＋</div><h2>还没有产品开发计划</h2><p>${canManageLaunchPlans ? '点击右上角“新建产品开发计划”，先确定本批产品的上架时间；主题产品按三个年龄段建立场景与主题，百搭基本款则可直接插入产品。' : '当前还没有上市计划，请联系创建者或管理员新建计划后再开始协作。'}</p>${canManageLaunchPlans ? '<button class="launch-primary-btn" type="button" data-launch-new>新建第一个计划</button>' : ''}</div>
            </div>
          `}
        </section>
      `;
    }

    function formatLaunchDate(value) {
      if (!value) return '时间待定';
      const parts = value.split('-');
      return parts.length === 3 ? `${parts[0]}年${Number(parts[1])}月${Number(parts[2])}日` : value;
    }

    function launchMiniField(path, field, label, placeholder, options = {}) {
      const value = options.value ?? '';
      const classes = ['launch-mini-field', options.wide ? 'wide' : ''].filter(Boolean).join(' ');
      const control = options.textarea
        ? `<textarea class="launch-input launch-textarea ${options.tall ? 'tall' : ''}" data-launch-theme-field="${path}:${field}" placeholder="${placeholder}">${escapeHtml(value)}</textarea>`
        : `<input class="launch-input" data-launch-theme-field="${path}:${field}" value="${escapeHtml(value)}" placeholder="${placeholder}">`;
      return `<div class="${classes}"><label>${label}</label>${control}</div>`;
    }

    function launchAdviceField(path, field, label, placeholder, options = {}) {
      const classes = ['launch-mini-field', options.wide ? 'wide' : ''].filter(Boolean).join(' ');
      return `<div class="${classes}"><label>${label}</label><textarea class="launch-input launch-textarea ${options.tall ? 'tall' : ''}" data-launch-advice-field="${path}:${field}" placeholder="${placeholder}">${escapeHtml(options.value ?? '')}</textarea></div>`;
    }

    async function loadStylePool(force = false) {
      if (!appApi) return;
      if (force || !ajidouPoolData.loaded) {
        try {
          const result = await appApi.listAjidouPoolImages('angelmyth', 1, 100);
          ajidouPoolData.images = result.images;
          ajidouPoolData.page = 1;
          ajidouPoolData.total = result.total;
          ajidouPoolData.hasMore = result.hasMore;
          ajidouPoolData.loaded = true;
        } catch (error) {
          ajidouPoolData.loaded = true;
          ajidouPoolData.hasMore = false;
          console.error('Unable to load AJIDOU bestseller pool', error);
        }
      }
      await Promise.all(stylePoolDefinitions.map(async definition => {
        const bucket = stylePoolData[definition.key];
        if (bucket.loaded && !force) return;
        try {
          const result = await appApi.listStylePoolImages('angelmyth', definition.key, 1, 100);
          bucket.images = result.images;
          bucket.page = 1;
          bucket.total = result.total;
          bucket.hasMore = result.hasMore;
          bucket.loaded = true;
        } catch (error) {
          bucket.loaded = true;
          bucket.hasMore = false;
          console.error(`Unable to load style pool: ${definition.key}`, error);
        }
      }));
    }

    async function loadMoreStylePool(styleKey) {
      if (!appApi) return;
      const bucket = stylePoolData[styleKey];
      if (!bucket?.hasMore) return;
      const result = await appApi.listStylePoolImages('angelmyth', styleKey, bucket.page + 1, 100);
      bucket.images.push(...result.images);
      bucket.page = result.page;
      bucket.total = result.total;
      bucket.hasMore = result.hasMore;
    }

    async function loadMoreAjidouPool() {
      if (!appApi || !ajidouPoolData.hasMore) return;
      const result = await appApi.listAjidouPoolImages('angelmyth', ajidouPoolData.page + 1, 100);
      ajidouPoolData.images.push(...result.images);
      ajidouPoolData.page = result.page;
      ajidouPoolData.total = result.total;
      ajidouPoolData.hasMore = result.hasMore;
    }

    function ajidouPoolTemplate() {
      const canAdd = Boolean(appUser?.id);
      const canDelete = canManageStylePool;
      return `<article class="style-pool-board ajidou-pool-board">
        <div class="style-pool-board-head"><div><div class="style-pool-board-index">00 / BRAND BESTSELLER POOL</div><h2 class="style-pool-board-title">AJIDOU品牌爆品池</h2><p class="style-pool-board-desc">独立于其他风格池，自动汇总所有产品开发计划中的 AJIDOU 品牌款式参考。计划新增、删除或替换后，刷新本页即可同步。</p></div><div><span class="style-pool-count">共 ${ajidouPoolData.total} 张</span><div class="style-pool-status">计划联动 · 完全相同图片自动去重</div></div></div>
        <div class="style-pool-grid">
          ${ajidouPoolData.images.map((image, imageIndex) => `<div class="style-pool-item"><button class="style-pool-preview" type="button" data-ajidou-pool-preview="${imageIndex}" aria-label="放大查看AJIDOU品牌爆品第${imageIndex + 1}张图片"><img src="${escapeHtml(image.url)}" alt="AJIDOU品牌爆品 ${imageIndex + 1}"><span class="style-pool-zoom">点击放大</span></button><span class="ajidou-pool-source">${escapeHtml(image.planNames?.join('、') || '手动添加')}</span>${canDelete && image.source === 'manual' ? `<button class="style-pool-remove" type="button" data-style-pool-remove="ajidou|${image.id}" aria-label="删除AJIDOU手动图片">×</button>` : ''}</div>`).join('')}
          ${!ajidouPoolData.images.length ? '<div class="style-pool-empty">暂无 AJIDOU 参考图；请在产品上市计划中添加。</div>' : ''}
          ${canAdd ? `<label class="style-pool-add"><input type="file" accept="image/jpeg,image/png,image/webp" multiple data-style-pool-input="ajidou"><span><strong>＋</strong><span>手动添加图片 · 自动保存</span></span></label>` : ''}
          ${ajidouPoolData.hasMore ? '<button class="style-pool-more" type="button" data-ajidou-pool-more>加载更多图片</button>' : ''}
        </div>
      </article>`;
    }

    function styleHitPoolTemplate(section, index) {
      const canAdd = Boolean(appUser?.id);
      const canDelete = canManageStylePool;
      return `
        <section>
          <div class="segment-strip" aria-hidden="true"><span class="young"></span><span class="core"></span><span class="mature"></span></div>
          <div class="style-pool-page-head">
            <div><div class="chapter-no">Chapter ${String(index).padStart(2, '0')} / ${section.en}</div><h1 class="chapter-title">${section.label}</h1></div>
            <p class="chapter-summary">${section.summary}</p>
          </div>
          <div class="style-pool-intro"><div class="style-pool-intro-label">Living Image Library / 长期图片库</div><div class="style-pool-intro-copy">${section.purpose} 每个风格板块末尾始终保留“＋”，图片数量不设业务上限。选择图片后系统会立即自动上传并保存到服务器，不需要再点击其他保存按钮；系统采用分页加载，确保图片持续增长后页面仍能稳定浏览。</div></div>
          <div class="style-pool-list">
            ${ajidouPoolTemplate()}
            ${stylePoolDefinitions.map((definition, poolIndex) => {
              const bucket = stylePoolData[definition.key];
              return `<article class="style-pool-board">
                <div class="style-pool-board-head"><div><div class="style-pool-board-index">${String(poolIndex + 1).padStart(2,'0')} / STYLE POOL</div><h2 class="style-pool-board-title">${definition.title}</h2><p class="style-pool-board-desc">${definition.desc}</p></div><div><span class="style-pool-count">共 ${bucket.total} 张</span>${canAdd ? '<div class="style-pool-status">添加后自动保存</div>' : ''}</div></div>
                <div class="style-pool-grid">
                  ${bucket.images.map((image, imageIndex) => `<div class="style-pool-item"><button class="style-pool-preview" type="button" data-style-pool-preview="${definition.key}|${imageIndex}" aria-label="放大查看${definition.title}第${imageIndex + 1}张图片"><img src="${escapeHtml(image.url)}" alt="${definition.title} ${imageIndex + 1}"><span class="style-pool-zoom">点击放大</span></button><span class="ajidou-pool-source">${escapeHtml(image.source === 'plan' ? (image.planNames?.join('、') || '企划自动同步') : '手动添加')}</span>${canDelete && image.source !== 'plan' ? `<button class="style-pool-remove" type="button" data-style-pool-remove="${definition.key}|${image.id}" aria-label="删除手动图片">×</button>` : ''}</div>`).join('')}
                  ${!bucket.images.length && !canAdd ? '<div class="style-pool-empty">该风格暂未添加图片</div>' : ''}
                  ${canAdd ? `<label class="style-pool-add"><input type="file" accept="image/jpeg,image/png,image/webp" multiple data-style-pool-input="${definition.key}"><span><strong>＋</strong><span>添加图片 · 自动保存</span></span></label>` : ''}
                  ${bucket.hasMore ? `<button class="style-pool-more" type="button" data-style-pool-more="${definition.key}">加载更多图片</button>` : ''}
                </div>
              </article>`;
            }).join('')}
          </div>
        </section>`;
    }

    function launchVisualAdviceField(path, field, label, placeholder, imagesKind, imagesLabel, value, images = []) {
      const emptySlots = Math.max(0, 3 - images.length);
      return `
        <div class="launch-mini-field launch-visual-reference">
          <label>${label}</label>
          <textarea class="launch-input launch-textarea" data-launch-advice-field="${path}:${field}" placeholder="${placeholder}">${escapeHtml(value ?? '')}</textarea>
          <div class="launch-visual-reference-head"><span>${imagesLabel}</span><span class="launch-subtle-badge">${images.length} / 3张</span></div>
          <div class="launch-image-grid">
            ${images.map((src, imageIndex) => `<div class="launch-image-item"><button class="launch-image-preview" type="button" data-launch-preview-image="${imagesKind}|${path}|${imageIndex}" aria-label="放大查看${imagesLabel}第 ${imageIndex + 1} 张"><img src="${escapeHtml(src)}" alt="${imagesLabel} ${imageIndex + 1}"><span class="launch-image-zoom">点击放大</span></button><button class="launch-image-remove" type="button" data-launch-remove-image="${imagesKind}|${path}|${imageIndex}" aria-label="删除图片">×</button></div>`).join('')}
            ${Array.from({ length:emptySlots }, () => launchImageAddControl(imagesKind, path, '插入参考图')).join('')}
          </div>
        </div>`;
    }

    const launchStandardOptions = {
      category:['项链','耳环','耳钉','手链','手镯','戒指','套装','挂件','其他/自定义'],
      style:['韩式奢华千金风格','韩式精致通勤风格','韩式小清新风格','韩式冷感大女主风格','韩系大浪漫风格','韩系都市优雅风格','其他/自定义'],
      material:['925银','铜合金','珍珠','贝母','锆石','水晶','玛瑙','天然石','不锈钢','其他/自定义'],
      plannedMaterial:['925银','铜合金','珍珠','贝母','锆石','水晶','玛瑙','天然石','不锈钢','其他/自定义'],
      plannedCraft:['镶嵌','电镀','滴釉','拉丝','微镶','抛光','镂空','其他/自定义'],
      elements:['星星','猫','爱心','四叶草','蝴蝶结','珍珠','花朵','水滴','几何','其他/自定义'],
      plannedElements:['星星','猫','爱心','四叶草','蝴蝶结','珍珠','花朵','水滴','几何','其他/自定义']
    };
    const launchListId = field => launchStandardOptions[field] ? `launch-options-${field}` : '';
    const launchListAttr = field => launchListId(field) ? ` list="${launchListId(field)}"` : '';
    function launchStandardDatalists() {
      return Object.entries(launchStandardOptions).map(([field, values]) => `<datalist id="${launchListId(field)}">${values.map(value => `<option value="${escapeHtml(value)}"></option>`).join('')}</datalist>`).join('');
    }

    function launchStyleField(path, field, label, placeholder, value, options = {}) {
      const classes = ['launch-mini-field', options.wide ? 'wide' : ''].filter(Boolean).join(' ');
      const control = options.textarea
        ? `<textarea class="launch-input launch-textarea" data-launch-style-field="${path}:${field}" placeholder="${placeholder}">${escapeHtml(value ?? '')}</textarea>`
        : `<input class="launch-input"${launchListAttr(field)} data-launch-style-field="${path}:${field}" value="${escapeHtml(value ?? '')}" placeholder="${placeholder}">`;
      return `<div class="${classes}"><label>${label}</label>${control}</div>`;
    }

    function launchBasicField(productPath, field, label, placeholder, value, options = {}) {
      const classes = ['launch-mini-field', options.wide ? 'wide' : ''].filter(Boolean).join(' ');
      const control = options.textarea
        ? `<textarea class="launch-input launch-textarea" data-launch-basic-field="${productPath}:${field}" placeholder="${placeholder}">${escapeHtml(value ?? '')}</textarea>`
        : `<input class="launch-input"${launchListAttr(field)} data-launch-basic-field="${productPath}:${field}" value="${escapeHtml(value ?? '')}" placeholder="${placeholder}">`;
      return `<div class="${classes}"><label>${label}</label>${control}</div>`;
    }

    const launchReferenceImageKinds = new Set([
      'ajidouReferenceImages', 'cycleReferenceImages', 'accentColorAnalysisImages', 'baseColorAnalysisImages',
      'competitorReferenceImages', 'basicReferenceImages', 'basicPersonaImages', 'referenceImages',
      'wearImages', 'extensionReferenceImages', 'heroShootImages', 'detailVisualImages', 'influencerImages', 'faceImages'
    ]);

    function launchImageAddControl(kind, path, label = '插入图片', multiple = true) {
      const multipleAttr = multiple ? ' multiple' : '';
      if (!launchReferenceImageKinds.has(kind)) {
        return `<label class="launch-image-add"><input type="file" accept="image/*"${multipleAttr} data-launch-image-input="${kind}|${path}"><span><strong>＋</strong><span>${label}</span></span></label>`;
      }
      return `<div class="launch-image-add launch-image-paste-slot" tabindex="0" data-launch-paste-target="${kind}|${path}" aria-label="${label}，也可以粘贴剪贴板图片" title="鼠标停在这里，直接按 Ctrl+V 粘贴参考图"><label class="launch-image-file-trigger"><input type="file" accept="image/*"${multipleAttr} data-launch-image-input="${kind}|${path}"><span><strong>＋</strong><span>${label}</span></span></label><button class="launch-image-paste-button" type="button" data-launch-paste-image="${kind}|${path}">粘贴图片</button><span class="launch-image-paste-hint">悬停后按 Ctrl+V</span></div>`;
    }

    function launchImageGallery(images, kind, path, max) {
      const galleryClass = kind === 'finalImages' || kind === 'wearImages' ? ' final-images' : '';
      const targetTheme = kind === 'finalImages' ? launchThemeAt(path) : null;
      return `
        <div class="launch-image-grid${galleryClass}">
          ${images.map((src, imageIndex) => { const productName = targetTheme?.styles?.[imageIndex]?.name?.trim() || `开发款 ${String(imageIndex + 1).padStart(2, '0')}`; return `<div class="launch-image-item"><button class="launch-image-preview" type="button" data-launch-preview-image="${kind}|${path}|${imageIndex}" aria-label="放大查看第 ${imageIndex + 1} 张图片"><img src="${escapeHtml(src)}" alt="${escapeHtml(productName)}"><span class="launch-image-zoom">点击放大</span>${kind === 'finalImages' ? `<span class="launch-image-product-name" data-launch-image-product-name="${path}:${imageIndex}">${escapeHtml(productName)}</span>` : ''}</button><button class="launch-image-remove" type="button" data-launch-remove-image="${kind}|${path}|${imageIndex}" aria-label="删除图片">×</button></div>`; }).join('')}
          ${images.length < max ? launchImageAddControl(kind, path, kind === 'referenceImages' ? '插入参考图' : '插入图片') : ''}
        </div>
      `;
    }

    function launchExtensionPlanField(theme, path) {
      const images = theme.extensionReferenceImages || [];
      const emptySlots = Math.max(0, 3 - images.length);
      return `
        <div class="launch-extension-field wide">
          <label>消费者画像</label>
          <div class="launch-extension-layout">
            <div class="launch-extension-block launch-extension-images">
              <div class="launch-extension-block-title">参考款式图片 · 固定3张</div>
              <div class="launch-image-grid">
                ${images.map((src, imageIndex) => `<div class="launch-image-item"><button class="launch-image-preview" type="button" data-launch-preview-image="extensionReferenceImages|${path}|${imageIndex}" aria-label="放大查看延伸改款参考图第 ${imageIndex + 1} 张"><img src="${escapeHtml(src)}" alt="延伸改款参考款式 ${imageIndex + 1}"><span class="launch-image-zoom">点击放大</span></button><button class="launch-image-remove" type="button" data-launch-remove-image="extensionReferenceImages|${path}|${imageIndex}" aria-label="删除图片">×</button></div>`).join('')}
                ${Array.from({ length:emptySlots }, () => launchImageAddControl('extensionReferenceImages', path, '插入参考图')).join('')}
              </div>
            </div>
            <div class="launch-extension-block launch-extension-persona">
              <div class="launch-extension-block-title">对应人群画像</div>
              <textarea class="launch-input launch-textarea" data-launch-theme-field="${path}:extensionPlan" placeholder="描述这3张参考款式对应的人群，例如：年龄阶段、生活场景、审美偏好、穿搭特征和消费动机">${escapeHtml(theme.extensionPlan || '')}</textarea>
            </div>
          </div>
        </div>`;
    }

    function launchBasicProductImageGallery(product, productPath, kind = 'basicProductImages', max = 10, buttonLabel = '插入产品图') {
      const fieldMap = { basicProductImages:'images', basicReferenceImages:'referenceImages', basicPersonaImages:'personaImages' };
      const images = product[fieldMap[kind]] || [];
      return `
        <div class="launch-image-grid">
          ${images.map((src, imageIndex) => `<div class="launch-image-item"><button class="launch-image-preview" type="button" data-launch-preview-image="${kind}|${productPath}|${imageIndex}" aria-label="放大查看第 ${imageIndex + 1} 张图片"><img src="${escapeHtml(src)}" alt="${escapeHtml(product.name?.trim() || '改款产品')}"><span class="launch-image-zoom">点击放大</span></button><button class="launch-image-remove" type="button" data-launch-remove-image="${kind}|${productPath}|${imageIndex}" aria-label="删除图片">×</button></div>`).join('')}
          ${images.length < max ? launchImageAddControl(kind, productPath, buttonLabel) : ''}
        </div>`;
    }

    function launchPlanReferenceImageBoard(kind, title, max, description) {
      const images = launchDraft?.[kind] || [];
      const emptySlots = Math.max(0, max - images.length);
      return `
        <section class="launch-cycle-images">
          <div class="launch-cycle-images-head">
            <div><div class="launch-cycle-images-title">${title}</div><div class="launch-cycle-images-tip">${description} 点击任意图片可放大查看，并可用左右箭头连续浏览。</div></div>
            <span class="launch-subtle-badge">${images.length} / ${max}款</span>
          </div>
          <div class="launch-cycle-image-grid">
            ${images.map((src, imageIndex) => `<div class="launch-image-item"><button class="launch-image-preview" type="button" data-launch-preview-image="${kind}|plan|${imageIndex}" aria-label="放大查看${title}第 ${imageIndex + 1} 款"><img src="${escapeHtml(src)}" alt="${title} ${imageIndex + 1}"><span class="launch-image-zoom">点击放大</span></button><button class="launch-image-remove" type="button" data-launch-remove-image="${kind}|plan|${imageIndex}" aria-label="删除图片">×</button></div>`).join('')}
            ${Array.from({ length:emptySlots }, () => launchImageAddControl(kind, 'plan', '插入参考图')).join('')}
          </div>
        </section>`;
    }

    function launchCompetitorReferenceBoard(group, groupIndex) {
      const images = group?.images || [];
      const emptySlots = Math.max(0, 20 - images.length);
      const boardTitle = group?.title || competitorReferenceDefinitions[groupIndex]?.title || `竞品风格 ${groupIndex + 1}`;
      return `
        <section class="launch-cycle-images launch-competitor-style">
          <div class="launch-cycle-images-head">
            <div class="launch-competitor-style-heading">
              <label class="launch-competitor-style-title-field"><span>风格名称</span><input class="launch-input launch-competitor-style-title-input" data-launch-competitor-title="${groupIndex}" value="${escapeHtml(boardTitle)}" placeholder="填写风格名称"></label>
              <label class="launch-competitor-brand-field"><span>参考品牌</span><input class="launch-input launch-competitor-brand-input" data-launch-competitor-brand="${groupIndex}" value="${escapeHtml(group?.brand || '')}" placeholder="填写对应参考品牌，例如：NUMBERING、AJIDOU"></label>
            </div>
            <span class="launch-subtle-badge">${images.length} / 20款</span>
          </div>
          <div class="launch-cycle-images-tip">本风格可批量插入最多20张参考款式；桌面端一排10张。点击任意图片可放大查看，并可用左右箭头连续浏览。</div>
          <div class="launch-cycle-image-grid" style="margin-top:10px">
            ${images.map((src, imageIndex) => `<div class="launch-image-item"><button class="launch-image-preview" type="button" data-launch-preview-image="competitorReferenceImages|${groupIndex}|${imageIndex}" aria-label="放大查看${escapeHtml(boardTitle)}第 ${imageIndex + 1} 款"><img src="${escapeHtml(src)}" alt="${escapeHtml(boardTitle)} ${imageIndex + 1}"><span class="launch-image-zoom">点击放大</span></button><button class="launch-image-remove" type="button" data-launch-remove-image="competitorReferenceImages|${groupIndex}|${imageIndex}" aria-label="删除图片">×</button></div>`).join('')}
            ${Array.from({ length:emptySlots }, () => launchImageAddControl('competitorReferenceImages', groupIndex, '插入参考图')).join('')}
          </div>
        </section>`;
    }

    function launchCycleImageBoard() {
      return `
        ${launchPlanReferenceImageBoard('ajidouReferenceImages', 'AJIDOU品牌款式参考', 30, '可批量插入最多30款AJIDOU品牌款式，桌面端一排10张。')}
        <section class="launch-competitor-reference-system">
          <div class="launch-competitor-reference-head">
            <div><div class="launch-competitor-reference-title">其他竞品参考款式</div><div class="launch-competitor-reference-tip">按四种品牌风格分别建立竞品资料库；每个板块可填写对应参考品牌，并上传最多20张款式图片。</div></div>
            <span class="launch-subtle-badge">4个风格板块 · 共80张</span>
          </div>
          <div class="launch-competitor-reference-list">
            ${(launchDraft?.competitorReferenceGroups || emptyCompetitorReferenceGroups()).map(launchCompetitorReferenceBoard).join('')}
          </div>
        </section>
      `;
    }

    function launchColorAnalysisRow(kind, title, noteField, placeholder) {
      const images = Array.isArray(launchDraft?.[kind]) ? launchDraft[kind].slice(0, 5) : [];
      return `
        <section class="launch-color-analysis-row">
          <div>
            <div class="launch-color-gallery-head"><span>${title}</span><span class="launch-subtle-badge">${images.length} / 5张</span></div>
            <div class="launch-color-gallery">
              ${Array.from({ length:5 }, (_, imageIndex) => {
                const src = images[imageIndex];
                return src
                  ? `<div class="launch-image-item"><button class="launch-image-preview" type="button" data-launch-preview-image="${kind}|plan|${imageIndex}" aria-label="放大查看${title}第 ${imageIndex + 1} 张"><img src="${escapeHtml(src)}" alt="${title} ${imageIndex + 1}"><span class="launch-image-zoom">点击放大</span></button><label class="launch-color-replace">替换<input type="file" accept="image/*" data-launch-color-replace="${kind}|${imageIndex}"></label><button class="launch-image-remove" type="button" data-launch-remove-image="${kind}|plan|${imageIndex}" aria-label="删除图片">×</button></div>`
                  : launchImageAddControl(kind, 'plan', '插入参考图', false);
              }).join('')}
            </div>
          </div>
          <label class="launch-color-note"><span class="launch-color-note-title">色彩使用说明</span><textarea class="launch-input" data-launch-field="${noteField}" maxlength="3000" placeholder="${placeholder}">${escapeHtml(launchDraft?.[noteField] || '')}</textarea><span class="launch-color-save-tip">图片与文字修改后自动保存</span></label>
        </section>`;
    }

    function launchColorAnalysisBoard() {
      return `
        <section class="launch-color-analysis">
          <div class="launch-color-analysis-head"><div><div class="launch-color-analysis-title">本月开发计划 · 色彩占比分析</div><div class="launch-color-analysis-tip">分别规划产品点缀色与产品底色；每组固定 5 个图片位置，右侧记录颜色占比、搭配关系和具体使用方式。</div></div><span class="launch-subtle-badge">团队共同编辑 · 自动保存</span></div>
          <div class="launch-color-analysis-list">
            ${launchColorAnalysisRow('accentColorAnalysisImages', '产品点缀色系分析', 'accentColorAnalysisNote', '描述这五组点缀色的占比、适用品类、元素、材质与搭配方式。')}
            ${launchColorAnalysisRow('baseColorAnalysisImages', '产品底色颜色分析', 'baseColorAnalysisNote', '描述这五组产品底色的占比、主次关系、适用系列与落地方式。')}
          </div>
        </section>`;
    }

    function launchBloggerImageField(path, kind, label) {
      const targetTheme = launchThemeAt(path);
      const images = targetTheme?.advice?.[kind] || [];
      const emptySlots = Math.max(0, 4 - images.length);
      return `
        <div class="launch-blogger-reference">
          <label>${label}</label>
          <div class="launch-image-grid">
            ${images.map((src, imageIndex) => `<div class="launch-image-item"><button class="launch-image-preview" type="button" data-launch-preview-image="${kind}|${path}|${imageIndex}" aria-label="放大查看第 ${imageIndex + 1} 张图片"><img src="${escapeHtml(src)}" alt="${label}参考图 ${imageIndex + 1}"><span class="launch-image-zoom">点击放大</span></button><button class="launch-image-remove" type="button" data-launch-remove-image="${kind}|${path}|${imageIndex}" aria-label="删除图片">×</button></div>`).join('')}
            ${Array.from({ length:emptySlots }, () => launchImageAddControl(kind, path, '插入参考图')).join('')}
          </div>
        </div>`;
    }

    function renderLaunchLightbox() {
      const { images, index, label } = launchLightboxState;
      if (!images.length) return;
      launchLightboxImage.src = images[index];
      launchLightboxImage.alt = `${label} ${index + 1}`;
      launchLightboxLabel.textContent = label;
      launchLightboxCount.textContent = `${index + 1} / ${images.length}`;
      launchLightboxPrev.hidden = images.length < 2;
      launchLightboxNext.hidden = images.length < 2;
    }

    function openLaunchLightboxImages(images, label, imageIndex) {
      if (!Array.isArray(images) || !images.length) return;
      launchLightboxState = {
        images:[...images],
        index:Math.min(Math.max(Number(imageIndex) || 0, 0), images.length - 1),
        label
      };
      renderLaunchLightbox();
      launchImageLightbox.classList.add('show');
      launchLightboxClose.focus();
    }

    function openLaunchLightbox(kind, pathValue, imageIndex) {
      const isCompetitorReference = kind === 'competitorReferenceImages';
      const isPlanReference = ['ajidouReferenceImages', 'cycleReferenceImages', 'accentColorAnalysisImages', 'baseColorAnalysisImages'].includes(kind) || isCompetitorReference;
      const isBasicProduct = ['basicProductImages', 'basicReferenceImages', 'basicPersonaImages'].includes(kind);
      const targetTheme = isPlanReference || isBasicProduct ? null : launchThemeAt(pathValue);
      const targetBasicProduct = isBasicProduct ? launchBasicProductAt(pathValue) : null;
      const targetCompetitorGroup = isCompetitorReference ? launchDraft?.competitorReferenceGroups?.[Number(pathValue)] : null;
      const adviceImageKinds = ['heroShootImages', 'detailVisualImages', 'influencerImages', 'faceImages'];
      const basicImageFields = { basicProductImages:'images', basicReferenceImages:'referenceImages', basicPersonaImages:'personaImages' };
      const images = isCompetitorReference ? targetCompetitorGroup?.images : isPlanReference ? launchDraft?.[kind] : isBasicProduct ? targetBasicProduct?.[basicImageFields[kind]] : adviceImageKinds.includes(kind) ? targetTheme?.advice?.[kind] : targetTheme?.[kind];
      const labels = { referenceImages:'参考款式', extensionReferenceImages:'延伸改款参考款式', finalImages:'实际改款款式', wearImages:'模特上身展示图', heroShootImages:'主图 / 组图视觉参考', detailVisualImages:'详情页视觉参考', influencerImages:'适合合作的博主风格', faceImages:'适合的博主脸型 / 气质' };
      const basicLabels = { basicProductImages:'确定改款后的产品图', basicReferenceImages:'改款参考图', basicPersonaImages:'穿搭氛围与对应人群画像' };
      const competitorLabel = targetCompetitorGroup ? `${targetCompetitorGroup.title}${targetCompetitorGroup.brand?.trim() ? ` · ${targetCompetitorGroup.brand.trim()}` : ''}` : '其他竞品参考款式';
      const planLabels = { ajidouReferenceImages:'AJIDOU品牌款式参考', cycleReferenceImages:'其他竞品参考款式', accentColorAnalysisImages:'产品点缀色系分析', baseColorAnalysisImages:'产品底色颜色分析' };
      const label = isCompetitorReference ? competitorLabel : isPlanReference ? planLabels[kind] : isBasicProduct ? basicLabels[kind] : labels[kind] || '参考图片';
      openLaunchLightboxImages(images, label, imageIndex);
    }

    function canEditLaunchPlan(plan) {
      // 第 12 页为团队共同编辑区：所有已登录成员都可编辑同一企划。
      // 删除、最终确认等高风险操作仍由管理员权限单独控制。
      return Boolean(appUser?.id) && !isReadOnlyUser;
    }

    function touchLaunchPresence(target, path = '*') {
      if (!launchPresencePlanId || typeof appLaunchPlanClient.heartbeat !== 'function') return;
      launchPresencePath = path || '*';
      void appLaunchPlanClient.heartbeat(launchPresencePlanId, '*').catch(() => undefined);
      if (launchPresencePath !== '*') void appLaunchPlanClient.heartbeat(launchPresencePlanId, launchPresencePath).catch(() => undefined);
      if (target) target.dataset.launchPresenceTouched = 'true';
    }

    function launchPresencePathFromTarget(target) {
      if (!target?.dataset) return '*';
      for (const key of ['launchThemeField', 'launchAdviceField', 'launchStyleField', 'launchBasicField', 'launchBasicName', 'launchStyleName', 'launchThemeName', 'launchSceneName', 'launchSceneCustom', 'launchField']) {
        if (target.dataset[key]) return target.dataset[key];
      }
      return '*';
    }

    function startLaunchPresence(planId) {
      stopLaunchPresence();
      launchPresencePlanId = planId || '';
      launchPresencePath = '*';
      if (!launchPresencePlanId || typeof appLaunchPlanClient.heartbeat !== 'function') return;
      touchLaunchPresence();
      launchPresenceTimer = window.setInterval(() => touchLaunchPresence(), 15000);
    }

    function stopLaunchPresence() {
      if (launchPresenceTimer) window.clearInterval(launchPresenceTimer);
      if (launchPresencePlanId && typeof appLaunchPlanClient.clearPresence === 'function') {
        void appLaunchPlanClient.clearPresence(launchPresencePlanId, '*').catch(() => undefined);
        if (launchPresencePath !== '*') void appLaunchPlanClient.clearPresence(launchPresencePlanId, launchPresencePath).catch(() => undefined);
      }
      launchPresenceTimer = null;
      launchPresencePlanId = '';
      launchPresencePath = '*';
    }

    async function confirmLaunchEntityDelete(path, label, options = {}) {
      let editors = [];
      try {
        if (launchDraft && typeof appLaunchPlanClient.activeEditors === 'function') {
          editors = await appLaunchPlanClient.activeEditors(launchDraft.id, path || '*');
        }
      } catch { editors = []; }
      if (!options.alwaysConfirm && !editors.length) return true;
      const entityName = options.name ? `${label}“${options.name}”` : label;
      const editorWarning = editors.length
        ? `同事${editors.map(editor => editor.displayName).join('、')}正在编辑${entityName}，建议先通知对方。\n\n`
        : '';
      const consequence = options.consequence ? `\n${options.consequence}` : '';
      return confirm(`${editorWarning}确定要删除${entityName}吗？${consequence}\n\n点击“取消”可保留全部内容。`);
    }

    function closeLaunchLightbox() {
      launchImageLightbox.classList.remove('show');
      launchLightboxImage.removeAttribute('src');
      launchLightboxState = { images:[], index:0, label:'' };
    }

    function moveLaunchLightbox(step) {
      if (launchLightboxState.images.length < 2) return;
      launchLightboxState.index = (launchLightboxState.index + step + launchLightboxState.images.length) % launchLightboxState.images.length;
      renderLaunchLightbox();
    }

    function launchStyleCard(style, path, styleIndex) {
      const canEdit = canEditLaunchPlan(launchDraft);
      const disabled = canEdit ? '' : ' disabled';
      return `
        <article class="launch-style${canEdit ? '' : ' collaboration-readonly'}">
          <div class="launch-style-head">
            <span class="launch-style-index">开发款 ${String(styleIndex + 1).padStart(2, '0')}</span>
            <input class="launch-input launch-style-name-input" data-launch-style-name="${path}" value="${escapeHtml(style.name)}" placeholder="款式名称，例如：珍珠耳环、叠戴项链"${disabled}>
            <label class="launch-level-control"><span>产品等级</span><select class="launch-input launch-level-select" data-launch-style-field="${path}:productLevel"${disabled}><option value="">请选择</option>${['S','A','B','C'].map(level => `<option value="${level}" ${style.productLevel === level ? 'selected' : ''}>${level}款</option>`).join('')}</select></label>
            ${canEdit ? `<button class="launch-remove-btn" type="button" data-launch-remove-style="${path}" aria-label="删除开发款">×</button>` : ''}
          </div>
          <div class="launch-style-fields">
            ${launchStyleField(path, 'category', '实际品类', '例如：项链、耳饰、手链、戒指', style.category)}
            ${launchStyleField(path, 'elements', '设计元素', '例如：蝴蝶结、爱心、水滴', style.elements)}
            ${launchStyleField(path, 'material', '实际材质', '例如：925银、珍珠、锆石', style.material)}
            ${launchStyleField(path, 'plannedPrice', '计划售价', '例如：199–259元', style.plannedPrice)}
            ${launchStyleField(path, 'actualPrice', '实际开发价格', '填写打样或最终开发价格', style.actualPrice)}
            ${launchStyleField(path, 'description', '产品开发描述', '记录造型结构、佩戴方式、尺寸、开发调整和最终落地情况', style.description, { wide:true, textarea:true })}
          </div>
        </article>
      `;
    }

    function launchBasicProductCard(product, productIndex, collection = 'cold') {
      const productPath = `${collection}:${productIndex}`;
      const canEdit = canEditLaunchPlan(launchDraft);
      const disabled = canEdit ? '' : ' disabled';
      return `
        <article class="launch-basic-product${canEdit ? '' : ' collaboration-readonly'}">
          <div class="launch-style-head">
            <span class="launch-style-index">改款 ${String(productIndex + 1).padStart(2, '0')}</span>
            <input class="launch-input launch-style-name-input" data-launch-basic-name="${productPath}" value="${escapeHtml(product.name)}" placeholder="款式名称，例如：百搭小耳钉、基础细链项链"${disabled}>
            <label class="launch-level-control"><span>产品等级</span><select class="launch-input launch-level-select" data-launch-basic-field="${productPath}:productLevel"${disabled}><option value="">请选择</option>${['S','A','B','C'].map(level => `<option value="${level}" ${product.productLevel === level ? 'selected' : ''}>${level}款</option>`).join('')}</select></label>
            ${canEdit ? `<button class="launch-remove-btn" type="button" data-launch-remove-basic-product="${productPath}" aria-label="删除改款">×</button>` : `<span class="launch-subtle-badge">${escapeHtml(product.creatorName || '其他同事')}创建 · 只读</span>`}
          </div>
          <section class="launch-basic-reference-plan">
            <div class="launch-basic-reference-title">参考分析与改款计划</div>
            <div class="launch-basic-reference-tip">先放入这个改款的参考款式与目标人群，再明确价格、材质、工艺、元素和具体改款方向。</div>
            <div class="launch-basic-reference-layout">
              <div class="launch-basic-reference-images">
                <div class="launch-basic-analysis-title">改款参考图 · 最多4张</div>
                ${launchBasicProductImageGallery(product, productPath, 'basicReferenceImages', 4, '插入参考图')}
              </div>
              <div class="launch-basic-plan-fields">
                ${launchBasicField(productPath, 'referenceBrand', '参考品牌', '例如：AJIDOU、NUMBERING', product.referenceBrand)}
                ${launchBasicField(productPath, 'plannedPrice', '计划价格段', '例如：99–159元', product.plannedPrice)}
                ${launchBasicField(productPath, 'plannedMaterial', '计划材质', '例如：925银、铜合金、珍珠', product.plannedMaterial)}
                ${launchBasicField(productPath, 'plannedCraft', '计划工艺', '例如：滴釉、拉丝、微镶、抛光', product.plannedCraft)}
                ${launchBasicField(productPath, 'plannedElements', '设计元素和特点', '例如：圆珠、细链、素圈、叠戴结构', product.plannedElements)}
                ${launchBasicField(productPath, 'adaptationDirection', '改款方向', '说明保留什么、调整什么，以及造型、尺寸、佩戴方式和差异化方向', product.adaptationDirection, { wide:true, textarea:true })}
              </div>
              <div class="launch-basic-persona-images">
                <div class="launch-basic-analysis-title">穿搭氛围 / 对应人群画像 · 最多4张</div>
                ${launchBasicProductImageGallery(product, productPath, 'basicPersonaImages', 4, '插入人群图')}
                <div class="launch-basic-persona-copy">${launchBasicField(productPath, 'personaProfile', '对应人群说明', '年龄、生活场景、审美偏好、穿搭风格和购买动机', product.personaProfile, { wide:true, textarea:true })}</div>
              </div>
            </div>
          </section>
          <div class="launch-basic-result-title">确定改款后的产品与款式资料</div>
          <div class="launch-basic-product-layout">
            <div class="launch-basic-product-images">
              <div class="launch-basic-analysis-title">确定改款后的产品图 · 最多10张</div>
              ${launchBasicProductImageGallery(product, productPath, 'basicProductImages', 10, '插入改款图')}
            </div>
            <div class="launch-basic-analysis">
              <div class="launch-basic-analysis-title">改款后的实际款式资料</div>
              <div class="launch-style-fields">
                ${launchBasicField(productPath, 'category', '实际品类', '例如：项链、耳饰、手链、戒指', product.category)}
                ${launchBasicField(productPath, 'designer', '设计师', '填写负责该基本款开发的设计师姓名', product.designer)}
                ${launchBasicField(productPath, 'style', '风格 / 基础属性', '例如：百搭、极简、日常通勤', product.style)}
                ${launchBasicField(productPath, 'elements', '设计元素', '例如：圆珠、细链、素圈、水滴', product.elements)}
                ${launchBasicField(productPath, 'material', '实际材质', '例如：925银、钛钢、珍珠、锆石', product.material)}
                ${launchBasicField(productPath, 'plannedRetailPrice', '计划售价', '例如：199–399元', product.plannedRetailPrice)}
                ${launchBasicField(productPath, 'actualPrice', '实际开发价格', '填写打样或最终开发价格', product.actualPrice)}
                ${launchBasicField(productPath, 'outfit', '适合搭配 / 使用范围', '例如：T恤、衬衫、针织衫，日常多场景百搭', product.outfit, { wide:true })}
                ${launchBasicField(productPath, 'description', '产品开发描述', '记录造型、尺寸、佩戴方式、基础功能、差异化细节、开发调整及最终落地结果', product.description, { wide:true, textarea:true })}
              </div>
            </div>
          </div>
        </article>`;
    }

    function launchThemeCard(theme, segmentIndex, sceneIndex, themeIndex) {
      const path = `${segmentIndex}:${sceneIndex}:${themeIndex}`;
      const advice = theme.advice || {};
      const canEdit = canEditLaunchPlan(launchDraft);
      const readonlyClass = canEdit ? '' : ' collaboration-readonly';
      const isCollapsed = launchCollapsedThemeIds.has(theme.id);
      const collapseSummary = `${theme.referenceImages.length || 0} 张参考图 · ${theme.finalImages.length || 0} 张改款图 · ${theme.styles.length || 0} 个开发款`;
      return `
        <div class="launch-theme${readonlyClass}${isCollapsed ? ' collapsed' : ''}">
          <div class="launch-row"><button class="launch-collapse-btn" type="button" data-launch-toggle-theme="${escapeHtml(theme.id)}" aria-expanded="${isCollapsed ? 'false' : 'true'}" aria-label="${isCollapsed ? '展开主题内容' : '收起主题内容'}">${isCollapsed ? '＋' : '−'}</button><input class="launch-input" data-launch-theme-name="${path}" value="${escapeHtml(theme.name)}" placeholder="填写主题，例如：城市晨光、下班约会、海边珍珠"${canEdit ? '' : ' disabled'}>${canEdit ? `<button class="launch-remove-btn" type="button" data-launch-remove-theme="${path}" aria-label="删除主题">×</button>` : `<span class="launch-subtle-badge">${escapeHtml(theme.creatorName || '其他同事')}创建 · 只读</span>`}</div>
          ${isCollapsed ? `<div class="launch-collapse-summary">${escapeHtml(collapseSummary)} · 已收起</div>` : ''}
          <div class="launch-theme-workspace">
            <div class="launch-theme-primary">
              <section class="launch-work-panel">
                <div class="launch-work-head"><div><div class="launch-work-title">参考款式</div><div class="launch-work-tip">逐张插入对标精品或爆款图片，作为这个主题的设计参考。</div></div><span class="launch-subtle-badge">最多10张</span></div>
                ${launchImageGallery(theme.referenceImages, 'referenceImages', path, 10)}
              </section>
              <section class="launch-work-panel white">
                <div class="launch-work-head"><div><div class="launch-work-title">主题策划与改款方向</div><div class="launch-work-tip">说明为什么做、由谁负责、准备开发什么，以及材质、工艺和设计语言。</div></div></div>
                <div class="launch-form-grid">
                  ${launchMiniField(path, 'designer', '设计师', '填写负责人', { value:theme.designer })}
                  ${launchMiniField(path, 'plannedCount', '计划开发款数', '例如：4款', { value:theme.plannedCount })}
                  ${launchMiniField(path, 'rationale', '开发这个主题的原因', '消费者需求、场景机会、竞品启发或品牌表达依据', { value:theme.rationale, wide:true, textarea:true })}
                  ${launchExtensionPlanField(theme, path)}
                  ${launchMiniField(path, 'priceBand', '计划销售价格段', '例如：199–299元', { value:theme.priceBand })}
                  ${launchMiniField(path, 'materials', '计划材质', '例如：925银、淡水珍珠、锆石', { value:theme.materials })}
                  ${launchMiniField(path, 'crafts', '计划工艺', '例如：滴釉、拉丝、微镶、镜面抛光', { value:theme.crafts })}
                  ${launchMiniField(path, 'elements', '设计元素与特点', '例如：水滴、花朵、可拆卸、叠戴', { value:theme.elements })}
                  ${launchMiniField(path, 'direction', '主题描述 / 改款方向', '完整描述这个主题的情绪、视觉语言、造型方向、差异化和最终想呈现的产品感觉', { value:theme.direction, wide:true, textarea:true, tall:true })}
                </div>
              </section>
            </div>
            <section class="launch-work-panel">
              <div class="launch-work-head"><div><div class="launch-work-title">改款后的成品 / 设计稿</div><div class="launch-work-tip">上传实际改出的款式图、设计稿或打样图，用于与参考款和主题方向对照；仅保存于当前企划，不同步到爆款池。</div></div><span class="launch-subtle-badge">最多50款</span></div>
              ${launchImageGallery(theme.finalImages, 'finalImages', path, 50)}
            </section>
            <section class="launch-work-panel">
              <div class="launch-work-head"><div><div class="launch-work-title">模特上身展示图</div><div class="launch-work-tip">上传改款完成后实际佩戴到模特身上的图片，产品上身展示页会按风格和主题自动汇总。</div></div><span class="launch-subtle-badge">最多10张</span></div>
              ${launchImageGallery(theme.wearImages, 'wearImages', path, 10)}
            </section>
            <section class="launch-work-panel">
              <div class="launch-work-head"><div><div class="launch-work-title">逐款开发追踪</div><div class="launch-work-tip">每一个实际开发款单独记录风格、元素、材质、价格、穿搭和具体开发结果；每个主题最多50款。</div></div><span class="launch-subtle-badge">${theme.styles.length} / 50 款</span></div>
              <div class="launch-style-list">${theme.styles.map((style, styleIndex) => launchStyleCard(style, `${path}:${styleIndex}`, styleIndex)).join('')}</div>
              ${theme.styles.length < 50 ? `<button class="launch-inline-add" type="button" data-launch-add-style="${path}">＋ 新增一个实际开发款</button>` : `<div class="launch-builder-empty">已达到本主题50款资料上限</div>`}
            </section>
            <section class="launch-work-panel white">
              <div class="launch-work-head"><div><div class="launch-work-title">视觉与推广建议</div><div class="launch-work-tip">补充产品上线所需的视觉呈现、站内外推广、人选及产品等级判断。</div></div><label class="launch-advice-link-field"><span>参考品牌产品链接</span><input class="launch-input" type="url" data-launch-advice-field="${path}:referenceProductUrl" value="${escapeHtml(typeof advice.referenceProductUrl === 'string' ? advice.referenceProductUrl : '')}" placeholder="粘贴品牌产品链接，输入后自动保存" autocomplete="url"></label></div>
              <div class="launch-advice-grid">
                ${launchVisualAdviceField(path, 'heroShoot', '主图 / 组图拍摄建议', '拍摄场景、模特、光线、构图、道具、佩戴特写和组图顺序建议', 'heroShootImages', '主图 / 组图视觉参考', advice.heroShoot, advice.heroShootImages)}
                ${launchVisualAdviceField(path, 'detailVisual', '详情页视觉风格建议', '页面色调、排版、卖点表达、材质细节、场景图和信任信息建议', 'detailVisualImages', '详情页视觉参考', advice.detailVisual, advice.detailVisualImages)}
                ${launchAdviceField(path, 'onsitePromotion', '站内推广建议', '搜索、推荐、内容种草、活动、关联搭配与人群投放建议', { value:advice.onsitePromotion })}
                ${launchAdviceField(path, 'offsitePromotion', '站外推广建议', '建议的平台、内容形式、传播节奏、场景切入和种草话术', { value:advice.offsitePromotion })}
                ${launchBloggerImageField(path, 'influencerImages', '适合合作的博主风格')}
                ${launchBloggerImageField(path, 'faceImages', '适合的博主脸型 / 气质')}
              </div>
            </section>
          </div>
        </div>
      `;
    }

    function launchScenePicker(scene, segmentIndex, sceneIndex) {
      const path = `${segmentIndex}:${sceneIndex}`;
      const selected = new Set(Array.isArray(scene.sceneSelections) ? scene.sceneSelections : []);
      const selectedCount = selected.size;
      const displayName = launchSceneDisplayName(scene) || scene.name || '';
      return `
        <div class="launch-scene-picker" data-launch-scene-picker="${path}">
          <div class="launch-scene-picker-main">
            <input class="launch-input launch-scene-display" data-launch-scene-name="${path}" value="${escapeHtml(displayName)}" placeholder="请从右侧菜单多选生活场景" readonly>
            <details class="launch-scene-dropdown">
              <summary><span>选择生活场景</span><b>${selectedCount ? `已选 ${selectedCount} 项` : '可多选'}</b></summary>
              <div class="launch-scene-menu">
                <div class="launch-scene-menu-head"><strong>核心生活场景 / 具体场合</strong><button type="button" data-launch-clear-scenes="${path}">清空选择</button></div>
                ${launchSceneOptions.map(group => `
                  <fieldset class="launch-scene-group">
                    <legend>${escapeHtml(group.core)}</legend>
                    <div class="launch-scene-option-grid">
                      ${group.occasions.map(occasion => {
                        const key = launchSceneKey(group.core, occasion);
                        return `<label class="launch-scene-option"><input type="checkbox" data-launch-scene-option="${path}" value="${escapeHtml(key)}" ${selected.has(key) ? 'checked' : ''}><span>${escapeHtml(occasion)}</span></label>`;
                      }).join('')}
                    </div>
                  </fieldset>
                `).join('')}
              </div>
            </details>
          </div>
          <input class="launch-input launch-scene-custom" data-launch-scene-custom="${path}" value="${escapeHtml(scene.sceneNameCustom || '')}" placeholder="可选：补充菜单外的自定义场景">
        </div>`;
    }

    function updateLaunchSceneFromControls(path, options = {}) {
      const [segmentIndex, sceneIndex] = launchPath(path);
      const scene = launchDraft?.segments?.[segmentIndex]?.scenes?.[sceneIndex];
      if (!scene) return;
      if (options.readSelections !== false) {
        scene.sceneSelections = [...launchModalBody.querySelectorAll(`[data-launch-scene-option="${path}"]:checked`)].map(input => input.value);
      }
      const customInput = launchModalBody.querySelector(`[data-launch-scene-custom="${path}"]`);
      if (customInput) scene.sceneNameCustom = customInput.value;
      scene.name = launchSceneDisplayName(scene);
      const display = launchModalBody.querySelector(`[data-launch-scene-name="${path}"]`);
      if (display) display.value = scene.name;
      const countBadge = launchModalBody.querySelector(`[data-launch-scene-picker="${path}"] .launch-scene-dropdown > summary b`);
      if (countBadge) countBadge.textContent = scene.sceneSelections.length ? `已选 ${scene.sceneSelections.length} 项` : '可多选';
    }

    function launchImportanceOption(level) {
      const meta = launchImportanceLevels[level];
      return `
        <label class="launch-priority-option" data-level="${level}">
          <input type="radio" name="launchImportanceLevel" data-launch-field="importanceLevel" value="${level}" ${launchDraft.importanceLevel === level ? 'checked' : ''}>
          <span class="launch-priority-card"><strong class="launch-priority-grade">${level}</strong><span class="launch-priority-name">${meta.name}</span><span class="launch-priority-desc">${meta.desc}</span></span>
        </label>
      `;
    }

    function launchDateRangeField(step, title, startField, endField) {
      return `
        <div class="launch-timeline-step" data-step="${step}">
          <div class="launch-timeline-step-title">${title}</div>
          <div class="launch-date-pair">
            <label class="launch-date-control"><span>开始日期</span><input class="launch-input" type="date" data-launch-field="${startField}" value="${escapeHtml(launchDraft[startField] || '')}"></label>
            <label class="launch-date-control"><span>结束日期</span><input class="launch-input" type="date" data-launch-field="${endField}" value="${escapeHtml(launchDraft[endField] || '')}"></label>
          </div>
        </div>
      `;
    }

    function launchAssortmentMatrixTemplate() {
      const matrix = normalizeAssortmentMatrix(launchDraft?.assortmentMatrix);
      const columnTotals = matrix.categories.map((_, columnIndex) => matrix.rows.reduce((total, row) => total + (Number(row.quantities[columnIndex]) || 0), 0));
      const grandTotal = columnTotals.reduce((total, value) => total + value, 0);
      return `
        <section class="launch-assortment-matrix">
          <div class="launch-assortment-head"><div><div class="launch-assortment-title">风格 × 品类开发矩阵</div><div class="launch-assortment-tip">填写5个品类、5种风格及交叉开发款数；主力价格段与元素按风格行记录。所有内容随开发计划保存到服务器。</div></div><span class="launch-subtle-badge">自动合计</span></div>
          <div class="launch-assortment-scroll"><table class="launch-assortment-table"><thead><tr>
            <th class="launch-assortment-corner"><span class="category-label">品类</span><span class="style-label">风格</span></th>
            ${matrix.categories.map((category, columnIndex) => `<th class="launch-assortment-category"><input class="launch-assortment-input" list="launch-options-category" data-launch-matrix-category="${columnIndex}" value="${escapeHtml(category)}" placeholder="品类${columnIndex + 1}" aria-label="品类${columnIndex + 1}"></th>`).join('')}
            <th class="launch-assortment-price">主力价格段</th><th class="launch-assortment-elements">元素</th>
          </tr></thead><tbody>
            ${matrix.rows.map((row, rowIndex) => `<tr>
              <th><input class="launch-assortment-input launch-assortment-style-input" list="launch-options-style" data-launch-matrix-style="${rowIndex}" value="${escapeHtml(row.style)}" placeholder="风格${rowIndex + 1}" aria-label="风格${rowIndex + 1}"></th>
              ${row.quantities.map((quantity, columnIndex) => `<td><input class="launch-assortment-input" type="number" min="0" step="1" data-launch-matrix-quantity="${rowIndex}:${columnIndex}" value="${escapeHtml(quantity)}" placeholder="0" aria-label="风格${rowIndex + 1}品类${columnIndex + 1}款数"></td>`).join('')}
              <td><input class="launch-assortment-input launch-assortment-text-input" data-launch-matrix-price="${rowIndex}" value="${escapeHtml(row.priceRange)}" placeholder="例如：150–199" aria-label="风格${rowIndex + 1}主力价格段"></td>
              <td><input class="launch-assortment-input launch-assortment-text-input" list="launch-options-elements" data-launch-matrix-elements="${rowIndex}" value="${escapeHtml(row.elements)}" placeholder="例如：星星、珍珠、锆石" aria-label="风格${rowIndex + 1}元素"></td>
            </tr>`).join('')}
            <tr><th class="launch-assortment-total-label">合计</th>${columnTotals.map(total => `<td class="launch-assortment-total" data-launch-matrix-column-total>${total}</td>`).join('')}<td class="launch-assortment-total" data-launch-matrix-grand-total>${grandTotal} 款</td><td class="launch-assortment-total-note">数量合计会根据交叉格实时更新</td></tr>
          </tbody></table></div>
        </section>`;
    }

    function launchSingleDateField(step, title, field, caption) {
      return `
        <div class="launch-timeline-step" data-step="${step}">
          <div class="launch-timeline-step-title">${title}</div>
          <div class="launch-date-single"><label class="launch-date-control"><span>${caption}</span><input class="launch-input" type="date" data-launch-field="${field}" value="${escapeHtml(launchDraft[field] || '')}"></label></div>
        </div>
      `;
    }

    function launchFeaturedProductCard(product, index, collection) {
      const canEdit = canEditLaunchPlan(launchDraft);
      const disabled = canEdit ? '' : ' disabled';
      const label = collection === 'homepage' ? '首页主推款' : '站外推广主推款';
      const image = product?.image || '';
      return `<article class="launch-featured-card${canEdit ? '' : ' collaboration-readonly'}">
        <div class="launch-featured-media">
          ${image ? `<button class="launch-image-preview" type="button" data-launch-preview-featured="${collection}|${index}" aria-label="放大查看${label} ${index + 1}"><img src="${escapeHtml(image)}" alt="${label} ${index + 1}"><span class="launch-image-zoom">点击放大</span></button><button class="launch-image-remove" type="button" data-launch-remove-featured="${collection}|${index}" aria-label="删除图片"${disabled}>×</button>` : `<label class="launch-image-add"><input type="file" accept="image/*" data-launch-featured-image="${collection}|${index}"${disabled}><span><strong>＋</strong><span>插入图片</span></span></label>`}
        </div>
        <div class="launch-featured-copy">
          <div class="launch-featured-index">${label} ${String(index + 1).padStart(2, '0')}</div>
          <label class="launch-featured-brief"><span>BRIEF｜产品简报</span><textarea class="launch-input" data-launch-featured-field="${collection}|${index}" maxlength="3000" placeholder="填写这款产品为什么适合首页主推或站外直播 / 达人推广，包括卖点、场景、搭配与选款理由。"${disabled}>${escapeHtml(product?.brief || '')}</textarea></label>
        </div>
      </article>`;
    }

    function launchFeaturedProductsBoard() {
      const homepage = launchDraft?.homepageFeaturedProducts || [];
      const offsite = launchDraft?.offsiteFeaturedProducts || [];
      const homepageSlots = Array.from({ length:6 }, (_, index) => homepage[index] || emptyFeaturedProduct());
      const offsiteSlots = Array.from({ length:10 }, (_, index) => offsite[index] || emptyFeaturedProduct());
      return `<section class="launch-featured-board">
        <div class="launch-featured-board-head"><div><div class="launch-featured-board-title">本期波段产品</div><div class="launch-featured-board-tip">集中记录本期波段需要重点曝光的产品；图片插入与产品简报修改后自动保存。</div></div><span class="launch-subtle-badge">首页 6 款 · 站外 10 款</span></div>
        <section class="launch-featured-section homepage-featured"><div class="launch-featured-section-head"><div><h3>首页主推款清单</h3><p>用于首页、店铺首屏和站内重点资源位展示，按两列图文组合呈现。</p></div><span class="launch-subtle-badge">6 款</span></div><div class="launch-featured-grid homepage-featured-grid">${homepageSlots.map((product, index) => launchFeaturedProductCard(product, index, 'homepage')).join('')}</div></section>
        <section class="launch-featured-section offsite-featured"><div class="launch-featured-section-head"><div><h3>站外推广主推款</h3><p>用于直播间与站外达人选款，BRIEF 中填写产品卖点、内容角度与推荐理由。</p></div><span class="launch-subtle-badge">10 款</span></div><div class="launch-featured-list">${offsiteSlots.map((product, index) => launchFeaturedProductCard(product, index, 'offsite')).join('')}</div></section>
      </section>`;
    }

    function launchTextEditorHasFocus() {
      const active = document.activeElement;
      if (!(active instanceof Element) || !launchModalBody.contains(active)) return false;
      return active.matches('textarea, input:not([type="file"]):not([type="radio"]):not([type="checkbox"]), [contenteditable="true"]');
    }

    function renderLaunchModal(options = {}) {
      if (!launchDraft) return;
      if (!options.force && (launchTextCompositionActive || launchTextEditorHasFocus())) {
        launchRenderQueued = true;
        return;
      }
      launchRenderQueued = false;
      const previousScrollTop = launchModalBody.scrollTop;
      launchModalTitle.textContent = editingLaunchId ? '编辑产品开发计划' : '新建产品开发计划';
      launchModalBody.innerHTML = `
        <section class="launch-priority-panel">
          <div class="launch-priority-head"><div><div class="launch-priority-title">上市波段重要性</div><div class="launch-priority-tip">采用 S/A/B/C 企划分级，比星级更便于团队统一判断资源、排期与推广投入。</div></div><span class="launch-subtle-badge">人为选择</span></div>
          <div class="launch-priority-layout">
            <div class="launch-priority-options">${Object.keys(launchImportanceLevels).map(launchImportanceOption).join('')}</div>
            <div class="launch-field launch-priority-reason"><label for="launchImportanceReason">重要性说明</label><textarea class="launch-input" id="launchImportanceReason" data-launch-field="importanceReason" maxlength="1000" placeholder="说明为什么定为这个等级，例如：品牌成立后的第一波货、为双11准备的核心货盘、三八女王节重点波段，或用于小规模测试的补充波段。">${escapeHtml(launchDraft.importanceReason || '')}</textarea></div>
          </div>
        </section>
        <div class="launch-basics">
          <div class="launch-field"><label for="launchPlanName">计划名称</label><input class="launch-input" id="launchPlanName" data-launch-field="name" value="${escapeHtml(launchDraft.name)}" placeholder="例如：2026秋季都市成长系列"></div>
        </div>
        <div class="launch-field launch-cycle-plan"><label for="launchCyclePlan">本周期改款规划</label><textarea class="launch-input" id="launchCyclePlan" data-launch-field="cyclePlan" maxlength="5000" placeholder="描述本月或本周期重点改款的风格及占比权重、重点元素、计划材质、预计总款量和整体改款节奏。">${escapeHtml(launchDraft.cyclePlan || '')}</textarea></div>
        ${launchAssortmentMatrixTemplate()}
        <section class="launch-timeline">
          <div class="launch-timeline-head"><div><div class="launch-timeline-title">波段开发时间轴</div><div class="launch-timeline-tip">先锁定总周期，再依次确定企划、产品设计、打样、大货与包装生产、视觉设计、推广、商品上架与正式上市节点。</div></div><span class="launch-subtle-badge">关键节点</span></div>
          <div class="launch-timeline-total">
            <div class="launch-timeline-step-title">整个波段开发周期</div>
            <div class="launch-date-pair">
              <label class="launch-date-control"><span>周期开始</span><input class="launch-input" type="date" data-launch-field="cycleStart" value="${escapeHtml(launchDraft.cycleStart || '')}"></label>
              <label class="launch-date-control"><span>周期结束</span><input class="launch-input" type="date" data-launch-field="cycleEnd" value="${escapeHtml(launchDraft.cycleEnd || '')}"></label>
            </div>
          </div>
          <div class="launch-timeline-grid">
            ${launchDateRangeField('01', '企划阶段', 'planningStart', 'planningEnd')}
            ${launchDateRangeField('02', '设计阶段', 'designStart', 'designEnd')}
            ${launchDateRangeField('03', '打样阶段', 'samplingStart', 'samplingEnd')}
            ${launchDateRangeField('04', '大货生产周期', 'bulkProductionStart', 'bulkProductionEnd')}
            ${launchDateRangeField('05', '包装生产周期', 'packagingProductionStart', 'packagingProductionEnd')}
            ${launchDateRangeField('06', '视觉设计周期', 'visualDesignStart', 'visualDesignEnd')}
            ${launchDateRangeField('07', '推广周期', 'promotionStart', 'promotionEnd')}
            ${launchDateRangeField('08', '商品上架周期', 'shelvingStart', 'shelvingEnd')}
            ${launchSingleDateField('09', '正式上市', 'launchDate', '正式开售日期')}
          </div>
        </section>
        ${launchCycleImageBoard()}
        ${launchColorAnalysisBoard()}
        <div class="launch-builder-note">四个主题风格板块统一建立“场景 → 主题 → 参考图与文字策划 → 具体款式”；百搭、基础、技术型和长期常销产品放入最下方“子波段基本款”，直接填写参考品牌、图片及产品资料。</div>
        <div class="launch-segment-builder">
          ${launchDraft.segments.map((segment, segmentIndex) => `
            <section class="launch-segment-panel">
              <div class="launch-segment-head"><span class="launch-segment-name">${segment.label}</span><button class="launch-add-btn" type="button" data-launch-add-scene="${segmentIndex}">＋ 新增场景</button></div>
              <div class="launch-scene-list">
                ${segment.scenes.length ? segment.scenes.map((scene, sceneIndex) => {
                  const sceneCollapseKey = scene.id || `${segmentIndex}:${sceneIndex}`;
                  const sceneCollapsed = launchCollapsedSceneIds.has(sceneCollapseKey);
                  const sceneSummary = `${scene.themes.length || 0} 个主题 · ${scene.themes.reduce((total, theme) => total + (theme.styles?.length || 0), 0)} 个开发款`;
                  return `
                  <article class="launch-scene${sceneCollapsed ? ' collapsed' : ''}">
                    <div class="launch-row"><button class="launch-collapse-btn" type="button" data-launch-toggle-scene="${escapeHtml(sceneCollapseKey)}" aria-expanded="${sceneCollapsed ? 'false' : 'true'}" aria-label="${sceneCollapsed ? '展开场景内容' : '收起场景内容'}">${sceneCollapsed ? '＋' : '−'}</button>${launchScenePicker(scene, segmentIndex, sceneIndex)}<button class="launch-remove-btn" type="button" data-launch-remove-scene="${segmentIndex}:${sceneIndex}" aria-label="删除场景">×</button></div>
                    ${sceneCollapsed ? `<div class="launch-collapse-summary">${escapeHtml(sceneSummary)} · 已收起</div>` : ''}
                    <div class="launch-theme-list">
                      ${scene.themes.map((theme, themeIndex) => launchThemeCard(theme, segmentIndex, sceneIndex, themeIndex)).join('')}
                    </div>
                    <button class="launch-inline-add" type="button" data-launch-add-theme="${segmentIndex}:${sceneIndex}">＋ 在这个场景下新增主题</button>
                  </article>
                `;
                }).join('') : `<div class="launch-builder-empty">这个风格板块还没有场景。点击“新增场景”开始建立本批产品。</div>`}
              </div>
            </section>
          `).join('')}
        </div>
        <section class="launch-basic-panel subwave-basic">
          <div class="launch-basic-head">
            <div class="launch-basic-head-copy"><div class="launch-basic-title">子波段基本款</div><div class="launch-basic-tip">用于百搭、基础、技术型或长期常销产品。可填写参考品牌、上传图片和文字，无需设置场景和主题。</div></div>
            <button class="launch-add-btn" type="button" data-launch-add-basic-product="subwave">＋ 新增基本款</button>
          </div>
          <div class="launch-basic-list">
            ${launchDraft.subwaveBasicProducts.length ? launchDraft.subwaveBasicProducts.map((product, productIndex) => launchBasicProductCard(product, productIndex, 'subwave')).join('') : `<div class="launch-builder-empty">还没有子波段基本款。点击“新增基本款”，建立参考品牌、参考图片、改款计划和最终产品资料。</div>`}
          </div>
        </section>
        ${launchFeaturedProductsBoard()}
        ${launchStandardDatalists()}
      `;
      if (!canEditLaunchPlan(launchDraft)) {
        launchModalBody.querySelectorAll('input, textarea, select, button[data-launch-add-scene], button[data-launch-add-theme], button[data-launch-add-style], button[data-launch-add-basic-product], button[data-launch-remove-scene], button[data-launch-remove-theme], button[data-launch-remove-style], button[data-launch-remove-basic-product], input[type="file"]').forEach(control => { control.disabled = true; });
        launchModalBody.classList.add('launch-readonly');
        launchSaveBtn.disabled = true;
        launchSaveBtn.title = '请先登录后再保存这份计划';
      } else {
        launchModalBody.classList.remove('launch-readonly');
        launchSaveBtn.disabled = false;
        launchSaveBtn.removeAttribute('title');
      }
      requestAnimationFrame(() => { launchModalBody.scrollTop = previousScrollTop; });
    }

    function openLaunchModal(planId = null) {
      const source = planId ? getLaunchPlans().find(plan => plan.id === planId) : null;
      editingLaunchId = source?.id || null;
      launchDraft = source ? normalizeLaunchPlan(JSON.parse(JSON.stringify(source))) : emptyLaunchPlan();
      launchDraftBaseline = JSON.stringify(launchDraft);
      launchCollapsedSceneIds.clear();
      launchCollapsedThemeIds.clear();
      renderLaunchModal();
      launchModalBackdrop.classList.add('show');
      document.body.style.overflow = 'hidden';
      startLaunchPresence(launchDraft.id);
    }

    function launchDraftHasChanges() { return Boolean(launchDraft && JSON.stringify(launchDraft) !== launchDraftBaseline); }

    function saveLaunchDraftLocally() {
      if (!launchDraft) return false;
      try {
        localStorage.setItem(`angelmyth-launch-draft-${launchDraft.id}`, JSON.stringify(launchDraft));
        return true;
      } catch {
        // 原始产品图可能超过 localStorage 容量；服务器自动保存仍会继续，不能把本机写入失败误报为已保存。
        return false;
      }
    }

    function scheduleLaunchDraftSave(delay = 650) {
      clearTimeout(launchDraftTimer);
      launchDraftTimer = setTimeout(() => {
        saveLaunchDraftLocally();
      }, Math.min(180, Math.max(0, delay)));
      clearTimeout(launchAutoSaveTimer);
      launchAutoSaveTimer = setTimeout(() => {
        if (launchTextCompositionActive) { scheduleLaunchDraftSave(delay); return; }
        if (launchDraftHasChanges()) void saveLaunchPlan(false, true);
      }, Math.max(0, delay));
    }

    function closeLaunchModal(force = false) {
      if (!force && launchSaveRunner) {
        toast.textContent = '内容正在保存到团队服务器，请等待保存完成后再关闭';
        toast.dataset.kind = 'error';
        toast.classList.add('show');
        return;
      }
      if (!force && launchDraftHasChanges() && !confirm('当前开发计划还有未正式保存的修改。确定放弃这些修改并关闭吗？')) return;
      clearTimeout(launchAutoSaveTimer);
      clearTimeout(launchSaveRetryTimer);
      launchSaveRequested = false;
      launchSaveCloseRequested = false;
      launchSaveInteractiveRequested = false;
      stopLaunchPresence();
      launchModalBackdrop.classList.remove('show');
      document.body.style.overflow = '';
      launchDraft = null;
      launchActivePasteTarget = '';
      launchHoveredPasteTarget = '';
      launchTextCompositionActive = false;
      launchRenderQueued = false;
      editingLaunchId = null;
      launchCollapsedSceneIds.clear();
      launchCollapsedThemeIds.clear();
    }

    function launchPath(value) { return value.split(':').map(Number); }

    function launchThemeAt(pathValue) {
      const [s, c, t] = launchPath(pathValue);
      return launchDraft?.segments?.[s]?.scenes?.[c]?.themes?.[t];
    }

    function launchBasicProductAt(pathValue) {
      const [collection = 'cold', indexValue = pathValue] = String(pathValue).includes(':') ? String(pathValue).split(':') : ['cold', pathValue];
      const products = collection === 'subwave' ? launchDraft?.subwaveBasicProducts : launchDraft?.basicProducts;
      return products?.[Number(indexValue)];
    }

    function launchBasicProductCollection(pathValue) {
      const [collection = 'cold'] = String(pathValue).includes(':') ? String(pathValue).split(':') : ['cold'];
      return collection === 'subwave' ? launchDraft?.subwaveBasicProducts : launchDraft?.basicProducts;
    }

    function compressLaunchImage(file, options = {}) {
      return new Promise((resolve, reject) => {
        if (!file?.type?.startsWith('image/')) { reject(new Error('请选择图片文件')); return; }
        const reader = new FileReader();
        reader.onerror = () => reject(new Error('图片读取失败'));
        reader.onload = () => {
          const image = new Image();
          image.onerror = () => reject(new Error('图片解析失败'));
          image.onload = () => {
            const maxSide = options.maxSide || 800;
            const scale = Math.min(1, maxSide / Math.max(image.naturalWidth, image.naturalHeight));
            const width = Math.max(1, Math.round(image.naturalWidth * scale));
            const height = Math.max(1, Math.round(image.naturalHeight * scale));
            const canvas = document.createElement('canvas');
            canvas.width = width;
            canvas.height = height;
            const context = canvas.getContext('2d');
            context.fillStyle = '#ffffff';
            context.fillRect(0, 0, width, height);
            context.drawImage(image, 0, 0, width, height);
            resolve(canvas.toDataURL('image/webp', options.quality || .74));
          };
          image.src = reader.result;
        };
        reader.readAsDataURL(file);
      });
    }

    function readLaunchImageOriginal(file) {
      return new Promise((resolve, reject) => {
        if (!file?.type?.startsWith('image/')) { reject(new Error('请选择图片文件')); return; }
        const reader = new FileReader();
        reader.onerror = () => reject(new Error('图片读取失败'));
        reader.onload = () => resolve(String(reader.result || ''));
        reader.readAsDataURL(file);
      });
    }

    function sendLaunchClipboardFilesToInput(targetValue, files) {
      if (!launchReferenceImageKinds.has(String(targetValue).split('|')[0])) throw new Error('只有参考类图片支持粘贴');
      const input = [...launchModalBody.querySelectorAll('[data-launch-image-input]')]
        .find(candidate => candidate.dataset.launchImageInput === targetValue);
      if (!input) throw new Error('当前参考图区已经达到图片数量上限');
      const transfer = new DataTransfer();
      files.forEach((file, index) => {
        if (!file?.type?.startsWith('image/')) return;
        const imageFile = file instanceof File ? file : new File([file], `clipboard-image-${index + 1}.png`, { type:file.type || 'image/png' });
        transfer.items.add(imageFile);
      });
      if (!transfer.files.length) throw new Error('剪贴板中没有可粘贴的图片');
      input.files = transfer.files;
      input.dispatchEvent(new Event('change', { bubbles:true }));
    }

    async function readLaunchClipboardImages() {
      if (!navigator.clipboard?.read) throw new Error('当前浏览器不支持点击读取剪贴板，请选中格子后按 Ctrl+V');
      const clipboardItems = await navigator.clipboard.read();
      const files = [];
      for (const item of clipboardItems) {
        for (const type of item.types.filter(value => value.startsWith('image/'))) files.push(await item.getType(type));
      }
      if (!files.length) throw new Error('剪贴板中没有图片，请先在其他页面右键复制图片');
      return files;
    }

    function syncLaunchRootFields() {
      launchModalBody.querySelectorAll('[data-launch-field]').forEach(control => {
        if ((control.type === 'radio' || control.type === 'checkbox') && !control.checked) return;
        launchDraft[control.dataset.launchField] = control.value;
      });
      launchModalBody.querySelectorAll('[data-launch-competitor-title]').forEach(control => {
        const group = launchDraft.competitorReferenceGroups?.[Number(control.dataset.launchCompetitorTitle)];
        if (group) group.title = control.value;
      });
      launchModalBody.querySelectorAll('[data-launch-competitor-brand]').forEach(control => {
        const group = launchDraft.competitorReferenceGroups?.[Number(control.dataset.launchCompetitorBrand)];
        if (group) group.brand = control.value;
      });
      const matrix = launchDraft.assortmentMatrix = normalizeAssortmentMatrix(launchDraft.assortmentMatrix);
      launchModalBody.querySelectorAll('[data-launch-matrix-category]').forEach(control => { matrix.categories[Number(control.dataset.launchMatrixCategory)] = control.value; });
      launchModalBody.querySelectorAll('[data-launch-matrix-style]').forEach(control => { matrix.rows[Number(control.dataset.launchMatrixStyle)].style = control.value; });
      launchModalBody.querySelectorAll('[data-launch-matrix-quantity]').forEach(control => {
        const [rowIndex, columnIndex] = control.dataset.launchMatrixQuantity.split(':').map(Number);
        matrix.rows[rowIndex].quantities[columnIndex] = control.value;
      });
      launchModalBody.querySelectorAll('[data-launch-matrix-price]').forEach(control => { matrix.rows[Number(control.dataset.launchMatrixPrice)].priceRange = control.value; });
      launchModalBody.querySelectorAll('[data-launch-matrix-elements]').forEach(control => { matrix.rows[Number(control.dataset.launchMatrixElements)].elements = control.value; });
    }

    function syncAllLaunchEditableControls() {
      if (!launchDraft) return;
      syncLaunchRootFields();
      launchModalBody.querySelectorAll('[data-launch-featured-field]').forEach(control => {
        const [collection, indexValue] = control.dataset.launchFeaturedField.split('|');
        const key = collection === 'homepage' ? 'homepageFeaturedProducts' : 'offsiteFeaturedProducts';
        launchDraft[key] ||= [];
        const index = Number(indexValue);
        while (launchDraft[key].length <= index) launchDraft[key].push(emptyFeaturedProduct());
        launchDraft[key][index].brief = control.value;
      });
      launchModalBody.querySelectorAll('[data-launch-scene-custom]').forEach(control => updateLaunchSceneFromControls(control.dataset.launchSceneCustom, { readSelections:true }));
      launchModalBody.querySelectorAll('[data-launch-theme-name]').forEach(control => {
        const [s, c, t] = launchPath(control.dataset.launchThemeName);
        const theme = launchDraft.segments?.[s]?.scenes?.[c]?.themes?.[t];
        if (theme) theme.name = control.value;
      });
      launchModalBody.querySelectorAll('[data-launch-theme-field]').forEach(control => {
        const parts = control.dataset.launchThemeField.split(':');
        const fieldName = parts.pop();
        const theme = launchThemeAt(parts.join(':'));
        if (theme && fieldName) theme[fieldName] = control.value;
      });
      launchModalBody.querySelectorAll('[data-launch-advice-field]').forEach(control => {
        const parts = control.dataset.launchAdviceField.split(':');
        const fieldName = parts.pop();
        const theme = launchThemeAt(parts.join(':'));
        if (theme && fieldName) { theme.advice ||= {}; theme.advice[fieldName] = control.value; }
      });
      launchModalBody.querySelectorAll('[data-launch-style-name]').forEach(control => {
        const [s, c, t, p] = launchPath(control.dataset.launchStyleName);
        const style = launchDraft.segments?.[s]?.scenes?.[c]?.themes?.[t]?.styles?.[p];
        if (style) style.name = control.value;
      });
      launchModalBody.querySelectorAll('[data-launch-style-field]').forEach(control => {
        const parts = control.dataset.launchStyleField.split(':');
        const fieldName = parts.pop();
        const [s, c, t, p] = parts.map(Number);
        const style = launchDraft.segments?.[s]?.scenes?.[c]?.themes?.[t]?.styles?.[p];
        if (style && fieldName) style[fieldName] = control.value;
      });
      launchModalBody.querySelectorAll('[data-launch-basic-name]').forEach(control => {
        const product = launchBasicProductAt(control.dataset.launchBasicName);
        if (product) product.name = control.value;
      });
      launchModalBody.querySelectorAll('[data-launch-basic-field]').forEach(control => {
        const parts = control.dataset.launchBasicField.split(':');
        const fieldName = parts.pop();
        const product = launchBasicProductAt(parts.join(':'));
        if (product && fieldName) product[fieldName] = control.value;
      });
    }

    const launchDateRules = [
      ['cycleStart','cycleEnd','整个波段开发周期'], ['planningStart','planningEnd','企划阶段'],
      ['designStart','designEnd','设计阶段'], ['samplingStart','samplingEnd','打样阶段'],
      ['bulkProductionStart','bulkProductionEnd','大货生产周期'], ['packagingProductionStart','packagingProductionEnd','包装生产周期'],
      ['visualDesignStart','visualDesignEnd','视觉设计周期'], ['promotionStart','promotionEnd','推广周期'],
      ['shelvingStart','shelvingEnd','商品上架周期']
    ];

    function validateLaunchTimeline(plan) {
      for (const [startField, endField, label] of launchDateRules) {
        if (plan[startField] && plan[endField] && plan[startField] > plan[endField]) return `${label}的开始日期不能晚于结束日期`;
      }
      const ordered = [
        ['planningEnd','designStart','企划结束日期不能晚于设计开始日期'],
        ['designEnd','samplingStart','设计结束日期不能晚于打样开始日期'],
        ['samplingEnd','bulkProductionStart','打样结束日期不能晚于大货生产开始日期'],
        ['shelvingEnd','launchDate','商品上架结束日期不能晚于正式上市日期']
      ];
      for (const [before, after, message] of ordered) if (plan[before] && plan[after] && plan[before] > plan[after]) return message;
      // 推广周期可以早于或延续到整体开发周期之外；其他节点必须落在整体开发周期内。
      // 例如当前企划的 promotionEnd 为 2026-10-21，这是允许的售后推广安排。
      if (plan.cycleStart && plan.cycleEnd) {
        for (const [field, value] of Object.entries(plan)) {
          if (field === 'promotionStart' || field === 'promotionEnd' || !/(Start|End|Date)$/.test(field) || !value || typeof value !== 'string') continue;
          if (value < plan.cycleStart || value > plan.cycleEnd) return `${field}超出了整个波段开发周期`;
        }
      }
      return '';
    }

    function updateLaunchAssortmentTotals() {
      const matrix = normalizeAssortmentMatrix(launchDraft?.assortmentMatrix);
      const totals = matrix.categories.map((_, columnIndex) => matrix.rows.reduce((sum, row) => sum + (Number(row.quantities[columnIndex]) || 0), 0));
      launchModalBody.querySelectorAll('[data-launch-matrix-column-total]').forEach((cell, columnIndex) => { cell.textContent = formatProfitNumber(totals[columnIndex]); });
      const grandTotal = totals.reduce((sum, value) => sum + value, 0);
      const grandTotalCell = launchModalBody.querySelector('[data-launch-matrix-grand-total]');
      if (grandTotalCell) grandTotalCell.textContent = `${formatProfitNumber(grandTotal)} 款`;
    }

    function isLaunchRecord(value) {
      return Boolean(value && typeof value === 'object' && !Array.isArray(value));
    }

    function isLaunchImageStoragePath(path) {
      return /(?:^|\.)(?:image|images|[A-Za-z]*Images)(?:\.|\[|$)/.test(path);
    }

    // The server response may include collaboration merges or arrive after a
    // slower image upload. Keep server-side URLs and untouched collaborator
    // fields, but never let that response shorten or erase text this browser
    // explicitly changed since its last confirmed server snapshot.
    function mergeLaunchSavedDraftWithLocalText(base, local, saved, path = '') {
      if (typeof local === 'string') {
        if (isLaunchImageStoragePath(path)) return saved;
        return local !== base ? local : saved;
      }
      if (Array.isArray(local) && Array.isArray(saved)) {
        if (isLaunchImageStoragePath(path)) return saved;
        const localEntities = new Map(local.filter(item => isLaunchRecord(item) && typeof item.id === 'string').map(item => [String(item.id), item]));
        const baseEntities = new Map((Array.isArray(base) ? base : []).filter(item => isLaunchRecord(item) && typeof item.id === 'string').map(item => [String(item.id), item]));
        if (localEntities.size || saved.some(item => isLaunchRecord(item) && typeof item.id === 'string')) {
          return saved.map((savedItem, index) => {
            if (!isLaunchRecord(savedItem) || typeof savedItem.id !== 'string') return savedItem;
            const localItem = localEntities.get(String(savedItem.id));
            return localItem ? mergeLaunchSavedDraftWithLocalText(baseEntities.get(String(savedItem.id)), localItem, savedItem, `${path}[${savedItem.id}]`) : savedItem;
          });
        }
        return saved.map((savedItem, index) => index < local.length
          ? mergeLaunchSavedDraftWithLocalText(Array.isArray(base) ? base[index] : undefined, local[index], savedItem, `${path}[${index}]`)
          : savedItem);
      }
      if (isLaunchRecord(local) && isLaunchRecord(saved)) {
        const result = { ...saved };
        const keys = new Set([...Object.keys(isLaunchRecord(base) ? base : {}), ...Object.keys(local), ...Object.keys(saved)]);
        keys.forEach(key => {
          result[key] = mergeLaunchSavedDraftWithLocalText(isLaunchRecord(base) ? base[key] : undefined, local[key], saved[key], path ? `${path}.${key}` : key);
        });
        return result;
      }
      return saved;
    }

    async function persistLaunchPlan(interactive = false) {
      if (!launchDraft || !canEditLaunchPlan(launchDraft)) {
        toast.textContent = '请先登录后再保存这份计划';
        toast.dataset.kind = 'error';
        toast.classList.add('show');
        return false;
      }
      syncAllLaunchEditableControls();
      const timelineError = validateLaunchTimeline(launchDraft);
      if (timelineError) {
        toast.textContent = timelineError;
        toast.dataset.kind = 'error';
        toast.classList.add('show');
        return false;
      }
      launchDraft.cycleReferenceImages = flattenCompetitorReferenceImages(launchDraft);
      launchDraft.name = launchDraft.name.trim() || `${formatLaunchDate(launchDraft.launchDate)} 产品开发计划`;
      launchDraft.updatedAt = new Date().toISOString();
      toast.dataset.kind = '';
      toast.textContent = interactive ? '正在执行最终保存并校验服务器记录…' : '正在自动保存到团队服务器…';
      toast.classList.add('show');
      try {
        const submittedSnapshot = JSON.stringify(launchDraft);
        const submittedDraft = JSON.parse(submittedSnapshot);
        let baselineDraft = {};
        try { baselineDraft = JSON.parse(launchDraftBaseline || '{}'); } catch { baselineDraft = {}; }
        const saved = await appLaunchPlanClient.save(submittedDraft);
        const plans = getLaunchPlans();
        const index = plans.findIndex(plan => plan.id === launchDraft.id);
        const normalized = normalizeLaunchPlan(saved.data);
        index >= 0 ? plans.splice(index, 1, normalized) : plans.push(normalized);
        if (saved.savedOffline) {
          toast.textContent = saved.sessionExpired
            ? '登录已过期：内容仅保存在本机，尚未写入团队服务器。请重新登录后再次保存'
            : '服务器暂时不可用：内容仅保存在本机，系统将继续重试';
          toast.dataset.kind = 'error';
          toast.classList.add('show');
          if (saved.sessionExpired) window.dispatchEvent(new CustomEvent('angelmyth:auth-expired'));
          clearTimeout(launchSaveRetryTimer);
          if (!saved.sessionExpired) launchSaveRetryTimer = setTimeout(() => { if (launchDraftHasChanges()) void saveLaunchPlan(false, true); }, 5000);
          return false;
        }
        localStorage.removeItem(`angelmyth-launch-draft-${launchDraft.id}`);
        if (JSON.stringify(launchDraft) === submittedSnapshot) {
          launchDraft = normalizeLaunchPlan(mergeLaunchSavedDraftWithLocalText(baselineDraft, submittedDraft, normalized));
          launchDraftBaseline = JSON.stringify(launchDraft);
        } else launchSaveRequested = true;
        toast.textContent = saved.resolvedConflicts?.length
          ? '已保存到服务器；同一字段发生并发修改，已按最后保存者更新'
          : saved.autoMerged ? '已保存到服务器，并合并了其他同事同时修改的内容' : '已保存到团队服务器';
        toast.dataset.kind = '';
        return true;
      } catch (error) {
        toast.textContent = `${error.message || '保存失败'}；内容尚未写入团队服务器，系统将自动重试`;
        toast.dataset.kind = 'error';
        toast.classList.add('show');
        clearTimeout(launchSaveRetryTimer);
        launchSaveRetryTimer = setTimeout(() => { if (launchDraftHasChanges()) void saveLaunchPlan(false, true); }, 5000);
        return false;
      }
    }

    function saveLaunchPlan(closeAfterSave = true, silent = false) {
      launchSaveRequested = true;
      launchSaveCloseRequested ||= closeAfterSave;
      launchSaveInteractiveRequested ||= !silent;
      if (launchSaveRunner) return launchSaveRunner;
      launchSaveRunner = (async () => {
        let closeWhenComplete = false;
        let latestServerSaveSucceeded = false;
        try {
          while (launchSaveRequested && launchDraft) {
            const interactive = launchSaveInteractiveRequested;
            closeWhenComplete ||= launchSaveCloseRequested;
            launchSaveRequested = false;
            launchSaveCloseRequested = false;
            launchSaveInteractiveRequested = false;
            if (interactive) launchSaveBtn.disabled = true;
            latestServerSaveSucceeded = await persistLaunchPlan(interactive);
            if (!latestServerSaveSucceeded) { closeWhenComplete = false; break; }
            if (launchDraftHasChanges()) launchSaveRequested = true;
          }
          if (closeWhenComplete && latestServerSaveSucceeded && launchDraft && !launchDraftHasChanges()) {
            closeLaunchModal(true);
            if (currentId === 'product-launch') await navigate('product-launch', false);
          }
        } finally {
          launchSaveRunner = null;
          if (launchDraft && canEditLaunchPlan(launchDraft)) launchSaveBtn.disabled = false;
          if (latestServerSaveSucceeded) {
            clearTimeout(saveState.timer);
            saveState.timer = setTimeout(() => toast.classList.remove('show'), 2200);
          }
          if (launchSaveRequested && launchDraft) queueMicrotask(() => { void saveLaunchPlan(launchSaveCloseRequested, !launchSaveInteractiveRequested); });
        }
      })();
      return launchSaveRunner;
    }

    function renderNav() {
      navList.innerHTML = sections.map((section, index) => `
        <button class="nav-item ${section.id === currentId ? 'active' : ''}" type="button" data-target="${section.id}">
          <span class="nav-no">${String(index).padStart(2, '0')}</span>
          <span class="nav-text">${section.label}</span>
        </button>
      `).join('');
    }

    function homeTemplate() {
      const frameworks = sections.slice(1);
      return `
        <section>
          <div class="page-kicker">ANGELMYTH / BRAND STRATEGY</div>
          <h1 class="page-title">${sections[0].title}</h1>
          <p class="page-lede">${sections[0].summary}</p>
          <div class="hero-meta">
            <div class="meta-cell"><div class="meta-label">Project / 项目</div><div class="meta-value">品牌设计企划<br>系统搭建</div></div>
            <div class="meta-cell"><div class="meta-label">Framework / 框架</div><div class="meta-value">13 个核心<br>决策模块</div></div>
            <div class="meta-cell"><div class="meta-label">Brand Spirit / 品牌精神</div><div class="meta-value">从模仿到判断<br>从选择到表达</div></div>
          </div>
          <section class="age-system">
            <div class="age-system-head">
              <h2 class="age-system-title">三年龄段产品货盘</h2>
              <div class="age-system-note">24–28岁为核心人群；材质与价格随年龄逐步升级</div>
            </div>
            <div class="age-bar">
              <div class="young">18–24岁 · 15%</div>
              <div class="core">24–28岁 · 60% 核心人群</div>
              <div class="mature">28–35岁 · 25%</div>
            </div>
            <div class="age-cards">
              <article class="age-card young"><h3>18–24岁 · 潮流入门</h3><p>校园至初入职场，以轻量、易搭配和快速趋势为核心，承担品牌年轻化与低门槛触达。</p><strong>韩系甜酷 / 法式甜美 / 多巴胺</strong><div class="age-card-meta"><div><b>主力价格：</b>¥70–149</div><div><b>材质重点：</b>合金电镀、珐琅树脂、仿珍珠与锆石</div><div><b>产品：</b>迷你耳钉、小耳圈、细链项链、小体量手链</div></div></article>
              <article class="age-card core"><h3>24–28岁 · 精致进阶</h3><p>品牌主力成交人群，以精致金属、锆石与珍珠成套为核心，覆盖通勤、约会和社交。</p><strong>都市精致轻奢 / 法式浪漫 / 韩系甜美去幼态</strong><div class="age-card-meta"><div><b>主力价格：</b>¥100–199</div><div><b>材质重点：</b>精致电镀金属、锆石水晶、珍珠贝珠</div><div><b>产品：</b>耳环、项链、手链成套开发，强化系列识别</div></div></article>
              <article class="age-card mature"><h3>28–35岁 · 真实质感</h3><p>强调高完成度、真实珍珠、天然石与成套产品，承接礼赠、旅行、宴会和成熟通勤。</p><strong>都市优雅轻奢 / 法式浪漫 / 新中式简约设计</strong><div class="age-card-meta"><div><b>主力价格：</b>¥150–299</div><div><b>材质重点：</b>天然珍珠、贝珠、天然石、高质感电镀</div><div><b>产品：</b>耳环＋项链＋手链完整套组，体量与材质感升级</div></div></article>
            </div>
            <div class="development-model">
              <div class="development-model-head"><h3 class="development-model-title">产品开发模式</h3><div class="development-model-note">所有产品均经过品牌化再开发</div></div>
              <div class="development-model-grid">
                <article class="development-mode adaptation"><div class="development-mode-share">80%</div><div class="development-mode-name">市场爆款改款</div><div class="development-mode-copy">基于平台趋势与畅销结构，调整比例、元素、材质、色彩、组合方式和价格带，快速形成符合 AngelMyth 审美与品质要求的转化款。</div></article>
                <article class="development-mode original"><div class="development-mode-share">20%</div><div class="development-mode-name">自主设计</div><div class="development-mode-copy">围绕品牌故事、超级符号与系列识别开发原创形象款，建立长期品牌资产。</div></article>
              </div>
              <div class="development-rule">开发原则：80%负责市场反应速度、成交效率与稳定上新；20%负责品牌辨识度、系列认知与设计资产沉淀。市场趋势只作为选款与改款依据，最终产品必须符合 AngelMyth 的设计、材质与品质标准。</div>
            </div>
          </section>
        </section>
        <section class="section-block">
          <div class="section-head">
            <h2 class="section-title">企划系统全景</h2>
            <div class="section-note">从品牌内核 → 消费洞察 → 产品表达 → 商业增长</div>
          </div>
          <div class="framework-grid">
            ${frameworks.map((item, i) => `
              <article class="framework-card">
                <div class="framework-index">${String(i + 1).padStart(2, '0')}</div>
                <div>
                  <h3 class="framework-name">${item.label}</h3>
                  <p class="framework-desc">${item.summary}</p>
                  <button class="framework-link" type="button" data-target="${item.id}">进入模块 →</button>
                </div>
              </article>
            `).join('')}
          </div>
        </section>
      `;
    }

    function storyTemplate() {
      return `
        <section>
          <div class="segment-strip" aria-hidden="true"><span class="young"></span><span class="core"></span><span class="mature"></span></div>
          <div class="story-hero">
            <div class="page-kicker">PROLOGUE / BRAND STORY</div>
            <h1 class="story-title">她试过许多人的样子，<br>最后成为了<em>自己</em>。</h1>
            <div class="story-years"><span>SEOUL / GROWING UP</span><strong>18—28</strong></div>
            <p class="story-deck">她是生活在首尔的普通女孩。黑色长发、安静的鹅蛋脸，让她看起来有一点冷；那既是天生的轮廓，也是面对陌生世界时的保护色。真正靠近她的人知道，她的内心始终柔软、热情而有温度。十年之间，城市、关系、收入与穿着都在改变，唯一不变的是：她没有把定义自己的权利交给别人。</p>
          </div>

          <article class="story-article">
            <div class="story-article-meta">
              <div class="article-label">The Full Story / 完整故事</div>
              <div class="article-place">Seoul<br>From eighteen<br>to twenty-eight</div>
            </div>
            <div class="story-article-body">
              <div class="brand-origin-prologue">
                <div class="brand-origin-label">Brand Origin / 品牌缘起</div>
                <p class="brand-origin-copy"><strong>AngelMyth 由韩国独立设计师创立，灵感源于首尔年轻女性不断变化的都市生活。</strong></p>
                <p class="brand-origin-copy">我们相信，女性从来不止一种样子。她可以温柔，也可以锋利；可以安静，也可以闪耀。品牌以珍珠的柔光、金属的利落，以及可叠戴、可转换的结构为设计语言，将首尔都市的极简、甜酷与松弛融入日常饰品。</p>
                <p class="brand-origin-copy">AngelMyth 不替女性定义风格，只为她创造表达不同自我的更多可能。这份相信并非一句抽象宣言，而是来自一个女孩从十八岁走向二十八岁的十年变化。</p>
              </div>
              <h2 class="article-title">她成为自己的十年</h2>
              <p class="article-lead">十八岁那年，她走进首尔的大学校园。她还不知道十年后的自己会是什么样子，也不知道一个女孩要经历多少次模仿、犹豫、选择和放弃，才能真正说出：这就是我。</p>

              <h3 class="article-turn">01 / 十八岁，首尔的春天</h3>
              <p class="article-copy">她出生在首尔一个生活稳定、受教育程度较高的家庭。父母都在各自的专业领域拥有稳定的职业，家里有书、有音乐，也有让她接触绘画、运动和不同审美的条件。他们愿意支持女儿的兴趣，却不会替她规划一条标准答案般的人生。考进大学依然需要她自己努力，因为优渥的家庭背景只能提供起点，不能代替她穿过韩国社会真实的学业压力与竞争。她偶尔去兼职，不是为了填补家里的生活缺口，而是想提前认识社会、获得自己的经验，也让自己在父母的保护之外长出独立感。</p>
              <p class="article-copy">她有一头黑色长发，一张安静的鹅蛋脸，身形修长。不开口时，她的轮廓带着一点天然的冷感；遇见陌生人，她又会本能地少说话，把安静当成保护自己的边界。于是很多人第一次见她，会觉得她冷冰冰的、酷酷的，甚至有些难以靠近。可真正成为她的朋友以后，才会看见另一面的她：笑起来有漂亮的酒窝，愿意认真听人说话，也会分享音乐、画和那些细碎但热烈的心情。她不是没有温度，只是从不轻易把温度交给陌生世界。</p>
              <p class="article-copy">学业之外，她喜欢音乐，会弹钢琴，也愿意尝试小提琴；她喜欢画画、游泳，喜欢和朋友去运动，也喜欢坐在篮球场边看男生打球。校园的林荫道上，她会和喜欢的人慢慢散步；去校外餐厅约会前，她会在宿舍里反复换衣服，研究该化怎样的妆、戴哪一对耳环、项链应该单戴还是叠戴。那时的认真里有青涩的忐忑，她当然在意对方是否觉得她漂亮，但那并不只是取悦。她是在学习如何郑重地赴一场约，也是在学习如何珍惜当下的自己。</p>
              <p class="article-copy">她也和许多同龄女孩一样喜欢女团。舞台上的女孩似乎永远知道怎样看镜头、怎样走路、怎样让一件衣服和一副耳环变成自己的气场。她会模仿冷感主角锋利而克制的妆容，也会模仿甜美女孩精致的千金感，还会尝试充满速度和力量的运动舞台风。她并不总能驾驭得好，有时妆画得太重，有时饰品和衣服互相争抢，有时只是照着喜欢的人买下相似的东西。但模仿从来不是她成长中的错误。对于一个还没有形成审美判断的女孩来说，那是她借来的第一套表达词汇。</p>
              <p class="article-copy">平日里，她穿卫衣、T恤、牛仔裤和球鞋，戴一枚小耳钉或一条细链；和朋友逛街时，她会把自己打扮得更像想象中的千金女孩；偶尔在亲近朋友带领下去KTV、聚会或夜店，她又会穿上皮衣、短裙或更有攻击性的衣服，用醒目的耳环、叠戴项链和组戒，试着成为那个冷冽、性感、敢于站在人群中央的自己。甜美、运动、朋克、冷酷并不彼此冲突。它们都是她在问同一个问题：我还可以是什么样子？</p>

              <h3 class="article-turn">02 / 二十二岁，玻璃幕墙后的第一份工作</h3>
              <p class="article-copy">二十二岁以后，她离开校园，进入首尔一家节奏很快的电子与跨境电商公司实习。第一天走进写字楼，她几乎听不懂会议里的人为什么争论，也不明白每个人为什么总在赶时间。她从打印文件、整理材料、准备会议、倒水和处理琐碎事务开始。她会做错，会紧张，会在需要主动开口时反复组织句子。离开熟悉的校园以后，她第一次清楚地感觉到，世界不会因为她尚未准备好就放慢速度。</p>
              <p class="article-copy">她开始收起学生时代最熟悉的卫衣和运动裤，笨拙地学习穿西装、衬衫和职业装；她把长发扎起或盘起，让妆容从模仿舞台的浓烈变得干净、克制。刚入职场时，她的收入还没有完全匹配自己的审美期待，于是先用价格克制、适合试错的基础饰品，观察公司里那些成熟的前辈：她们如何把颜色控制在恰当的范围，如何用一枚耳钉、一条细项链或一枚素戒，让自己看上去利落而不单调。她仍然在模仿，只是参照物从舞台上的偶像，变成了现实世界里能够从容处理工作的人。</p>
              <p class="article-copy">慢慢地，她发现所谓收敛并不是抹掉自己，而是理解场合。早晨通勤和办公室会议里，她选择干净的小耳钉、线条明确的项链与不妨碍工作的戒指；下班去吃饭或见闺蜜时，她会在基础项链上加一条点缀链，换上一副更醒目的耳环，让自己从白天的秩序里松开一点；周末运动、逛街、约会或窝在家中时，她仍然可以穿回喜欢的T恤、短裙和球鞋，戴轻巧、舒服、带一点甜感的首饰。</p>
              <p class="article-copy">工作也在改变她。她从不敢打断别人，到能够清楚地表达意见；从害怕陌生人的目光，到能够独立处理客户、同事和突发问题。她的脸依旧带着冷感，她在不熟悉的人面前也依旧不会变得喧闹，但那层安静不再只是防御。它逐渐成为一种稳定：她知道自己可以不讨好所有人，也知道真正的温柔不需要靠取悦来证明。</p>

              <h3 class="article-turn">03 / 二十五岁以后，她开始选择</h3>
              <p class="article-copy">工作两三年后，她熟悉了业务，也开始承担管理责任。职位和收入一点点上升，她终于可以买下过去只能远远看着的东西。她会攒几个月的钱买一个有品牌标识的包，也会为一双好看的高跟鞋心动。身边的人拥有大牌，她也希望拥有，这是她真实经历过的人生阶段。她不需要假装自己从来不在意，也没有必要把这种渴望包装成错误。对当时的她来说，品牌意味着品质，也意味着某种终于进入成人世界的确认感。</p>
              <p class="article-copy">但见过更多、买过更多以后，她的注意力开始改变。她不再只问“这是什么牌子”，而会看材质是否舒适、做工是否细致、线条是否适合自己的脸和身形，也会思考一件东西究竟能进入多少真实生活。她开始知道，贵并不自动等于适合，流行也不等于必须拥有。曾经借来的审美，正在一次次购买、搭配和使用中，变成她自己的判断。</p>
              <p class="article-copy">办公室里，她用结构清晰、材质更好的饰品配合职业装，让自己显得专业却不失辨识度；周末和朋友运动，她可以重新穿上卫衣和球鞋，只留下一点轻巧的金属光泽；去看话剧、参加聚会或赴一场认真准备的约会，她会穿得更隆重，让珍珠、天然石和叠戴项链跟着光线改变情绪；与闺蜜见面的夜晚，她可以甜美，也可以性感、冷酷和耀眼。她还是会精心打扮，却越来越少依赖别人的赞美。她知道自己的美在哪里，也知道今天想让哪一部分自己被看见。</p>
              <p class="article-copy">她最常为自己买饰品。有时是完成一个辛苦项目后的奖励，有时只是某条项链恰好适合下周的聚会。她也会和闺蜜在生日、纪念日或一次普通的见面里互赠小首饰，把一段共同经历留在彼此身上。她喜欢组合的方式：一条素链可以独自安静，也可以加入第二条、第三条项链；一枚素戒可以与点缀戒叠在同一根手指；手镯和不同质感的手链可以随着场合重新排列。组合让同一件饰品拥有不同语气，也让她保留随时改变表达的权利。</p>
              <p class="article-copy">二十八岁并不是故事规定的终点。她可能正在恋爱，也可能更享受独处；她可能继续向上工作，也可能重新选择生活的节奏。爱情、事业、朋友、运动和城市夜晚都是她人生的一部分，却没有任何一个部分能够替她定义全部。十年里，变化最快的从来不是她身边的人，而是她自己。</p>
              <p class="article-ending">她没有从普通女孩变成供人仰望的传奇。她只是终于不再等待别人告诉她该成为什么人。冰冷轮廓下的温度没有被竞争磨掉，反而在一次次选择中长出了翅膀。她试过许多人的样子，最后拥有了决定自己样子的自由。她佩戴的从来不只是饰品，而是由自己选择、亲手写下的成长——<strong>佩戴属于你的神话。</strong></p>
            </div>
          </article>

          <div class="story-analysis-head">
            <div class="analysis-label">Interpretation / 故事提炼</div>
            <h2 class="analysis-title">故事讲完以后，我们再看她的十年究竟为 AngelMyth 留下了什么。</h2>
          </div>

          <div class="story-thesis">
            <article class="thesis-item">
              <div class="thesis-label">起点 / Imitation</div>
              <h2 class="thesis-title">先借来一种表达</h2>
              <p class="thesis-copy">当她还不知道什么适合自己，女团舞台、同龄人的穿搭与城市潮流，就是她认识风格的第一套词汇。</p>
            </article>
            <article class="thesis-item">
              <div class="thesis-label">过程 / Exploration</div>
              <h2 class="thesis-title">在场景里反复尝试</h2>
              <p class="thesis-copy">校园、约会、通勤、聚会与独处需要不同的自己。每一次搭配，都是对身份、关系与情绪的真实练习。</p>
            </article>
            <article class="thesis-item">
              <div class="thesis-label">抵达 / Expression</div>
              <h2 class="thesis-title">建立自己的判断</h2>
              <p class="thesis-copy">成长不是固定成一种风格，而是知道何时选择什么，并能自在地表达甜、酷、柔软、锋利与专业。</p>
            </article>
          </div>
        </section>

        <section class="story-section">
          <div class="story-section-head">
            <div class="story-section-kicker">Story Synopsis / 故事梗概</div>
            <h2 class="story-section-title">十年不是把她变成某一种人，而是让她拥有选择每一种自己的能力。</h2>
          </div>
          <div class="story-synopsis">
            <div class="synopsis-label">Seoul · 18—28</div>
            <p class="synopsis-copy">她从首尔校园里那个青涩、敏感、偶尔模仿偶像的女孩，走进节奏紧张的写字楼；从不知道该穿什么、怎样与人相处，到能够判断材质、做工、场合和自己真正的需要。她曾经渴望大牌带来的确认感，也亲自走过那个阶段；后来，她不再只问“这是什么牌子”，而会问“它是否适合此刻的我”。她的成长不是一场供人羡慕的成功传奇，而是一个普通女孩亲手获得审美、判断与生活选择权的过程。</p>
          </div>

          <article class="story-stage age-young">
            <div>
              <div class="stage-age">18—21</div>
              <div class="stage-place">Campus / Seoul</div>
            </div>
            <div>
              <h3 class="stage-title">她先从模仿开始，学习美的不同语法。</h3>
              <p class="stage-copy">大学生活并不轻松。稳定的家庭给了她探索兴趣的空间，却没有替她完成成长。她把大部分时间留给课堂、图书馆与兼职，也会去琴房弹琴、画室画画、泳池练习，和朋友在篮球场边消磨傍晚。黑长直和安静的表情使她在人群里显得冷冽；面对陌生人时，她也习惯少说话来保护自己。但在熟悉的朋友面前，她会露出酒窝，是热情、可爱、甚至有一点闹腾的甜妹。像许多韩国女孩一样，她关注女团舞台：她学酷感主角的冷冽妆容，也学甜美女孩的千金感，还试过更有运动张力的舞台穿搭。模仿不是错误，而是她建立风格认知的起点。</p>
              <div class="stage-scenes">
                <div class="scene-note"><h4 class="scene-name">图书馆与课堂</h4><p class="scene-style">卫衣、T恤、牛仔裤；小耳钉、细链与轻巧点缀，安静而不失甜感。</p></div>
                <div class="scene-note"><h4 class="scene-name">林荫散步与约会</h4><p class="scene-style">精心挑选裙装、妆容和叠戴项链。青涩的在意，是尊重对方，也是认真对待自己。</p></div>
                <div class="scene-note"><h4 class="scene-name">逛街、KTV与派对</h4><p class="scene-style">在甜美千金、冷酷性感、朋克机车之间切换，用夸张耳饰和组戒试探不同的自己。</p></div>
              </div>
            </div>
          </article>

          <article class="story-stage age-core">
            <div>
              <div class="stage-age">22—24</div>
              <div class="stage-place">First Job / Seoul</div>
            </div>
            <div>
              <h3 class="stage-title">走进职场，她开始理解收敛并不等于失去自己。</h3>
              <p class="stage-copy">她进入一家节奏很快的电子与跨境电商公司，从整理文件、打印材料和会议准备开始。最初的她笨拙、紧张，不懂同事为什么总在赶时间，也不知道怎样自然地融入谈话。她脱下熟悉的运动裤与卫衣，学着穿西装、盘起头发、把妆容变得干净，把夸张饰品换成适合通勤的耳钉、细项链和可拆分叠戴的手链。她先以适合日常试错的价格选择首饰，同时观察并模仿前辈的精致。可她逐渐明白，职场化不是把个性藏起来，而是找到一种在场合里仍然属于自己的表达。</p>
              <div class="stage-scenes">
                <div class="scene-note"><h4 class="scene-name">通勤与会议</h4><p class="scene-style">简洁职业装配有结构感的细链、耳钉与素戒，建立可靠、利落的第一印象。</p></div>
                <div class="scene-note"><h4 class="scene-name">下班聚餐与闺蜜局</h4><p class="scene-style">在基础通勤搭配上增加第二条项链或更醒目的耳环，快速转换下班后的情绪。</p></div>
                <div class="scene-note"><h4 class="scene-name">周末运动与约会</h4><p class="scene-style">球鞋、短裙或休闲装配轻量饰品；认真打扮不再只是等待称赞，而是享受准备的过程。</p></div>
              </div>
            </div>
          </article>

          <article class="story-stage age-mature">
            <div>
              <div class="stage-age">25—28</div>
              <div class="stage-place">Her Own Rhythm</div>
            </div>
            <div>
              <h3 class="stage-title">当她不再照抄答案，风格才真正成为她的语言。</h3>
              <p class="stage-copy">几年后，她熟悉业务，也开始承担管理责任。职位和收入的上升，让她可以买下曾经向往的品牌包与高跟鞋；她经历过追逐大牌的阶段，并没有必要否认它。正是见过更多、试过更多以后，她开始重视材质、走线、舒适度、设计与使用频率，也更清楚自己为何购买。办公室里她干练克制，周末可以松弛甜美，闺蜜聚会时精致耀眼，夜晚派对上依然可以性感冷酷。爱情、工作、运动和社交都是她的生活场景，却没有任何一段关系成为她的结局。走到28岁，她得到的不是唯一正确的样子，而是决定自己怎样生活、怎样表达的权利。</p>
              <div class="stage-scenes">
                <div class="scene-note"><h4 class="scene-name">办公室与商务场合</h4><p class="scene-style">更好的材质与做工，克制的层次和清晰的结构，为专业感保留个人辨识度。</p></div>
                <div class="scene-note"><h4 class="scene-name">剧场、约会与城市夜晚</h4><p class="scene-style">珍珠、天然石、光泽金属与多层项链随场合组合，成熟但不被单一的“优雅”限制。</p></div>
                <div class="scene-note"><h4 class="scene-name">闺蜜聚会与自我犒赏</h4><p class="scene-style">她为自己购买，也与闺蜜交换心意。饰品记录关系，但不把她的价值交给任何人确认。</p></div>
              </div>
            </div>
          </article>
        </section>

        <section class="story-section">
          <div class="story-section-head">
            <div class="story-section-kicker">Why Angel · Why Myth</div>
            <h2 class="story-section-title">“天使”是没有失去的温度，“神话”是亲手获得的自由。</h2>
          </div>
          <div class="meaning-grid">
            <article class="meaning-block">
              <div class="meaning-word">ANGEL / 天使</div>
              <h3 class="meaning-title">柔软不是脆弱，翅膀也不是被谁赠予。</h3>
              <p class="meaning-copy">天使首先代表她藏在冷感外表下的善意、热情与柔软。即使面对竞争、压力和规则，她仍没有失去温度。后来长出的翅膀，则代表成熟后的内核：她拥有审美、判断、边界与选择，可以飞向自己决定的生活。</p>
            </article>
            <article class="meaning-block">
              <div class="meaning-word">MYTH / 神话</div>
              <h3 class="meaning-title">不是成为传奇，而是成为自己的作者。</h3>
              <p class="meaning-copy">神话不是把她包装成耀眼的成功女性，也不是等待爱情给故事一个结局。它是一场普通女孩亲手完成的蜕变：从借用别人的答案，到拥有定义自己的能力；外部的职位、收入与生活升级，只是这场内在建立留下的结果。</p>
            </article>
          </div>
          <div class="story-manifesto">饰品是她最贴近身体的表达：<span>先帮助她尝试，后来替她记录，最终由她自由组合。</span></div>
          <div class="spirit-grid">
            <article class="spirit-item"><div class="spirit-no">01</div><h3 class="spirit-name">不被单一风格定义</h3><p class="spirit-copy">品牌不以甜、酷或优雅框住女孩，而以真实生活场景组织产品。</p></article>
            <article class="spirit-item"><div class="spirit-no">02</div><h3 class="spirit-name">模仿是成长的起点</h3><p class="spirit-copy">鼓励尝试不同风格，在反复比较中形成属于自己的审美判断。</p></article>
            <article class="spirit-item"><div class="spirit-no">03</div><h3 class="spirit-name">组合带来选择权</h3><p class="spirit-copy">素链、点缀链、组戒与手链可拆分叠搭，让同一件产品进入不同关系与场合。</p></article>
            <article class="spirit-item"><div class="spirit-no">04</div><h3 class="spirit-name">美由自己确认</h3><p class="spirit-copy">以自购和闺蜜赠礼为核心，让饰品服务于自我表达，而非等待他人定义价值。</p></article>
          </div>
        </section>
      `;
    }

    function positioningTemplate(section, index) {
      const next = sections[index + 1];
      const decisions = [
        {
          no: '01', kicker: 'Mission / 品牌使命', title: '陪伴女孩建立自己的审美与表达',
          statement: 'AngelMyth 陪伴女孩从模仿与尝试，逐渐走向判断与表达。品牌不替她规定唯一正确的样子，而是让她在不同人生阶段和生活场景中，自由选择今天想成为谁。',
          tags: ['从模仿到判断', '从尝试到表达', '不被单一风格定义']
        },
        {
          no: '02', kicker: 'Value Proposition / 核心价值主张', title: '为成长中的每一种自己而设计',
          statement: 'AngelMyth 以女孩从校园走向职场的真实场景为设计起点，通过可拆分、可叠戴、可重新组合的产品方法，以及逐步进阶的材质与品质，让一套饰品适配不同服装、关系、情绪和人生阶段。',
          layers: [
            ['价值核心', '为成长中的不同身份与生活场景而设计'],
            ['产品方法', '场景适配 × 自由组合 × 叠戴变化'],
            ['品质路径', '从第一件品质饰品走向成熟审美选择']
          ],
          tags: ['场景适配', '自由组合', '品质进阶']
        },
        {
          no: '03', kicker: 'Competitive Frame / 竞争参照系', title: '场景化组合饰品品牌',
          statement: 'AngelMyth 进入年轻女性设计饰品市场，以真实生活场景组织产品，用组合与叠戴打破“一件饰品只有一种戴法”的旧标准。价格位于大众快时尚与国际高价品牌之间，成为年轻女性可以持续进阶的品质选择。',
          layers: [
            ['竞争位置', '场景化组合饰品品牌'],
            ['价格位置', '大众快时尚之上、国际高价品牌之下的品质进阶带'],
            ['风格策略', '不以韩系框定品牌；韩系是故事与审美来源之一，产品随市场趋势和生活场景多元变化']
          ],
          tags: ['组合叠戴', '品质进阶', '趋势驱动', '多元风格']
        },
        {
          no: '04', kicker: 'Personality / 品牌人格', title: '冷静有温度，多变且有主见',
          statement: 'AngelMyth 第一眼克制、冷静、带有边界感；真正靠近后，会发现她柔软、真诚而有温度。她对新鲜事物保持好奇，愿意在甜美、运动、优雅与冷酷之间变化，最终成长为能够独立判断并自在表达的人。',
          layers: [
            ['核心人格', '冷静、克制、温暖、有主见'],
            ['外在表现', '精致、多变、灵动、富有好奇心'],
            ['成长结果', '自信、独立、锋利、具有表达欲']
          ],
          tags: ['冷感外表', '温热内心', '多元表达', '自主判断']
        }
      ];
      return `
        <section>
          <div class="segment-strip" aria-hidden="true"><span class="young"></span><span class="core"></span><span class="mature"></span></div>
          <div class="chapter-head">
            <div>
              <div class="chapter-no">Chapter ${String(index).padStart(2, '0')} / ${section.en}</div>
              <h1 class="chapter-title">${section.label}</h1>
            </div>
            <p class="chapter-summary">${section.summary}</p>
          </div>
          <div class="chapter-purpose">
            <div class="purpose-label">定位结论 / Decision</div>
            <div class="purpose-text">${section.purpose}</div>
          </div>
          <div class="decision-grid">
            ${decisions.map(item => `
              <article class="decision-card" data-no="${item.no}">
                <div class="decision-top">
                  <div class="decision-kicker">${item.no} · ${item.kicker}</div>
                  <div class="decision-status">已确认</div>
                </div>
                <h2 class="decision-title">${item.title}</h2>
                <p class="decision-statement">${item.statement}</p>
                ${item.layers ? `<div class="decision-layers">${item.layers.map(layer => `<div class="decision-layer"><span class="layer-label">${layer[0]}</span><span class="layer-value">${layer[1]}</span></div>`).join('')}</div>` : ''}
                <div class="decision-tags">${item.tags.map(tag => `<span class="decision-tag">${tag}</span>`).join('')}</div>
              </article>
            `).join('')}
          </div>
          <div class="positioning-summary">
            <div class="positioning-summary-label">One Sentence Positioning / 一句话定位</div>
            <p class="positioning-summary-copy">AngelMyth 是一个面向成长中年轻女性的<em>场景化组合饰品品牌</em>，以自由组合、品质进阶和多元趋势表达，陪伴她从模仿别人走向定义自己。</p>
          </div>
          <div class="chapter-footer">
            <div class="progress-copy">品牌定位四项核心决策已确认</div>
            ${next ? `<button class="next-btn" type="button" data-target="${next.id}">下一章：${next.label} →</button>` : ''}
          </div>
        </section>
      `;
    }

    function consumerScenesTemplate(section, index) {
      const next = sections[index + 1];
      const journeyKeys = ['身份焕新 × 穿搭任务', '内容种草 × 平台搜索', '适配证明 × 设计价值', '被夸赞 × 风格认同'];
      return `
        <section>
          <div class="segment-strip" aria-hidden="true"><span class="young"></span><span class="core"></span><span class="mature"></span></div>
          <div class="chapter-head">
            <div>
              <div class="chapter-no">Chapter ${String(index).padStart(2, '0')} / ${section.en}</div>
              <h1 class="chapter-title">${section.label}</h1>
            </div>
            <p class="chapter-summary">${section.summary}</p>
          </div>
          <div class="chapter-purpose">
            <div class="purpose-label">消费旅程 / Journey</div>
            <div class="purpose-text">${section.purpose}</div>
          </div>
          <div class="journey-overview" aria-label="消费旅程总览">
            ${section.prompts.map((prompt, i) => `
              <div class="journey-step">
                <div class="journey-no">0${i + 1}</div>
                <div class="journey-name">${prompt[0]}</div>
                <div class="journey-key">${journeyKeys[i]}</div>
              </div>
            `).join('')}
          </div>
          <div class="scene-decision-grid">
            ${section.prompts.map((prompt, i) => {
              const decision = section.decisions[i];
              return `
                <article class="scene-decision-card">
                  <div class="scene-decision-top">
                    <div>
                      <h2 class="scene-decision-title">0${i + 1} · ${prompt[0]}</h2>
                      <p class="scene-decision-question">${prompt[1]}</p>
                    </div>
                    <span class="confirmed-badge">已确认</span>
                  </div>
                  <div class="scene-options">
                    ${section.choices[i].map((choice, choiceIndex) => {
                      const isPrimary = decision.primary.includes(choiceIndex);
                      const isSecondary = decision.secondary.includes(choiceIndex);
                      const roleClass = isPrimary ? 'primary' : isSecondary ? 'secondary' : 'unselected';
                      const roleLabel = isPrimary ? '主答案' : isSecondary ? '辅助' : '';
                      return `
                        <div class="scene-option ${roleClass}">
                          <span class="scene-option-code">${String.fromCharCode(65 + choiceIndex)}</span>
                          <span><span class="scene-option-name">${choice[0]}</span><span class="scene-option-desc">${choice[1]}</span></span>
                          <span class="scene-option-role">${roleLabel}</span>
                        </div>
                      `;
                    }).join('')}
                  </div>
                  <div class="scene-conclusion">
                    <div class="scene-conclusion-label">Strategy Conclusion / 策略结论</div>
                    <p class="scene-conclusion-copy">${decision.conclusion}</p>
                  </div>
                </article>
              `;
            }).join('')}
          </div>
          <div class="journey-summary">
            <div class="journey-summary-label">Consumption Journey / 消费路径结论</div>
            <p class="journey-summary-copy">AngelMyth 应在消费者<em>进入新阶段或需要完成一次造型</em>时出现，以真实穿搭内容激发兴趣、由淘宝天猫搜索承接需求，再用上身适配与原创设计完成成交，最终通过“佩戴后被夸赞”的风格认同推动分享与复购。</p>
          </div>
          <div class="chapter-footer">
            <div class="progress-copy">消费旅程四项决策已确认 · 主答案与辅助答案已分级呈现</div>
            ${next ? `<button class="next-btn" type="button" data-target="${next.id}">下一章：${next.label} →</button>` : ''}
          </div>
        </section>
      `;
    }

    function consumerTemplate(section, index) {
      const next = sections[index + 1];
      const overviewKeys = ['都市成长型女性为核心', '实用 × 身份 × 情绪', '适配焦虑 × 选择成本', '真实上身建立第一信任'];
      return `
        <section>
          <div class="segment-strip" aria-hidden="true"><span class="young"></span><span class="core"></span><span class="mature"></span></div>
          <div class="chapter-head">
            <div>
              <div class="chapter-no">Chapter ${String(index).padStart(2, '0')} / ${section.en}</div>
              <h1 class="chapter-title">${section.label}</h1>
            </div>
            <p class="chapter-summary">${section.summary}</p>
          </div>
          <div class="chapter-purpose">
            <div class="purpose-label">画像结论 / Portrait</div>
            <div class="purpose-text">${section.purpose}</div>
          </div>
          <div class="portrait-overview" aria-label="消费者画像结论总览">
            ${section.prompts.map((prompt, i) => `
              <div class="portrait-overview-item">
                <div class="portrait-overview-no">0${i + 1}</div>
                <div class="portrait-overview-name">${prompt[0]}</div>
                <div class="portrait-overview-key">${overviewKeys[i]}</div>
              </div>
            `).join('')}
          </div>
          <div class="portrait-grid">
            ${section.prompts.map((prompt, i) => {
              const decision = section.decisions[i];
              return `
                <article class="portrait-card">
                  <div class="portrait-card-head">
                    <div>
                      <h2 class="portrait-card-title">0${i + 1} · ${prompt[0]}</h2>
                      <p class="portrait-card-question">${prompt[1]}</p>
                    </div>
                    <span class="confirmed-badge">已确认</span>
                  </div>
                  <div class="portrait-answer-list">
                    ${section.choices[i].map((choice, choiceIndex) => {
                      const isPrimary = decision.primary.includes(choiceIndex);
                      const isSecondary = decision.secondary.includes(choiceIndex);
                      const roleClass = isPrimary ? 'primary' : isSecondary ? 'secondary' : 'unselected';
                      const roleLabel = isPrimary ? '核心结论' : isSecondary ? '重要支撑' : '';
                      return `
                        <div class="portrait-answer ${roleClass}">
                          <span class="portrait-answer-code">${String.fromCharCode(65 + choiceIndex)}</span>
                          <span><span class="portrait-answer-name">${choice[0]}</span><span class="portrait-answer-desc">${choice[1]}</span></span>
                          <span class="portrait-answer-role">${roleLabel}</span>
                        </div>
                      `;
                    }).join('')}
                  </div>
                  <div class="portrait-conclusion">
                    <div class="portrait-conclusion-label">Strategy Conclusion / 策略结论</div>
                    <p class="portrait-conclusion-copy">${decision.conclusion}</p>
                  </div>
                </article>
              `;
            }).join('')}
          </div>
          <div class="portrait-summary">
            <div class="portrait-summary-label">Core Consumer Portrait / 核心消费者画像</div>
            <p class="portrait-summary-copy">AngelMyth 面向18–35岁的成长型女性，核心消费者是正在建立个人判断的<em>24–28岁都市成长型女性</em>。她希望饰品既能完善日常穿搭，也能记录成长和奖励自己；品牌需要用真实上身解决适配焦虑，用鲜明设计理由降低选择成本，再以可靠品质与可信口碑完成成交。</p>
          </div>
          <div class="chapter-footer">
            <div class="progress-copy">消费者画像四项核心决策已确认 · 主次关系已分级呈现</div>
            ${next ? `<button class="next-btn" type="button" data-target="${next.id}">下一章：${next.label} →</button>` : ''}
          </div>
        </section>
      `;
    }

    function productScenesTemplate(section, index) {
      const next = sections[index + 1];
      const overviewKeys = ['日常高频 × 场景转换', '好搭配 × 状态提升', '从已有衣橱建立组合', '生活内容 × 教学 × 故事'];
      return `
        <section>
          <div class="segment-strip" aria-hidden="true"><span class="young"></span><span class="core"></span><span class="mature"></span></div>
          <div class="chapter-head">
            <div>
              <div class="chapter-no">Chapter ${String(index).padStart(2, '0')} / ${section.en}</div>
              <h1 class="chapter-title">${section.label}</h1>
            </div>
            <p class="chapter-summary">${section.summary}</p>
          </div>
          <div class="chapter-purpose">
            <div class="purpose-label">使用策略 / Usage</div>
            <div class="purpose-text">${section.purpose}</div>
          </div>
          <div class="usage-overview" aria-label="产品使用场景结论总览">
            ${section.prompts.map((prompt, i) => `
              <div class="usage-overview-item">
                <div class="usage-overview-no">0${i + 1}</div>
                <div class="usage-overview-title">${prompt[0]}</div>
                <div class="usage-overview-key">${overviewKeys[i]}</div>
              </div>
            `).join('')}
          </div>
          <div class="usage-grid">
            ${section.prompts.map((prompt, i) => {
              const decision = section.decisions[i];
              return `
                <article class="usage-card">
                  <div class="usage-card-head">
                    <div>
                      <h2 class="usage-card-title">0${i + 1} · ${prompt[0]}</h2>
                      <p class="usage-card-question">${prompt[1]}</p>
                    </div>
                    <span class="confirmed-badge">已确认</span>
                  </div>
                  <div class="usage-selection-label">Confirmed Directions / 已确认方向</div>
                  <div class="usage-selection-list">
                    ${decision.selected.map(choiceIndex => {
                      const choice = section.choices[i][choiceIndex];
                      return `
                        <div class="usage-selection">
                          <span class="usage-selection-code">${String.fromCharCode(65 + choiceIndex)}</span>
                          <span><span class="usage-selection-name">${choice[0]}</span><span class="usage-selection-desc">${choice[1]}</span></span>
                        </div>
                      `;
                    }).join('')}
                  </div>
                  <div class="usage-conclusion">
                    <div class="usage-conclusion-label">Strategy Conclusion / 策略结论</div>
                    <p class="usage-conclusion-copy">${decision.conclusion}</p>
                  </div>
                </article>
              `;
            }).join('')}
          </div>
          <div class="usage-summary">
            <div class="usage-summary-label">Product Usage Strategy / 产品使用策略总结</div>
            <p class="usage-summary-copy">AngelMyth 的产品应成为女性在<em>日常生活与身份转换之间自由切换</em>的组合工具：从已有衣橱和真实场景出发，通过容易搭配、可叠戴和一饰多用降低选择成本，同时以精致感、仪式感和被认同的体验，建立持续佩戴与表达的理由。</p>
          </div>
          <div class="chapter-footer">
            <div class="progress-copy">产品使用场景四项策略已确认 · 已转化为正式企划结论</div>
            ${next ? `<button class="next-btn" type="button" data-target="${next.id}">下一章：${next.label} →</button>` : ''}
          </div>
        </section>
      `;
    }

    function pricingTemplate(section, index) {
      const next = sections[index + 1];
      const groups = [
        {
          tone: 'young', age: '18–24岁', share: '货盘占比 15%', intro: '轻量首饰拉新；强调色彩、可爱、快速趋势与低门槛试错。',
          prices: [['¥40–69','25%',25],['¥70–99','40%',40],['¥100–149','25%',25],['¥150+','10%',10]], main: '¥70–99（占比40%）',
          details: [['品类','耳饰、项链、手链与戒指'],['角色','年轻潮流材质，承接拉新与第一件品牌饰品'],['升级目标','从低门槛潮流感过渡到更稳定的金属质感']]
        },
        {
          tone: 'core', age: '24–28岁', share: '货盘占比 60%', intro: '核心成交层；以精致金属、锆石与珍珠成套化建立品牌主力价格。',
          prices: [['¥70–99','15%',15],['¥100–149','30%',30],['¥150–199','40%',40],['¥200+','15%',15]], main: '¥150–199（占比40%）',
          details: [['品类','耳环、项链、手链成套开发'],['角色','承担主力成交、系列识别与价格带上移'],['升级目标','从潮流配饰升级为精致金属＋锆石珍珠的品质选择']]
        },
        {
          tone: 'mature', age: '28–35岁', share: '货盘占比 25%', intro: '质感升级层；通过真实珍珠、天然石与完整套组提高价值感。',
          prices: [['¥150–199','40%',40],['¥200–299','45%',45],['¥300+','15%',15]], main: '¥200–299（占比45%）',
          details: [['品类','耳环＋项链＋手链完整套组'],['角色','承接成熟通勤、旅行、宴会与礼赠'],['升级目标','提高真实材质、高完成度套组及高阶价格占比']]
        }
      ];
      return `
        <section>
          <div class="segment-strip" aria-hidden="true"><span class="young"></span><span class="core"></span><span class="mature"></span></div>
          <div class="chapter-head"><div><div class="chapter-no">Chapter ${String(index).padStart(2,'0')} / ${section.en}</div><h1 class="chapter-title">${section.label}</h1></div><p class="chapter-summary">${section.summary}</p></div>
          <div class="chapter-purpose"><div class="purpose-label">升级路径 / Pricing Path</div><div class="purpose-text">从年轻潮流材质逐步升级到真实珍珠、天然石与高质感成套产品，让客单价提升具有清晰的产品理由。</div></div>
          <div class="strategy-section">
            <div class="strategy-upgrade"><span class="young">潮流感 / 低门槛</span><span class="core">精致金属＋锆石珍珠 / 主力价格带上移</span><span class="mature">真实材质 / 高质感</span></div>
            <div class="strategy-age-grid">
              ${groups.map(group => `<article class="strategy-age-card ${group.tone}"><div class="strategy-age-head"><span class="strategy-age-title">${group.age}</span><span class="strategy-age-share">${group.share}</span></div><div class="strategy-age-body"><p class="strategy-age-intro">${group.intro}</p><h3 class="strategy-subtitle">价格段占比</h3><div class="price-list">${group.prices.map(price => `<div class="price-chip"><b>${price[0]}</b> · ${price[1]}</div>`).join('')}</div><div class="price-distribution" aria-label="${group.age}价格段比例图">${group.prices.map(price => `<span style="width:${price[2]}%" title="${price[0]} ${price[1]}"></span>`).join('')}</div><div class="main-price-band">主力价格带｜${group.main}</div><div class="strategy-detail-list">${group.details.map(item => `<div><b>${item[0]}｜</b>${item[1]}</div>`).join('')}</div></div></article>`).join('')}
            </div>
            <section class="portfolio-price-overview" aria-labelledby="portfolio-price-title">
              <div class="portfolio-price-head">
                <div>
                  <div class="portfolio-price-eyebrow">TOTAL PORTFOLIO / 综合货盘</div>
                  <h2 class="portfolio-price-title" id="portfolio-price-title">全品牌整体价位段占比</h2>
                  <p class="portfolio-price-copy">抛开年龄段，将18–24岁、24–28岁与28–35岁的内部价格结构，按照15% / 60% / 25%的整体货盘权重加权汇总。</p>
                </div>
                <div class="portfolio-price-kpis" aria-label="综合价格指标">
                  <div class="portfolio-price-kpi"><span>第一核心价格带</span><b>¥150–199</b></div>
                  <div class="portfolio-price-kpi"><span>¥150以上合计</span><b>59.5%</b></div>
                </div>
              </div>
              <div class="portfolio-price-bar" aria-label="全品牌六档价位段比例图">
                <span style="width:3.75%" title="¥40–69 · 3.75%"></span>
                <span style="width:15%" title="¥70–99 · 15%"></span>
                <span style="width:21.75%" title="¥100–149 · 21.75%"></span>
                <span style="width:35.5%" title="¥150–199 · 35.5%"></span>
                <span style="width:20.25%" title="¥200–299 · 20.25%"></span>
                <span style="width:3.75%" title="¥300+ · 3.75%"></span>
              </div>
              <div class="portfolio-price-legend">
                <div class="portfolio-price-item" style="--price-color:#f3bfd0"><span class="portfolio-price-band-label">¥40–69</span><strong class="portfolio-price-value">3.75%</strong></div>
                <div class="portfolio-price-item" style="--price-color:#e886a9"><span class="portfolio-price-band-label">¥70–99</span><strong class="portfolio-price-value">15%</strong></div>
                <div class="portfolio-price-item" style="--price-color:#e75287"><span class="portfolio-price-band-label">¥100–149</span><strong class="portfolio-price-value">21.75%</strong></div>
                <div class="portfolio-price-item" style="--price-color:#4b84da"><span class="portfolio-price-band-label">¥150–199</span><strong class="portfolio-price-value">35.5%</strong></div>
                <div class="portfolio-price-item" style="--price-color:#8a6b9f"><span class="portfolio-price-band-label">¥200–299</span><strong class="portfolio-price-value">20.25%</strong></div>
                <div class="portfolio-price-item" style="--price-color:#a1644b"><span class="portfolio-price-band-label">¥300以上</span><strong class="portfolio-price-value">3.75%</strong></div>
              </div>
              <div class="portfolio-price-note"><b>整体结构判断｜</b>¥150–199以35.5%成为全品牌第一成交核心，¥70–149合计36.75%承担年轻拉新与规模成交，¥200以上合计24%承接品质升级；¥100以上产品合计81.25%，整体价格结构兼顾入门覆盖与向上进阶。</div>
            </section>
            <div class="strategy-conclusion"><div class="strategy-conclusion-label">规划结论</div><div class="strategy-conclusion-copy">18–24岁以 ¥70–99 为第一主力，占比40%，¥40–69与 ¥100–149各占25%，¥150+控制在10%，强化年轻客群的入门与高频成交；24–28岁以 ¥150–199 为第一主力，占比40%，¥100–149占30%，¥70–99与 ¥200+各占15%，形成稳定的核心成交梯度；28–35岁全部集中在 ¥150以上，其中 ¥200–299占45%成为第一主力，¥150–199占40%，¥300+占15%，兼顾成熟品质与可接受的高阶价格。全品牌综合结构由 ¥150–199主导，¥150以上产品合计59.5%。</div></div>
            <div class="data-caveat">比例说明：三个年龄段均已重新归一为100%，用于指导各年龄货盘内部的价格结构；顶部15% / 60% / 25%仍代表三个年龄段在整体货盘中的占比。</div>
          </div>
          <div class="chapter-footer"><div class="progress-copy">三个年龄段价格结构与升级路径已确认</div>${next ? `<button class="next-btn" type="button" data-target="${next.id}">下一章：${next.label} →</button>` : ''}</div>
        </section>`;
    }

    const profitCostRows = [
      { key:'product', label:'产品成本', hint:'商品生产与采购成本' },
      { key:'packaging', label:'包装成本', hint:'首饰盒、卡片、外包装等' },
      { key:'shipping', label:'运费', hint:'平均履约与发货费用' },
      { key:'platform', label:'平台费用', hint:'平台扣点、技术服务等' },
      { key:'onsite', label:'站内投流', hint:'平台内广告与流量采买' },
      { key:'influencer', label:'站内达人推广', hint:'达人佣金与合作预算' },
      { key:'offsite', label:'站外推广', hint:'站外内容及流量预算' },
      { key:'tax', label:'税费', hint:'按销售额统一计提' },
      { key:'inventory', label:'库存成本', hint:'备货、滞销和周转成本' }
    ];

    const defaultProfitModel = {
      platforms: {
        tmall: { name:'天猫', color:'#e95686', note:'站内投流与站外推广共同承担品牌成交。', rates:{ product:18, packaging:5, shipping:2, platform:5, onsite:20, influencer:0, offsite:20, tax:5, inventory:5 } },
        douyin: { name:'抖音', color:'#448cf2', note:'站内投流叠加站内达人推广完成内容成交。', rates:{ product:18, packaging:5, shipping:2, platform:5, onsite:20, influencer:20, offsite:0, tax:5, inventory:5 } },
        dewu: { name:'得物', color:'#955f47', note:'平台费用按售价30%，站内费用20%，站外暂不计。', rates:{ product:18, packaging:5, shipping:2, platform:30, onsite:20, influencer:0, offsite:0, tax:5, inventory:5 } }
      },
      prices:[100,150,199,299],
      baselineVersion:3
    };

    function cloneProfitModel() { return JSON.parse(JSON.stringify(defaultProfitModel)); }

    function getProfitModel() {
      const saved = state.profitModel || {};
      const model = cloneProfitModel();
      let migrated = false;
      Object.keys(model.platforms).forEach(key => { model.platforms[key].rates = { ...model.platforms[key].rates, ...(saved.platforms?.[key]?.rates || {}) }; });
      if (Array.isArray(saved.prices) && saved.prices.length) model.prices = saved.prices.map(value => Math.max(0, Number(value) || 0)).slice(0, 8);
      if ((Number(saved.baselineVersion) || 0) < 3) {
        Object.values(model.platforms).forEach(platform => { platform.rates.product = 18; });
        model.baselineVersion = 3;
        migrated = true;
        try { localStorage.setItem(storageKey, JSON.stringify({ ...state, profitModel:model })); } catch (_) {}
      }
      state.profitModel = model;
      if (migrated && canManageStylePool) stateClient.scheduleSave(state);
      return model;
    }

    function profitTotal(platform) { return profitCostRows.reduce((total, row) => total + (Number(platform.rates[row.key]) || 0), 0); }

    function formatProfitNumber(value) {
      const rounded = Math.round((Number(value) || 0) * 100) / 100;
      return Number.isInteger(rounded) ? String(rounded) : rounded.toFixed(2).replace(/0+$/, '').replace(/\.$/, '');
    }

    function profitModelTemplate(section, index) {
      const next = sections[index + 1], model = getProfitModel(), platformEntries = Object.entries(model.platforms);
      return `
        <section>
          <div class="segment-strip" aria-hidden="true"><span class="young"></span><span class="core"></span><span class="mature"></span></div>
          <div class="chapter-head"><div><div class="chapter-no">Chapter ${String(index).padStart(2,'0')} / ${section.en}</div><h1 class="chapter-title">${section.label}</h1></div><p class="chapter-summary">${section.summary}</p></div>
          <div class="chapter-purpose"><div class="purpose-label">模型目标 / Profit Budget</div><div class="purpose-text">${section.purpose}</div></div>
          <div class="profit-model-shell">
            <div class="profit-tier-summary"><div><strong>产品毛利</strong><span>销售价 − 产品制造成本</span></div><div><strong>贡献毛利</strong><span>产品毛利 − 平台、投流、达人、物流、包装、售后等可变成本</span></div><div><strong>经营利润</strong><span>贡献毛利 − 人员、仓储、软件与管理等固定运营成本</span></div></div>
            <div class="profit-platform-summary">${platformEntries.map(([key,p])=>{const total=profitTotal(p),margin=100-total;return `<article class="profit-platform-card" style="--platform-color:${p.color}"><h2 class="profit-platform-name">${p.name}</h2><p class="profit-platform-note">${p.note}</p><div class="profit-platform-kpis"><div class="profit-platform-kpi"><span>总成本率</span><strong data-profit-summary-total="${key}">${formatProfitNumber(total)}%</strong></div><div class="profit-platform-kpi profit ${margin<0?'loss':''}" data-profit-summary-card="${key}"><span>预计利润率</span><strong data-profit-summary-margin="${key}">${formatProfitNumber(margin)}%</strong></div></div></article>`;}).join('')}</div>
            <section class="profit-editor-panel">
              <div class="profit-panel-head"><div><div class="profit-panel-kicker">COST BUDGET / 费用预算</div><div class="profit-title-row"><h2 class="profit-panel-title">各平台费用比例</h2><div class="pricing-rule-group" aria-label="三年龄段产品定价倍率"><span class="pricing-rule-chip young">18–24岁：不低于5.0倍 · 成本率≤20%</span><span class="pricing-rule-chip core">整体基准：产品成本率18% · 售价约为成本5.8倍</span><span class="pricing-rule-chip mature">28–35岁：6.0倍 · 成本率16%–17%</span></div></div></div><div class="profit-panel-note">所有数值均按售价百分比计算。点击数字即可修改，利润率和下方利润额会即时重算并自动保存。</div></div>
              <div class="profit-table-scroll"><table class="profit-table"><thead><tr><th>费用项目</th>${platformEntries.map(([,p])=>`<th>${p.name}</th>`).join('')}</tr></thead><tbody>
                ${profitCostRows.map(row=>`<tr><td><span class="profit-cost-label">${row.label}</span><span class="profit-cost-hint">${row.hint}</span></td>${platformEntries.map(([key,p])=>`<td><div class="profit-input-wrap"><input class="profit-rate-input" type="number" min="0" max="100" step="0.5" value="${formatProfitNumber(p.rates[row.key])}" data-profit-rate="${key}:${row.key}" aria-label="${p.name}${row.label}比例"></div></td>`).join('')}</tr>`).join('')}
                <tr class="profit-derived-row"><td><span class="profit-cost-label">总成本率</span><span class="profit-cost-hint">以上费用项目合计</span></td>${platformEntries.map(([key,p])=>`<td><span class="profit-derived-value" data-profit-total="${key}">${formatProfitNumber(profitTotal(p))}%</span></td>`).join('')}</tr>
                <tr class="profit-result-row"><td><span class="profit-cost-label">预计利润率</span><span class="profit-cost-hint">100%－总成本率</span></td>${platformEntries.map(([key,p])=>`<td><span class="profit-derived-value" data-profit-margin="${key}">${formatProfitNumber(100-profitTotal(p))}%</span></td>`).join('')}</tr>
              </tbody></table></div>
              <div class="profit-price-actions"><button class="profit-add-price" type="button" data-profit-add-price>＋ 新增测算售价</button><button class="profit-reset-btn" type="button" data-profit-reset>恢复默认费用</button></div>
            </section>
            <section class="profit-editor-panel">
              <div class="profit-panel-head"><div><div class="profit-panel-kicker">PRICE SIMULATION / 售价测算</div><h2 class="profit-panel-title">不同售价的预计利润</h2></div><div class="profit-panel-note">售价可直接修改；预计利润额＝售价 × 预计利润率。最多保留8个测算售价。得物售价低于130元时自动标记平台费用过高。</div></div>
              <div class="profit-table-scroll"><table class="profit-table"><thead><tr><th>测算售价</th>${platformEntries.map(([,p])=>`<th>${p.name}<br><span class="profit-simulation-label">产品成本金额 · 预计利润 · 产品倍率</span></th>`).join('')}</tr></thead><tbody>${model.prices.map((price,i)=>`<tr><td><input class="profit-price-input" type="number" min="0" step="1" value="${formatProfitNumber(price)}" data-profit-price="${i}" aria-label="第${i+1}个测算售价"><button class="profit-price-remove" type="button" data-profit-remove-price="${i}">删除</button></td>${platformEntries.map(([key,p])=>{const total=profitTotal(p),productRate=Number(p.rates.product)||0,cost=price*productRate/100,profit=price*(100-total)/100,multiple=cost>0?price/cost:0;return `<td><div class="profit-simulation-cell${key==='dewu'&&price<130?' dewu-blocked':''}" data-profit-platform-cell="${i}:${key}"><div class="profit-simulation-metrics"><div class="profit-simulation-metric"><span class="profit-simulation-label">产品成本金额</span><strong class="profit-simulation-value" data-profit-cost="${i}:${key}">¥${formatProfitNumber(cost)}</strong></div><div class="profit-simulation-metric"><span class="profit-simulation-label">预计利润</span><strong class="profit-simulation-value profit ${profit<0?'negative':''}" data-profit-amount="${i}:${key}">¥${formatProfitNumber(profit)}</strong></div><div class="profit-simulation-metric"><span class="profit-simulation-label">产品倍率</span><strong class="profit-simulation-value" data-profit-multiple="${i}:${key}">${formatProfitNumber(multiple)}×</strong></div></div>${key==='dewu'?'<div class="profit-dewu-overlay">平台费用过高</div>':''}</div></td>`;}).join('')}</tr>`).join('')}</tbody></table></div>
              <div class="profit-formula-note"><b>当前口径｜</b>天猫、抖音与得物的产品成本默认按售价18%计算；天猫：包装5%＋运费2%＋平台5%＋站内投流20%＋站外推广20%＋税费5%＋库存5%；抖音：在相同基础费用上加入站内达人20%，站外0%；得物：平台30%＋站内投流20%，站内达人及站外均为0%。本模型为商品贡献利润预算，暂未计退款退货、优惠券、人工、仓储和售后等固定或异常费用。</div>
            </section>
          </div>
          <div class="chapter-footer"><div class="progress-copy">三平台费用预算与利润测算会自动保存在本机</div>${next?`<button class="next-btn" type="button" data-target="${next.id}">下一章：${next.label} →</button>`:''}</div>
        </section>`;
    }

    function updateProfitModelView() {
      const model=getProfitModel();
      Object.entries(model.platforms).forEach(([key,p])=>{const total=profitTotal(p),margin=100-total,productRate=Number(p.rates.product)||0;['total','summary-total'].forEach(type=>{const el=pageContent.querySelector(`[data-profit-${type}="${key}"]`);if(el)el.textContent=`${formatProfitNumber(total)}%`;});['margin','summary-margin'].forEach(type=>{const el=pageContent.querySelector(`[data-profit-${type}="${key}"]`);if(el)el.textContent=`${formatProfitNumber(margin)}%`;});pageContent.querySelector(`[data-profit-summary-card="${key}"]`)?.classList.toggle('loss',margin<0);pageContent.querySelectorAll('[data-profit-price]').forEach(input=>{const i=Number(input.dataset.profitPrice),price=Number(input.value)||0,cost=price*productRate/100,amount=price*margin/100,multiple=cost>0?price/cost:0;const costTarget=pageContent.querySelector(`[data-profit-cost="${i}:${key}"]`),amountTarget=pageContent.querySelector(`[data-profit-amount="${i}:${key}"]`),multipleTarget=pageContent.querySelector(`[data-profit-multiple="${i}:${key}"]`);if(costTarget)costTarget.textContent=`¥${formatProfitNumber(cost)}`;if(amountTarget){amountTarget.textContent=`¥${formatProfitNumber(amount)}`;amountTarget.classList.toggle('negative',amount<0);amountTarget.classList.toggle('profit',amount>=0);}if(multipleTarget)multipleTarget.textContent=`${formatProfitNumber(multiple)}×`;pageContent.querySelector(`[data-profit-platform-cell="${i}:${key}"]`)?.classList.toggle('dewu-blocked',key==='dewu'&&price<130);});});
      pageContent.querySelector('.profit-result-row')?.classList.toggle('loss',Object.values(model.platforms).some(p=>100-profitTotal(p)<0));
    }

    function materialsTemplate(section, index) {
      const next = sections[index + 1];
      const groups = [
        {
          tone:'young', age:'18–24岁', intro:'轻量首饰拉新；强调色彩、可爱和快速趋势。',
          materials:['合金 / 电镀金属','珐琅 / 树脂','仿珍珠 / 贝珠','锆石 / 玻璃水晶','银针 / 钛钢亲肤件'],
          details:[['元素','彩色、爱心、蝴蝶结、小珍珠、小方糖、小锆石'],['产品','迷你耳钉、小耳圈、戒指、细链项链、小体量手链'],['场景','校园日常、初职通勤；甜而精致']]
        },
        {
          tone:'core', age:'24–28岁', intro:'核心成交；精致金属、锆石与珍珠成套化。',
          materials:['合金 / 精致电镀金属','锆石 / 水晶','珍珠 / 贝珠','925银 / 钛钢 / 银针','天然石 / 珐琅补充'],
          details:[['元素','金属线条、圆环、细链、锆石、四叶草、小方糖、山茶花、珍珠、蝴蝶结'],['产品','耳环＋项链＋手链成套开发，强化品牌系列识别'],['场景','通勤、约会、社交；精致柔美不过甜']]
        },
        {
          tone:'mature', age:'28–35岁', intro:'质感升级；真实珍珠、天然石与高完整度套组。',
          materials:['天然珍珠 / 贝珠','合金 / 高质感电镀','锆石 / 水晶','925银 / 钛钢 / 银针','天然石 / 简约东方元素'],
          details:[['元素','天然珍珠、天然石、水晶、山茶花、玫瑰、艺术线条'],['产品','耳环＋项链＋手链完整套组；体量更大、材质感更强'],['场景','通勤、旅行、度假、宴会、礼赠；赫本式优雅']]
        }
      ];
      return `
        <section>
          <div class="segment-strip" aria-hidden="true"><span class="young"></span><span class="core"></span><span class="mature"></span></div>
          <div class="chapter-head"><div><div class="chapter-no">Chapter ${String(index).padStart(2,'0')} / ${section.en}</div><h1 class="chapter-title">${section.label}</h1></div><p class="chapter-summary">${section.summary}</p></div>
          <div class="chapter-purpose"><div class="purpose-label">材质升级 / Material Path</div><div class="purpose-text">从合金电镀与趣味材质切入，以精致金属、锆石和珍珠建立主力成交，再以真实珍珠、天然石和高完成度套组承接质感升级。</div></div>
          <div class="strategy-section">
            <div class="strategy-upgrade material-upgrade"><span class="young">潮流感 / 低门槛</span><span class="core">精致金属＋锆石珍珠 / 主力材质</span><span class="mature">真实材质 / 高质感</span></div>
            <div class="strategy-age-grid">
              ${groups.map(group => `<article class="strategy-age-card ${group.tone}"><div class="strategy-age-head"><span class="strategy-age-title">${group.age}</span></div><div class="strategy-age-body"><p class="strategy-age-intro">${group.intro}</p><h3 class="strategy-subtitle">核心材质</h3><div class="material-list">${group.materials.map(material => `<div class="material-item">${material}</div>`).join('')}</div><div class="strategy-detail-list">${group.details.map(item => `<div><b>${item[0]}｜</b>${item[1]}</div>`).join('')}</div></div></article>`).join('')}
            </div>
            <div class="strategy-conclusion"><div class="strategy-conclusion-label">材质原则</div><div class="strategy-conclusion-copy">所有年龄段均以亲肤安全、耐用镀层和清晰材质标识为基础。18–24岁重轻量与趋势表现；24–28岁强化精致电镀、锆石与珍珠成套；28–35岁重点采用真实珍珠、天然石、925银及高质感套组，并建立对应的保养和售后标准。</div></div>
          </div>
          <div class="chapter-footer"><div class="progress-copy">三个年龄段材质结构与产品应用已确认</div>${next ? `<button class="next-btn" type="button" data-target="${next.id}">下一章：${next.label} →</button>` : ''}</div>
        </section>`;
    }

    function visualSystemTemplate(section, index) {
      const next = sections[index + 1];
      return `
        <section>
          <div class="segment-strip" aria-hidden="true"><span class="young"></span><span class="core"></span><span class="mature"></span></div>
          <div class="chapter-head">
            <div><div class="chapter-no">Chapter ${String(index).padStart(2,'0')} / ${section.en}</div><h1 class="chapter-title">${section.label}</h1></div>
            <p class="chapter-summary">${section.summary}</p>
          </div>
          <div class="chapter-purpose"><div class="purpose-label">品牌资产 / Brand Asset</div><div class="purpose-text">将 Slogan、Logo、图形语言与产品载体组织为统一识别系统，使品牌精神能够被持续、准确地传播。</div></div>
          <div class="slogan-hero">
            <div class="slogan-kicker">Official Brand Slogan / 正式品牌口号</div>
            <div class="slogan-cn">佩戴属于你的神话</div>
            <div class="slogan-en">Wear Your Own Myth.</div>
            <p class="slogan-rationale">这句口号把品牌故事、产品与女性的自我成长连在一起：“佩戴”直接指向饰品与日常表达；“属于你的”强调选择权与不被定义；“神话”不是外界赋予的传奇，而是每个女孩从模仿、尝试走向独立判断后，亲手写下的成长。</p>
          </div>
          <section class="brand-ip-system">
            <div class="brand-ip-head">
              <div><div class="brand-ip-kicker">Core Brand IP / 核心品牌IP资产</div><h2 class="brand-ip-title">一道星芒，一只猫，构成 AngelMyth 的核心识别</h2></div>
              <p class="brand-ip-intro">星芒负责建立可跨越多种风格系列的长期品牌识别；猫咪承载 AngelMyth 女孩甜美与冷感并存的双面人格；四叶草作为辅助元素，为幸运、守护、祝福与礼赠表达提供补充。</p>
            </div>
            <div class="brand-ip-card-grid">
              <article class="brand-ip-card starburst">
                <div class="brand-ip-card-head">
                  <div class="brand-ip-symbol" aria-hidden="true"><svg viewBox="0 0 100 100" fill="none"><path d="M50 7L57 37L84 22L63 44L94 50L63 56L84 78L57 63L50 93L43 63L16 78L37 56L6 50L37 44L16 22L43 37L50 7Z" stroke="currentColor" stroke-width="4" stroke-linejoin="round"/><circle cx="50" cy="50" r="9" fill="currentColor"/><circle cx="80" cy="14" r="3" fill="currentColor"/><circle cx="19" cy="84" r="2.5" fill="currentColor"/></svg></div>
                  <div><div class="brand-ip-index">01 · Brand Core Symbol</div><div class="brand-ip-name">星芒 · 全品牌核心图形</div><div class="brand-ip-position">代表闪耀、能量与被看见，能够贯穿不同年龄、使用场景和风格系列，是最具延展性的第一识别符号。</div></div>
                </div>
                <div class="brand-ip-role-grid">
                  <div class="brand-ip-role"><b>品牌识别</b><span>用于Logo辅助图形、包装光点、吊牌、纹样、陈列与社交媒体动态光效。</span></div>
                  <div class="brand-ip-role"><b>产品开发</b><span>可形成吊坠、耳钉、戒面、链节和镂空结构，并通过镶钻、锆石与珍珠持续变化。</span></div>
                  <div class="brand-ip-role"><b>跨风格表达</b><span>千金风用密镶与闪耀锆石，小清新用珍珠和轻量光点，通勤与冷感系列则采用极简金属线条。</span></div>
                </div>
                <div class="brand-ip-product-tags"><span>四芒星</span><span>八芒星</span><span>锆石星光</span><span>珍珠星芒</span><span>几何镂空星芒</span></div>
              </article>
              <article class="brand-ip-card cat">
                <div class="brand-ip-card-head">
                  <div class="brand-ip-symbol" aria-hidden="true"><svg viewBox="0 0 100 100" fill="none"><path d="M26 34L20 13L39 25C46 21 56 21 63 25L82 13L76 35C82 43 84 53 81 63C77 78 65 87 50 87C35 87 23 78 19 63C16 53 19 42 26 34Z" stroke="currentColor" stroke-width="5" stroke-linejoin="round"/><path d="M36 51C39 48 43 48 46 51M58 51C61 48 65 48 68 51" stroke="currentColor" stroke-width="4" stroke-linecap="round"/><path d="M50 61C54 57 58 60 58 63C58 67 53 70 50 73C47 70 42 67 42 63C42 60 46 57 50 61Z" fill="currentColor"/><path d="M28 63L11 59M28 69L11 72M72 63L89 59M72 69L89 72" stroke="currentColor" stroke-width="3" stroke-linecap="round"/></svg></div>
                  <div><div class="brand-ip-index">02 · Character & Animal IP</div><div class="brand-ip-name">猫咪 · 品牌动物IP</div><div class="brand-ip-position">代表独立、灵敏、可爱与轻微的疏离感，能够同时连接甜妹与冷感大女主两类核心品牌人物。</div></div>
                </div>
                <div class="brand-ip-role-grid">
                  <div class="brand-ip-role"><b>角色资产</b><span>逐步建立猫咪轮廓、表情、动作与性格设定，后续可发展正式IP名称。</span></div>
                  <div class="brand-ip-role"><b>产品开发</b><span>优先用于猫耳、猫眼、猫爪、尾巴曲线、侧脸剪影与圆润猫鼻等可佩戴结构。</span></div>
                  <div class="brand-ip-role"><b>互动传播</b><span>适用于礼盒彩蛋、贴纸、包挂、社交内容和节日限定，增强收藏与分享感。</span></div>
                </div>
                <div class="brand-ip-product-tags"><span>猫耳轮廓</span><span>圆润猫鼻</span><span>猫爪锆石</span><span>尾巴曲线</span><span>猫咪包挂</span></div>
              </article>
            </div>
            <div class="brand-ip-secondary-title">Secondary Brand Element / 辅助品牌元素</div>
            <div class="brand-ip-secondary-grid">
              <article class="brand-ip-secondary-card heart"><div class="brand-ip-secondary-symbol" aria-hidden="true"><svg viewBox="0 0 64 64" fill="none"><path d="M32 53C29 50 10 38 10 23C10 15 15 10 22 10C27 10 30 13 32 17C34 13 37 10 42 10C49 10 54 15 54 23C54 38 35 50 32 53Z" stroke="currentColor" stroke-width="3.5" stroke-linejoin="round"/></svg></div><div><b>爱心 · 品牌辅助元素</b><span>表达悦己、亲密与浪漫，是女性自购和闺蜜礼赠场景中的情绪符号；用于项链、耳饰、手链、戒指及包装细节，强化品牌的温柔记忆点。</span></div></article>
              <article class="brand-ip-secondary-card clover"><div class="brand-ip-secondary-symbol" aria-hidden="true"><svg viewBox="0 0 64 64" fill="none"><path d="M32 30C18 27 13 21 16 14C19 7 27 10 32 19C37 10 45 7 48 14C51 21 46 27 32 30ZM32 30C18 33 13 39 16 46C19 53 27 50 32 41C37 50 45 53 48 46C51 39 46 33 32 30Z" stroke="currentColor" stroke-width="3.5" stroke-linejoin="round"/><path d="M32 31V57" stroke="currentColor" stroke-width="3.5" stroke-linecap="round"/></svg></div><div><b>四叶草 · 品牌辅助元素</b><span>表达幸运、守护与祝福，主要用于礼赠、纪念、轻复古和日常百搭系列；作为星芒与猫咪之外的补充元素，不承担品牌主识别。</span></div></article>
            </div>
            <div class="brand-ip-architecture">
              <div class="brand-ip-architecture-item"><b>星芒 · 核心识别层</b><span>跨风格、高延展、贯穿所有产品线</span></div><div class="brand-ip-arrow">→</div>
              <div class="brand-ip-architecture-item"><b>猫咪 · 情感角色层</b><span>人格化、故事化、形成互动记忆</span></div><div class="brand-ip-arrow">→</div>
              <div class="brand-ip-architecture-item"><b>爱心 + 四叶草 · 辅助元素层</b><span>悦己、亲密、幸运、守护与礼赠补充</span></div>
            </div>
            <div class="brand-ip-style-title">四种产品风格中的IP转译方向</div>
            <div class="brand-ip-style-grid">
              <div class="brand-ip-style"><b>韩系小千金风</b><span>采用密镶锆石、金色轮廓与多层放射星芒，营造璀璨、娇贵和高礼物感。</span></div>
              <div class="brand-ip-style"><b>韩系精致通勤风格</b><span>采用极简四芒星、细金属线条和单颗锆石光点，控制体量并强化日常高级感。</span></div>
              <div class="brand-ip-style"><b>韩系小清新风格</b><span>以小珍珠作为星光节点，搭配轻量八芒星和清透配色，适合叠戴与日常百搭。</span></div>
              <div class="brand-ip-style"><b>韩系冷感大女主风格</b><span>使用锐利几何星芒、银色液态金属与不对称结构，表现方向感、力量与冷光气质。</span></div>
            </div>
            <div class="brand-ip-rule"><b>开发原则：</b>星芒必须保持清晰的品牌识别骨架，并通过镶钻、锆石、珍珠、镂空与金属结构适配不同系列；猫咪可以随系列改变姿态与气质；四叶草只作为辅助元素按场景使用。所有元素避免低幼化，通过比例、材质与工艺完成“简约、精致、年轻、闪耀”的品牌化表达。</div>
          </section>
          <div class="slogan-spec-grid">
            <article class="slogan-spec-card"><div class="slogan-spec-no">01 · Meaning</div><h2 class="slogan-spec-title">书写自己的成长</h2><p class="slogan-spec-copy">“属于你的神话”强调人生没有统一答案。消费者从借鉴他人走向建立判断，最终拥有定义自身风格与生活的权利。</p></article>
            <article class="slogan-spec-card"><div class="slogan-spec-no">02 · Product Link</div><h2 class="slogan-spec-title">让饰品成为随身印记</h2><p class="slogan-spec-copy">“佩戴”与首饰品类直接相连。每一次组合、叠戴和场景选择，都是她表达当下状态、记录成长阶段的具体动作。</p></article>
            <article class="slogan-spec-card"><div class="slogan-spec-no">03 · Usage</div><h2 class="slogan-spec-title">适配长期品牌传播</h2><p class="slogan-spec-copy">中文用于国内品牌主视觉和情绪传播；英文用于 Logo 组合、包装、吊牌、社交媒体及国际化场景。</p></article>
          </div>
          <div class="slogan-lockups">
            <article class="slogan-lockup"><div class="slogan-lockup-label">Primary Lockup / 中英文标准组合</div><div class="slogan-lockup-cn">佩戴属于你的神话</div><div class="slogan-lockup-en">Wear Your Own Myth.</div></article>
            <article class="slogan-lockup dark"><div class="slogan-lockup-label">Compact Application / 包装与社交媒体</div><div class="slogan-lockup-cn">ANGELMYTH</div><div class="slogan-lockup-en">Wear Your Own Myth.</div></article>
          </div>
          <div class="strategy-conclusion"><div class="strategy-conclusion-label">使用规范</div><div class="strategy-conclusion-copy">品牌正式对外表达优先使用中英文标准组合。中文固定为“佩戴属于你的神话”，不得缩写或改写；英文固定为“Wear Your Own Myth.”，保留句末句号。空间受限时可仅使用英文与 ANGELMYTH 组合，但不可另造近义口号替代。</div></div>
          <div class="chapter-footer"><div class="progress-copy">品牌中英文 Slogan 已确认并纳入视觉资产系统</div>${next ? `<button class="next-btn" type="button" data-target="${next.id}">下一章：${next.label} →</button>` : ''}</div>
        </section>`;
    }

    function channelPlanTemplate(section, index) {
      const next = sections[index + 1];
      const platforms = [
        { name:'小红书', role:'首选种草阵地', color:'#e95686', purpose:'建立品牌审美、场景需求与女性成长心智，承担站外搜索和口碑沉淀。', actions:['校园、通勤、约会、聚会与旅行的场景化图文','KOC和中腰部穿搭达人真实上身、叠戴教程与测评','搜索词布局与评论洞察，反哺选品和内容主题'], rule:'启动即布局；前期优先看搜索、收藏和有效互动，而非只看直接成交。' },
        { name:'抖音', role:'声量＋销量爆发', color:'#448cf2', purpose:'用短视频、达人和直播快速放大内容，并由抖音小店完成兴趣成交。', actions:['换装、妆发、叠戴和一饰多搭的高密度短视频','达人分销、KOC矩阵与品牌自播共同测试爆款','站内付费放大优质素材，短视频和直播间互相导流'], rule:'首发核心渠道；先测试点击与成交，再把预算集中到有效素材和达人。' },
        { name:'天猫', role:'品牌成交承接', color:'#d94f6f', purpose:'承接小红书与抖音产生的品牌搜索，建立官方信任、评价和稳定日销。', actions:['统一品牌首页、系列页、场景详情页和搭配套组表达','站内短视频、搜索推广、猜你喜欢与人群重定向','新品期、大促和会员运营形成成交与复购节奏'], rule:'与抖音同期上线；重点建设搜索承接、产品证据、评价资产和官方品牌感。' },
        { name:'得物', role:'年轻潮流背书', color:'#7b64a0', purpose:'产品体系成熟后，以强风格、强辨识和适合年轻人群的系列进入潮流渠道。', actions:['优先选择甜酷、冷感、叠戴与辨识度强的产品','社区上身内容、新品首发和达人测评同步启动','根据平台费用反推价格带、毛利与组合结构'], rule:'第二阶段进入；需同时满足风格适配、评价成本、平台费用和可持续毛利。' },
        { name:'京东', role:'品质与服务背书', color:'#955f47', purpose:'供应与售后稳定后，承接更重视履约、材质和官方保障的消费者。', actions:['突出材质参数、工艺证明、质检、售后与配送体验','优先上线成熟通勤、礼赠及高品质套组','用站内搜索、活动资源和老客运营建立稳定日销'], rule:'后期进入；以供应稳定、售后成熟和品质内容完整为前提。' }
      ];
      return `
        <section>
          <div class="segment-strip" aria-hidden="true"><span class="young"></span><span class="core"></span><span class="mature"></span></div>
          <div class="chapter-head"><div><div class="chapter-no">Chapter ${String(index).padStart(2,'0')} / ${section.en}</div><h1 class="chapter-title">${section.label}</h1></div><p class="chapter-summary">${section.summary}</p></div>
          <div class="channel-principle"><div class="channel-principle-label">CHANNEL PRINCIPLE<br>渠道总原则</div><p class="channel-principle-copy">建立“货架电商＋内容种草＋直播成交”协同的货盘机制。货架电商与直播货盘的逻辑不同：天猫需要通过持续上新扩大产品宽度、覆盖更多搜索需求、用户需求和风格需求，并推动全店动销；抖音直播则更重视产品的色彩组合、服装搭配和套系关联，通过主推款带动项链、耳饰、手链及戒指的连带成交。因此，后续产品应围绕季度、当季色彩和穿搭场景进行强关联开发，并将产品倍率作为站外推广的重要支撑，确保售价能够覆盖达人佣金、投流、折扣及售后成本。在上市节奏上，天猫、小红书和抖音直播应同步启动：天猫和抖音直播共同承担新品测款，小红书负责内容种草和用户反馈；抖音直播可以直接挂链，通过点击、停留、成交和连带率验证主题与单款。对于测款表现较好的主题或单品，再集中投入小红书、达人短视频等站外资源进行放大；同时，直播间也围绕已经验证的主题和单款安排专项直播，通过反复讲解、成套搭配和流量集中打造爆款。最终形成“季度企划—产品开发—多平台同步上市—天猫与直播测款—站外放大—专项直播打爆—数据反哺下一轮开发”的闭环。</p></div>
          <section class="channel-section">
            <div class="channel-section-head"><div><div class="channel-section-kicker">01 / ENTRY SEQUENCE</div><h2 class="channel-section-title">三阶段渠道进入路线</h2></div><p class="channel-section-note">阶段由内容效率、产品完整度、渠道成本和组织能力共同决定，不是简单按时间切割。</p></div>
            <div class="channel-stage-grid">
              <article class="channel-stage primary"><div class="channel-stage-no">PHASE 01 · 启动期</div><h3 class="channel-stage-title">先建声量与成交闭环</h3><div class="channel-stage-time">品牌上市前后 / 第一优先级</div><div class="channel-stage-platforms"><span class="channel-pill">小红书</span><span class="channel-pill">抖音</span><span class="channel-pill">天猫</span></div><p class="channel-stage-copy">小红书和抖音达人、短视频构成主要声量来源；抖音同时完成站内分发与小店成交，天猫承接跨平台搜索、官方信任与稳定日销。</p><div class="channel-stage-gate"><b>阶段目标｜</b>跑通有效内容、达人、产品与两个成交店铺之间的转化路径。</div></article>
              <article class="channel-stage secondary"><div class="channel-stage-no">PHASE 02 · 完善期</div><h3 class="channel-stage-title">选择性进入得物</h3><div class="channel-stage-time">产品系列与口碑稳定后</div><div class="channel-stage-platforms"><span class="channel-pill">得物</span></div><p class="channel-stage-copy">不将全部货盘直接搬入得物，而是依据人群、风格、价格和平台费用，选择甜酷、冷感、叠戴及视觉辨识度强的系列。</p><div class="channel-stage-gate"><b>进入门槛｜</b>毛利可覆盖费用；风格适配年轻潮流人群；已有内容素材和基础评价。</div></article>
              <article class="channel-stage tertiary"><div class="channel-stage-no">PHASE 03 · 扩张期</div><h3 class="channel-stage-title">再进入京东</h3><div class="channel-stage-time">供应与服务体系成熟后</div><div class="channel-stage-platforms"><span class="channel-pill">京东</span></div><p class="channel-stage-copy">以品质、履约和售后为核心，优先放入成熟通勤、礼赠与高品质套组，补充全渠道覆盖和品质型成交。</p><div class="channel-stage-gate"><b>进入门槛｜</b>供应稳定、质检清晰、售后成熟，并能持续运营站内资源。</div></article>
            </div>
          </section>
          <section class="channel-section">
            <div class="channel-section-head"><div><div class="channel-section-kicker">02 / TRAFFIC LOOP</div><h2 class="channel-section-title">前期声量与成交承接路径</h2></div><p class="channel-section-note">小红书负责深度种草，抖音兼具声量制造与即时转化，天猫负责官方信任和跨平台搜索承接。</p></div>
            <div class="channel-flow">
              <article class="channel-flow-node source"><div class="channel-flow-label">CONTENT SOURCES / 并行声量源</div><h3 class="channel-flow-title">小红书种草＋抖音内容</h3><p class="channel-flow-copy">小红书通过场景笔记、KOC与达人建立深度认知；抖音通过短视频、达人合作和直播制造更广泛的视觉声量，两者并行启动。</p></article>
              <div class="channel-flow-arrow" aria-hidden="true"><span>→</span></div>
              <article class="channel-flow-node content"><div class="channel-flow-label">INTENT / 意向放大</div><h3 class="channel-flow-title">品牌搜索＋站内进店</h3><p class="channel-flow-copy">优质内容经达人传播和付费投放持续放大，消费者进一步搜索品牌、浏览系列与比较价格，形成明确购买意向。</p></article>
              <div class="channel-flow-arrow" aria-hidden="true"><span>→</span></div>
              <article class="channel-flow-node sales"><div class="channel-flow-label">CONVERSION / 成交</div><h3 class="channel-flow-title">抖音小店＋天猫旗舰店</h3><p class="channel-flow-copy">抖音承接即时兴趣成交；天猫承接品牌搜索、对比决策、官方信任和大促复购。</p></article>
            </div>
          </section>
          <section class="channel-section">
            <div class="channel-section-head"><div><div class="channel-section-kicker">03 / PLATFORM PLAYBOOK</div><h2 class="channel-section-title">五个平台的推广形式与职责</h2></div><p class="channel-section-note">同一套素材不能机械复制到所有平台，应根据用户任务重新组织标题、画面、证据和成交动作。</p></div>
            <div class="channel-platform-grid">${platforms.map(platform => `<article class="channel-platform-card" style="--role-color:${platform.color}"><div class="channel-platform-top"><h3 class="channel-platform-name">${platform.name}</h3><span class="channel-platform-role">${platform.role}</span></div><p class="channel-platform-purpose">${platform.purpose}</p><div class="channel-action-list">${platform.actions.map(action => `<div class="channel-action">${action}</div>`).join('')}</div><div class="channel-entry-rule"><b>部署原则｜</b>${platform.rule}</div></article>`).join('')}</div>
          </section>
          <div class="chapter-footer"><div class="progress-copy">渠道进入顺序、平台职责与前期流量闭环已确认</div>${next ? `<button class="next-btn" type="button" data-target="${next.id}">下一章：${next.label} →</button>` : ''}</div>
        </section>`;
    }

    function annualTrendPoints() {
      const notes = state['annual-plan']?.notes || {};
      const definitions = [
        { key:'2026-10', month:'2026.10', defaultSku:40, title:'品牌首开', detail:'品牌首开产品，完成首次正式上市。' },
        { key:'2026-11', month:'2026.11', defaultSku:12, title:'货盘补充', detail:'补充首发后的品类与款式缺口。' },
        { key:'2026-12', month:'2026.12', defaultSku:24, title:'年货节上新', detail:'重点为年前年货节准备新货。' },
        { key:'2027-01', month:'2027.01', defaultSku:24, title:'情人节主题', detail:'主打 2 月 14 日情人节消费节点。' },
        { key:'2027-02', month:'2027.02', defaultSku:30, title:'38 女王节', detail:'主打 3 月 8 日女王节活动。' },
        { key:'2027-03', month:'2027.03', defaultSku:20, title:'承接夏季上新', detail:'承接夏季产品上新，计划开发 20 款。' },
      ];
      return definitions.map(point => {
        const noteKey = `month-${point.key}-sku`;
        const hasSavedValue = Object.prototype.hasOwnProperty.call(notes, noteKey);
        const inputValue = hasSavedValue ? String(notes[noteKey] ?? '').trim() : (point.defaultSku === null ? '' : String(point.defaultSku));
        const numericValue = Number(inputValue);
        return {
          ...point,
          noteKey,
          inputValue,
          sku: inputValue === '' || !Number.isFinite(numericValue) ? null : Math.max(0, numericValue),
        };
      });
    }

    function annualTrendSvg(points) {
      const width = 1020;
      const height = 310;
      const left = 62;
      const right = 32;
      const top = 34;
      const bottom = 58;
      const highestSku = Math.max(0, ...points.map(point => point.sku ?? 0));
      const tickStep = Math.max(5, Math.ceil(Math.max(15, highestSku) / 15) * 5);
      const maxSku = tickStep * 3;
      const ticks = [0, tickStep, tickStep * 2, maxSku];
      const xAt = position => left + position * ((width - left - right) / (points.length - 1));
      const yAt = value => height - bottom - (value / maxSku) * (height - top - bottom);
      const pendingY = height - bottom;
      const segments = [];
      let segment = [];
      points.forEach((point, pointIndex) => {
        if (point.sku === null) {
          if (segment.length) segments.push(segment);
          segment = [];
        } else {
          segment.push({ ...point, pointIndex });
        }
      });
      if (segment.length) segments.push(segment);
      const linePath = segments.map(items => items.map((point, itemIndex) => `${itemIndex ? 'L' : 'M'} ${xAt(point.pointIndex)} ${yAt(point.sku)}`).join(' ')).join(' ');
      const areaPath = segments.filter(items => items.length > 1).map(items => {
        const path = items.map((point, itemIndex) => `${itemIndex ? 'L' : 'M'} ${xAt(point.pointIndex)} ${yAt(point.sku)}`).join(' ');
        return `${path} L ${xAt(items.at(-1).pointIndex)} ${pendingY} L ${xAt(items[0].pointIndex)} ${pendingY} Z`;
      }).join(' ');
      const pendingPath = points.map((point, pointIndex) => {
        const previous = points[pointIndex - 1];
        if (point.sku !== null || !previous || previous.sku === null) return '';
        return `M ${xAt(pointIndex - 1)} ${yAt(previous.sku)} L ${xAt(pointIndex)} ${pendingY}`;
      }).filter(Boolean).join(' ');
      return `
        ${ticks.map(value => `<line class="annual-trend-grid" x1="${left}" y1="${yAt(value)}" x2="${width-right}" y2="${yAt(value)}"></line><text class="annual-trend-y" x="${left-13}" y="${yAt(value)+4}" text-anchor="end">${value}</text>`).join('')}
        <line class="annual-trend-axis" x1="${left}" y1="${height-bottom}" x2="${width-right}" y2="${height-bottom}"></line>
        ${areaPath ? `<path class="annual-trend-area" d="${areaPath}"></path>` : ''}
        ${linePath ? `<path class="annual-trend-line" d="${linePath}"></path>` : ''}
        ${pendingPath ? `<path class="annual-trend-dash" d="${pendingPath}"></path>` : ''}
        ${points.map((point, pointIndex) => {
          const pointX = xAt(pointIndex);
          const pointY = point.sku === null ? pendingY : yAt(point.sku);
          return `<circle class="annual-trend-point${point.sku === null ? ' pending' : ''}" cx="${pointX}" cy="${pointY}" r="7"><title>${point.month}｜${point.title}｜${point.sku === null ? 'SKU 待定' : `${point.sku} SKU`}</title></circle><text class="annual-trend-value" x="${pointX}" y="${pointY-15}" text-anchor="middle">${point.sku === null ? '待定' : `${point.sku} SKU`}</text><text class="annual-trend-month" x="${pointX}" y="${height-bottom+28}" text-anchor="middle">${point.month}</text>`;
        }).join('')}
        <text class="annual-trend-y" x="14" y="${top}" transform="rotate(-90 14 ${top})">SKU 数量</text>
      `;
    }

    function refreshAnnualTrendChart() {
      const chart = pageContent.querySelector('.annual-trend-chart');
      if (chart) chart.innerHTML = annualTrendSvg(annualTrendPoints());
    }

    function annualLaunchTrendChart() {
      const points = annualTrendPoints();
      const width = 1020;
      const height = 310;
      return `
        <section class="annual-trend-panel">
          <div class="annual-trend-head">
            <div><h2 class="annual-trend-title">半年产品上市 SKU 节奏</h2><p class="annual-trend-subtitle">在下方直接修改每月开发量，折线图会立即更新，输入内容会自动保存。</p></div>
            <div class="annual-trend-legend">● 可编辑计划 SKU</div>
          </div>
          <div class="annual-trend-scroll">
            <svg class="annual-trend-chart" viewBox="0 0 ${width} ${height}" role="img" aria-label="2026年10月至2027年3月产品上市SKU折线图">
              ${annualTrendSvg(points)}
            </svg>
            <div class="annual-trend-details">
              ${points.map(point => `<article class="annual-trend-detail"><strong>${point.month} · ${point.title}</strong><label class="annual-trend-sku-field"><b>计划开发量</b><input type="number" min="0" step="1" inputmode="numeric" data-note="${point.noteKey}" data-annual-sku value="${escapeHtml(point.inputValue)}" placeholder="待定" aria-label="${point.month}计划开发SKU数量"><em>SKU</em></label><span>${point.detail}</span><div class="annual-trend-save-tip">修改后自动保存</div></article>`).join('')}
            </div>
          </div>
        </section>
      `;
    }

    function annualPlanTemplate(section, index) {
      const next = sections[index + 1];
      const months = [
        ['2026-10', '2026 年 10 月', '#e95686'],
        ['2026-11', '2026 年 11 月', '#448cf2'],
        ['2026-12', '2026 年 12 月', '#955f47'],
        ['2027-01', '2027 年 1 月', '#7b64a0'],
        ['2027-02', '2027 年 2 月', '#26a269'],
        ['2027-03', '2027 年 3 月', '#d08a37'],
      ];
      const notes = state['annual-plan']?.notes || {};
      const phases = [
        ['cycle', '上市周期'],
        ['planning', '企划时间'],
        ['design', '设计时间'],
        ['sampling', '打样时间'],
        ['production', '下单生产'],
        ['visual', '视觉出图'],
        ['promotion', '推广时间'],
        ['shelving', '上架时间'],
      ];
      return `
        <section>
          <div class="segment-strip" aria-hidden="true"><span class="young"></span><span class="core"></span><span class="mature"></span></div>
          <div class="chapter-head">
            <div>
              <div class="chapter-no">Chapter ${String(index).padStart(2, '0')} / HALF-YEAR ROADMAP</div>
              <h1 class="chapter-title">产品开发企划分解</h1>
            </div>
            <p class="chapter-summary">以 2026 年 10 月至 2027 年 3 月为一个半年周期，按月份拆解产品上市开发与推广宣传两条主线。</p>
          </div>
          <div class="chapter-purpose">
            <div class="purpose-label">半年目标 / Half-year Purpose</div>
            <div class="purpose-text">围绕产品开发上市计划与产品推广宣传计划，建立可以持续更新、按月推进、随时复盘的横向时间轴。</div>
          </div>
          ${annualLaunchTrendChart()}
          <div class="annual-timeline-wrap">
            <div class="annual-timeline" aria-label="2026年10月至2027年3月半年计划时间轴">
              ${months.map(([key, label, color], monthIndex) => `
                <article class="annual-month" style="--month-color:${color}">
                  <div class="annual-month-index">MONTH ${String(monthIndex + 1).padStart(2, '0')}</div>
                  <h2 class="annual-month-title">${label}</h2>
                  <div class="annual-phase-grid">
                    ${phases.map(([phaseKey, phaseLabel]) => `<div class="annual-phase-card"><span>${phaseLabel}</span><div class="annual-phase-dates"><label class="annual-phase-date-field"><small>开始</small><input type="date" data-note="month-${key}-${phaseKey}-start" value="${escapeHtml(notes[`month-${key}-${phaseKey}-start`] || '')}" aria-label="${label}${phaseLabel}开始日期"></label><label class="annual-phase-date-field"><small>结束</small><input type="date" data-note="month-${key}-${phaseKey}-end" value="${escapeHtml(notes[`month-${key}-${phaseKey}-end`] || '')}" aria-label="${label}${phaseLabel}结束日期"></label></div></div>`).join('')}
                  </div>
                  <div class="annual-plan-actions"><button class="annual-plan-action" type="button" data-annual-plan-action="product" data-annual-month="${key}">产品开发计划</button><button class="annual-plan-action" type="button" data-annual-plan-action="promotion" data-annual-month="${key}">产品推广计划</button></div>
                </article>
              `).join('')}
            </div>
          </div>
          <p class="annual-timeline-note">提示：每个时间节点都可单独选择起止日期，修改后自动保存；推广周期允许超出开发周期，其余节点按开发周期规划。</p>
          <div class="chapter-footer">
            <div class="progress-copy">半年时间轴已建立：6 个月 × 2 条计划主线</div>
            ${next ? `<button class="next-btn" type="button" data-target="${next.id}">下一章：${next.label} →</button>` : '<span class="next-btn">企划框架完成 / END</span>'}
          </div>
        </section>
      `;
    }

    function chapterTemplate(section, index) {
      const next = sections[index + 1];
      return `
        <section>
          <div class="segment-strip" aria-hidden="true"><span class="young"></span><span class="core"></span><span class="mature"></span></div>
          <div class="chapter-head">
            <div>
              <div class="chapter-no">Chapter ${String(index).padStart(2, '0')} / ${section.en}</div>
              <h1 class="chapter-title">${section.label}</h1>
            </div>
            <p class="chapter-summary">${section.summary}</p>
          </div>
          <div class="chapter-purpose">
            <div class="purpose-label">本章目标 / Purpose</div>
            <div class="purpose-text">${section.purpose}</div>
          </div>
          <div class="pending-grid">
            ${section.prompts.map((prompt, i) => `
              <article class="pending-card">
                <div class="pending-card-head">
                  <div>
                    <h2 class="pending-title">${String(i + 1).padStart(2, '0')} · ${prompt[0]}</h2>
                    <p class="pending-question">${prompt[1]}</p>
                  </div>
                  <span class="pending-status">待确认</span>
                </div>
                <div class="pending-body">
                  <div><strong>策略结论将在确认后呈现</strong><span>候选方向在讨论中选择；本页只收录最终结论与主次关系。</span></div>
                </div>
              </article>
            `).join('')}
          </div>
          <div class="chapter-footer">
            <div class="progress-copy">本章尚未确认 · 网页不展示选择过程</div>
            ${next ? `<button class="next-btn" type="button" data-target="${next.id}">下一章：${next.label} →</button>` : '<span class="next-btn">企划框架完成 / END</span>'}
          </div>
        </section>
      `;
    }

    function buildChoiceConclusion(section, promptIndex, selectedIndexes) {
      const selected = selectedIndexes.map(index => section.choices[promptIndex][index]);
      if (!selected.length) return '';
      const leads = [
        '产品的核心使用场景集中在',
        '产品需要同时提供的核心价值包括',
        '产品应优先建立以下搭配关系：',
        '最适合沉淀为品牌内容的画面包括'
      ];
      const details = selected.map(choice => `${choice[0]}（${choice[1]}）`).join('、');
      return `${leads[promptIndex]}${details}。`;
    }

    function updateChoiceCard(promptIndex) {
      const section = sections.find(item => item.id === currentId);
      const selected = state[currentId]?.selections?.[promptIndex] || [];
      const card = pageContent.querySelector(`[data-card="${promptIndex}"]`);
      const status = pageContent.querySelector(`[data-status="${promptIndex}"]`);
      card?.classList.toggle('has-choice', selected.length > 0 || Boolean(state[currentId]?.notes?.[promptIndex]?.trim()));
      if (status) status.textContent = selected.length ? `已选 ${selected.length} 项` : '待选择';
      const complete = section.prompts.filter((_, i) => (state[currentId]?.selections?.[i]?.length > 0 || Boolean(state[currentId]?.notes?.[i]?.trim()))).length;
      const progress = pageContent.querySelector('.progress-copy strong');
      if (progress) progress.textContent = `${complete} / ${section.prompts.length}`;
    }

    function escapeHtml(value) {
      return value.replace(/[&<>'"]/g, char => ({ '&':'&amp;', '<':'&lt;', '>':'&gt;', "'":'&#39;', '"':'&quot;' }[char]));
    }

    async function navigate(id, updateHash = true) {
      if (!sections.some(section => section.id === id)) {
        id = 'home';
        history.replaceState(null, '', '#home');
      }
      currentId = id;
      const index = sections.findIndex(section => section.id === id);
      const section = sections[index];
      if (id === 'product-launch') await refreshLaunchPlans(true);
      if (id === 'style-hit-pool') await loadStylePool();
      renderNav();
      document.querySelector('.topbar')?.classList.toggle('home-mode', id === 'home');
      const audienceKey = document.querySelector('.audience-key');
      const audienceCore = audienceKey?.querySelector('.core');
      audienceKey?.classList.toggle('materials-mode', id === 'materials');
      if (audienceCore) audienceCore.textContent = id === 'materials' ? '24–28' : '24–28 核心 60%';
      breadcrumb.textContent = `${section.en.toUpperCase()} / ${section.label}`;
      pageContent.innerHTML = id === 'home' ? homeTemplate() : id === 'brand-story' ? storyTemplate() : id === 'positioning' ? positioningTemplate(section, index) : id === 'consumer' ? consumerTemplate(section, index) : id === 'consumer-scenes' ? consumerScenesTemplate(section, index) : id === 'product-scenes' ? productScenesTemplate(section, index) : id === 'visual-system' ? visualSystemTemplate(section, index) : id === 'pricing' ? pricingTemplate(section, index) : id === 'channel-plan' ? channelPlanTemplate(section, index) : id === 'profit' ? profitModelTemplate(section, index) : id === 'materials' ? materialsTemplate(section, index) : id === 'product-launch' ? productLaunchTemplate(section, index) : id === 'style-hit-pool' ? styleHitPoolTemplate(section, index) : id === 'annual-plan' ? annualPlanTemplate(section, index) : chapterTemplate(section, index);
      if (isReadOnlyUser) {
        pageContent.querySelectorAll('input, textarea, select, button:not([data-target])').forEach(control => { control.disabled = true; });
        pageContent.querySelectorAll('.choice-option, [data-clear-choice], [data-profit-add-price], [data-profit-remove-price], [data-profit-reset]').forEach(control => { control.style.pointerEvents = 'none'; });
      } else if (appUser.role !== 'admin' && id !== 'product-launch' && id !== 'style-hit-pool' && id !== 'annual-plan' && id !== 'profit') {
        pageContent.querySelectorAll('input, textarea, select, button:not([data-target])').forEach(control => { control.disabled = true; });
        pageContent.querySelectorAll('.choice-option, [data-clear-choice], [data-profit-add-price], [data-profit-remove-price], [data-profit-reset]').forEach(control => { control.style.pointerEvents = 'none'; });
      }
      if (appUser.role !== 'admin' && id === 'profit') {
        pageContent.querySelectorAll('[data-profit-rate], [data-profit-add-price], [data-profit-remove-price], [data-profit-reset]').forEach(control => {
          control.disabled = true;
          control.style.pointerEvents = 'none';
        });
      }
      document.title = `${section.label} — AngelMyth`;
      if (updateHash) history.replaceState(null, '', `#${id}`);
      closeMenu();
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }

    function closeMenu() {
      sidebar.classList.remove('open');
      backdrop.classList.remove('show');
      menuBtn.setAttribute('aria-expanded', 'false');
    }

    document.addEventListener('click', event => {
      const target = event.target.closest('[data-target]');
      if (target) void navigate(target.dataset.target);
    });

    pageContent.addEventListener('click', event => {
      const launchNew = event.target.closest('[data-launch-new]');
      if (launchNew) {
        if (!canManageLaunchPlans) { toast.textContent = '只有创建者或管理员可以新建上市计划'; toast.classList.add('show'); return; }
        openLaunchModal(); return;
      }

      const launchEdit = event.target.closest('[data-launch-edit]');
      if (launchEdit) { openLaunchModal(launchEdit.dataset.launchEdit); return; }

      const launchDuplicate = event.target.closest('[data-launch-duplicate]');
      if (launchDuplicate) {
        if (!canManageLaunchPlans) { toast.textContent = '只有创建者或管理员可以复制上市计划'; toast.classList.add('show'); return; }
        const source = getLaunchPlans().find(plan => plan.id === launchDuplicate.dataset.launchDuplicate);
        if (source) void (async () => {
          try {
            const duplicate = cloneLaunchPlan(source);
            getLaunchPlans().push(normalizeLaunchPlan(await appLaunchPlanClient.duplicate(duplicate)));
            await navigate('product-launch', false);
          } catch (error) { toast.textContent = error.message || '复制计划失败'; toast.classList.add('show'); }
        })();
        return;
      }

      const launchDelete = event.target.closest('[data-launch-delete]');
      if (launchDelete) {
        if (!canManageLaunchPlans) { toast.textContent = '只有创建者或管理员可以删除整份上市计划'; toast.classList.add('show'); return; }
        const plan = getLaunchPlans().find(item => item.id === launchDelete.dataset.launchDelete);
        if (plan) {
          void (async () => {
            try {
              const editors = typeof appLaunchPlanClient.activeEditors === 'function' ? await appLaunchPlanClient.activeEditors(plan.id, '*') : [];
              const warning = editors.length
                ? `当前有${editors.map(editor => editor.displayName).join('、')}正在编辑这份计划，建议先通知对方再删除。仍要删除“${plan.name || formatLaunchDate(plan.launchDate)}”吗？`
                : `确定删除“${plan.name || formatLaunchDate(plan.launchDate)}”吗？`;
              if (!confirm(warning)) return;
              await appLaunchPlanClient.remove(plan.id);
              state.productLaunchPlans = getLaunchPlans().filter(item => item.id !== plan.id);
              await navigate('product-launch', false);
            } catch (error) { toast.textContent = error.message || '删除失败'; toast.classList.add('show'); }
          })();
        }
        return;
      }

      const choice = event.target.closest('[data-choice-prompt]');
      if (choice) {
        const promptIndex = Number(choice.dataset.choicePrompt);
        const choiceIndex = Number(choice.dataset.choice);
        const section = sections.find(item => item.id === currentId);
        state[currentId] ||= { notes: {}, checks: {}, selections: {} };
        state[currentId].selections ||= {};
        const selected = new Set(state[currentId].selections[promptIndex] || []);
        selected.has(choiceIndex) ? selected.delete(choiceIndex) : selected.add(choiceIndex);
        state[currentId].selections[promptIndex] = [...selected].sort((a, b) => a - b);
        state[currentId].notes ||= {};
        state[currentId].notes[promptIndex] = buildChoiceConclusion(section, promptIndex, state[currentId].selections[promptIndex]);
        choice.classList.toggle('selected', selected.has(choiceIndex));
        choice.setAttribute('aria-pressed', String(selected.has(choiceIndex)));
        const note = pageContent.querySelector(`[data-note="${promptIndex}"]`);
        if (note) note.value = state[currentId].notes[promptIndex];
        updateChoiceCard(promptIndex);
        saveState();
        return;
      }

      const clear = event.target.closest('[data-clear-choice]');
      if (!clear) return;
      const promptIndex = Number(clear.dataset.clearChoice);
      state[currentId] ||= { notes: {}, checks: {}, selections: {} };
      state[currentId].selections ||= {};
      state[currentId].notes ||= {};
      state[currentId].selections[promptIndex] = [];
      state[currentId].notes[promptIndex] = '';
      pageContent.querySelectorAll(`[data-choice-prompt="${promptIndex}"]`).forEach(option => {
        option.classList.remove('selected');
        option.setAttribute('aria-pressed', 'false');
      });
      const note = pageContent.querySelector(`[data-note="${promptIndex}"]`);
      if (note) note.value = '';
      updateChoiceCard(promptIndex);
      saveState();
    });

    launchModalBody.addEventListener('compositionstart', event => {
      if (!event.target.closest('input, textarea, [contenteditable="true"]')) return;
      launchTextCompositionActive = true;
      clearTimeout(launchAutoSaveTimer);
      clearTimeout(launchDraftTimer);
    });

    launchModalBody.addEventListener('compositionend', event => {
      if (!event.target.closest('input, textarea, [contenteditable="true"]')) return;
      launchTextCompositionActive = false;
      queueMicrotask(() => {
        if (!launchDraft) return;
        syncAllLaunchEditableControls();
        scheduleLaunchDraftSave();
      });
    });

    launchModalBody.addEventListener('focusout', () => {
      setTimeout(() => {
        if (!launchDraft || !launchRenderQueued || launchTextCompositionActive || launchTextEditorHasFocus()) return;
        renderLaunchModal({ force:true });
      }, 0);
    });

    launchModalBody.addEventListener('input', event => {
      if (!launchDraft) return;
      touchLaunchPresence(event.target, launchPresencePathFromTarget(event.target));
      if (!launchTextCompositionActive) scheduleLaunchDraftSave(650);
      const matrixControl = event.target.closest('[data-launch-matrix-category], [data-launch-matrix-style], [data-launch-matrix-quantity], [data-launch-matrix-price], [data-launch-matrix-elements]');
      if (matrixControl) {
        const matrix = launchDraft.assortmentMatrix = normalizeAssortmentMatrix(launchDraft.assortmentMatrix);
        if (matrixControl.dataset.launchMatrixCategory !== undefined) matrix.categories[Number(matrixControl.dataset.launchMatrixCategory)] = matrixControl.value;
        else if (matrixControl.dataset.launchMatrixStyle !== undefined) matrix.rows[Number(matrixControl.dataset.launchMatrixStyle)].style = matrixControl.value;
        else if (matrixControl.dataset.launchMatrixQuantity !== undefined) {
          const [rowIndex, columnIndex] = matrixControl.dataset.launchMatrixQuantity.split(':').map(Number);
          matrix.rows[rowIndex].quantities[columnIndex] = matrixControl.value;
          updateLaunchAssortmentTotals();
        } else if (matrixControl.dataset.launchMatrixPrice !== undefined) matrix.rows[Number(matrixControl.dataset.launchMatrixPrice)].priceRange = matrixControl.value;
        else if (matrixControl.dataset.launchMatrixElements !== undefined) matrix.rows[Number(matrixControl.dataset.launchMatrixElements)].elements = matrixControl.value;
        return;
      }
      const competitorBrand = event.target.closest('[data-launch-competitor-brand]');
      if (competitorBrand) {
        const group = launchDraft.competitorReferenceGroups?.[Number(competitorBrand.dataset.launchCompetitorBrand)];
        if (group) group.brand = competitorBrand.value;
        return;
      }
      const competitorTitle = event.target.closest('[data-launch-competitor-title]');
      if (competitorTitle) {
        const group = launchDraft.competitorReferenceGroups?.[Number(competitorTitle.dataset.launchCompetitorTitle)];
        if (group) group.title = competitorTitle.value;
        return;
      }
      const field = event.target.closest('[data-launch-field]');
      if (field) { launchDraft[field.dataset.launchField] = field.value; return; }
      const featuredField = event.target.closest('[data-launch-featured-field]');
      if (featuredField) {
        const [collection, indexValue] = featuredField.dataset.launchFeaturedField.split('|');
        const key = collection === 'homepage' ? 'homepageFeaturedProducts' : 'offsiteFeaturedProducts';
        launchDraft[key] ||= [];
        const index = Number(indexValue);
        while (launchDraft[key].length <= index) launchDraft[key].push(emptyFeaturedProduct());
        launchDraft[key][index].brief = featuredField.value;
        return;
      }
      const sceneCustom = event.target.closest('[data-launch-scene-custom]');
      if (sceneCustom) { updateLaunchSceneFromControls(sceneCustom.dataset.launchSceneCustom, { readSelections:true }); return; }
      const scene = event.target.closest('[data-launch-scene-name]');
      if (scene) return;
      const theme = event.target.closest('[data-launch-theme-name]');
      if (theme) { const [s, c, t] = launchPath(theme.dataset.launchThemeName); launchDraft.segments[s].scenes[c].themes[t].name = theme.value; return; }
      const themeField = event.target.closest('[data-launch-theme-field]');
      if (themeField) {
        const parts = themeField.dataset.launchThemeField.split(':');
        const fieldName = parts.pop();
        const targetTheme = launchThemeAt(parts.join(':'));
        if (targetTheme) targetTheme[fieldName] = themeField.value;
        return;
      }
      const adviceField = event.target.closest('[data-launch-advice-field]');
      if (adviceField) {
        const parts = adviceField.dataset.launchAdviceField.split(':');
        const fieldName = parts.pop();
        const targetTheme = launchThemeAt(parts.join(':'));
        if (targetTheme) { targetTheme.advice ||= {}; targetTheme.advice[fieldName] = adviceField.value; }
        return;
      }
      const style = event.target.closest('[data-launch-style-name]');
      if (style) {
        const [s, c, t, p] = launchPath(style.dataset.launchStyleName);
        launchDraft.segments[s].scenes[c].themes[t].styles[p].name = style.value;
        const imageName = launchModalBody.querySelector(`[data-launch-image-product-name="${s}:${c}:${t}:${p}"]`);
        if (imageName) imageName.textContent = style.value.trim() || `开发款 ${String(p + 1).padStart(2, '0')}`;
        return;
      }
      const styleField = event.target.closest('[data-launch-style-field]');
      if (styleField) {
        const parts = styleField.dataset.launchStyleField.split(':');
        const fieldName = parts.pop();
        const [s, c, t, p] = parts.map(Number);
        const targetStyle = launchDraft.segments?.[s]?.scenes?.[c]?.themes?.[t]?.styles?.[p];
        if (targetStyle) targetStyle[fieldName] = styleField.value;
        return;
      }
      const basicName = event.target.closest('[data-launch-basic-name]');
      if (basicName) { const product = launchBasicProductAt(basicName.dataset.launchBasicName); if (product) product.name = basicName.value; return; }
      const basicField = event.target.closest('[data-launch-basic-field]');
      if (basicField) {
        const parts = basicField.dataset.launchBasicField.split(':');
        const fieldName = parts.pop();
        const product = launchBasicProductAt(parts.join(':'));
        if (product) product[fieldName] = basicField.value;
      }
    });

    launchModalBody.addEventListener('focusin', event => {
      const pasteTarget = event.target.closest('[data-launch-paste-target]');
      launchActivePasteTarget = pasteTarget?.dataset.launchPasteTarget || '';
    });

    launchModalBody.addEventListener('pointerover', event => {
      const pasteTarget = event.target.closest('[data-launch-paste-target]');
      if (!pasteTarget) return;
      launchHoveredPasteTarget = pasteTarget.dataset.launchPasteTarget || '';
      pasteTarget.classList.add('is-paste-hover');
    });

    launchModalBody.addEventListener('pointerout', event => {
      const pasteTarget = event.target.closest('[data-launch-paste-target]');
      if (!pasteTarget) return;
      const nextTarget = event.relatedTarget instanceof Element
        ? event.relatedTarget.closest('[data-launch-paste-target]')
        : null;
      if (nextTarget === pasteTarget) return;
      pasteTarget.classList.remove('is-paste-hover');
      if (launchHoveredPasteTarget === pasteTarget.dataset.launchPasteTarget) launchHoveredPasteTarget = '';
    });

    document.addEventListener('paste', event => {
      if (!launchDraft || !launchModalBackdrop.classList.contains('show')) return;
      // Text fields must keep the browser's native paste behavior. The image
      // paste listener is global so it can support Ctrl+V while hovering an
      // image slot; without this guard a stale/hovered slot can intercept a
      // normal text paste into a textarea.
      const eventElement = event.target instanceof Element ? event.target : null;
      if (eventElement?.closest('input, textarea, select, [contenteditable="true"]')) return;
      const pasteTarget = eventElement?.closest('[data-launch-paste-target]');
      const targetValue = launchHoveredPasteTarget || pasteTarget?.dataset.launchPasteTarget || launchActivePasteTarget;
      if (!targetValue || !launchReferenceImageKinds.has(String(targetValue).split('|')[0])) return;
      const files = [...(event.clipboardData?.items || [])]
        .filter(item => item.kind === 'file' && item.type.startsWith('image/'))
        .map(item => item.getAsFile())
        .filter(Boolean);
      if (!files.length) {
        toast.textContent = '剪贴板中没有图片，请先在其他页面右键复制图片';
        toast.classList.add('show');
        return;
      }
      event.preventDefault();
      try { sendLaunchClipboardFilesToInput(targetValue, files); }
      catch (error) { toast.textContent = error.message || '图片粘贴失败'; toast.classList.add('show'); }
    });

    launchModalBody.addEventListener('change', async event => {
      if (!launchDraft) return;
      touchLaunchPresence(event.target, launchPresencePathFromTarget(event.target));
      scheduleLaunchDraftSave(150);
      const sceneOption = event.target.closest('[data-launch-scene-option]');
      if (sceneOption) { updateLaunchSceneFromControls(sceneOption.dataset.launchSceneOption); return; }
      const sceneClear = event.target.closest('[data-launch-clear-scenes]');
      if (sceneClear) {
        launchModalBody.querySelectorAll(`[data-launch-scene-option="${sceneClear.dataset.launchClearScenes}"]`).forEach(input => { input.checked = false; });
        updateLaunchSceneFromControls(sceneClear.dataset.launchClearScenes);
        return;
      }
      const colorReplaceInput = event.target.closest('[data-launch-color-replace]');
      if (colorReplaceInput) {
        const [kind, imageIndex] = colorReplaceInput.dataset.launchColorReplace.split('|');
        const file = colorReplaceInput.files?.[0];
        if (!file || !['accentColorAnalysisImages', 'baseColorAnalysisImages'].includes(kind)) return;
        launchDraft[kind] ||= [];
        toast.textContent = '正在替换图片并自动保存…';
        toast.classList.add('show');
        try {
          launchDraft[kind][Number(imageIndex)] = await compressLaunchImage(file, { maxSide:640, quality:.72 });
          scheduleLaunchDraftSave(0);
          toast.textContent = '图片已替换，正在自动保存到服务器';
          renderLaunchModal();
        } catch (error) {
          toast.textContent = error.message || '图片替换失败，请更换图片后重试';
        }
        return;
      }
      const featuredImageInput = event.target.closest('[data-launch-featured-image]');
      if (featuredImageInput) {
        const [collection, indexValue] = featuredImageInput.dataset.launchFeaturedImage.split('|');
        const key = collection === 'homepage' ? 'homepageFeaturedProducts' : 'offsiteFeaturedProducts';
        const file = featuredImageInput.files?.[0];
        if (!file) return;
        launchDraft[key] ||= [];
        const index = Number(indexValue);
        while (launchDraft[key].length <= index) launchDraft[key].push(emptyFeaturedProduct());
        toast.textContent = '正在插入产品原图…';
        toast.classList.add('show');
        try {
          launchDraft[key][index].image = await readLaunchImageOriginal(file);
          scheduleLaunchDraftSave(0);
          toast.textContent = '图片已插入，正在自动保存到服务器';
          renderLaunchModal();
        } catch (error) {
          toast.textContent = error.message || '图片插入失败，请更换图片后重试';
        }
        return;
      }
      const input = event.target.closest('[data-launch-image-input]');
      if (!input) return;
      const [kind, pathValue] = input.dataset.launchImageInput.split('|');
      const isCompetitorReference = kind === 'competitorReferenceImages';
      const isPlanReference = ['ajidouReferenceImages', 'cycleReferenceImages', 'accentColorAnalysisImages', 'baseColorAnalysisImages'].includes(kind) || isCompetitorReference;
      const isBasicProductImage = ['basicProductImages', 'basicReferenceImages', 'basicPersonaImages'].includes(kind);
      const targetTheme = isPlanReference || isBasicProductImage ? null : launchThemeAt(pathValue);
      const targetBasicProduct = isBasicProductImage ? launchBasicProductAt(pathValue) : null;
      const targetCompetitorGroup = isCompetitorReference ? launchDraft.competitorReferenceGroups?.[Number(pathValue)] : null;
      if ((!isPlanReference && !isBasicProductImage && !targetTheme) || (isBasicProductImage && !targetBasicProduct) || (isCompetitorReference && !targetCompetitorGroup) || !['ajidouReferenceImages', 'cycleReferenceImages', 'accentColorAnalysisImages', 'baseColorAnalysisImages', 'competitorReferenceImages', 'basicProductImages', 'basicReferenceImages', 'basicPersonaImages', 'referenceImages', 'wearImages', 'extensionReferenceImages', 'finalImages', 'heroShootImages', 'detailVisualImages', 'influencerImages', 'faceImages'].includes(kind)) return;
      const isAdviceImage = ['heroShootImages', 'detailVisualImages', 'influencerImages', 'faceImages'].includes(kind);
      const isFinalImage = kind === 'finalImages' || kind === 'wearImages' || kind === 'basicProductImages';
      const imageTarget = isCompetitorReference ? targetCompetitorGroup : isPlanReference ? launchDraft : isBasicProductImage ? targetBasicProduct : isAdviceImage ? (targetTheme.advice ||= {}) : targetTheme;
      const basicImageFields = { basicProductImages:'images', basicReferenceImages:'referenceImages', basicPersonaImages:'personaImages' };
      const imageField = isCompetitorReference ? 'images' : isBasicProductImage ? basicImageFields[kind] : kind;
      imageTarget[imageField] ||= [];
      const max = kind === 'ajidouReferenceImages' ? 30 : isCompetitorReference ? 30 : kind === 'cycleReferenceImages' ? 30 : ['accentColorAnalysisImages', 'baseColorAnalysisImages'].includes(kind) ? 5 : kind === 'basicProductImages' || kind === 'wearImages' || kind === 'referenceImages' ? 10 : kind === 'finalImages' ? 50 : ['extensionReferenceImages', 'heroShootImages', 'detailVisualImages'].includes(kind) ? 3 : 4;
      const files = [...input.files].slice(0, Math.max(0, max - imageTarget[imageField].length));
      if (!files.length) return;
      toast.textContent = isFinalImage ? '正在插入原图…' : '正在压缩并插入图片…';
      toast.classList.add('show');
      try {
        const compression = isPlanReference ? { maxSide:640, quality:.68 } : undefined;
        for (const file of files) imageTarget[imageField].push(isFinalImage ? await readLaunchImageOriginal(file) : await compressLaunchImage(file, compression));
        if (kind === 'referenceImages' && targetTheme) {
          targetTheme.referenceImageDetails ||= [];
          while (targetTheme.referenceImageDetails.length < targetTheme.referenceImages.length) targetTheme.referenceImageDetails.push({ id:createId('reference'), brand:'', monthlySales:'' });
        }
        toast.textContent = `已插入 ${files.length} 张图片，正在自动保存到服务器`;
        scheduleLaunchDraftSave(0);
        renderLaunchModal();
      } catch (error) {
        toast.textContent = error.message || '图片插入失败，请更换图片后重试';
      }
    });

    launchModalBody.addEventListener('click', event => {
      if (!launchDraft) return;
      touchLaunchPresence(event.target, launchPresencePathFromTarget(event.target));
      const pasteImage = event.target.closest('[data-launch-paste-image]');
      if (pasteImage) {
        const targetValue = pasteImage.dataset.launchPasteImage;
        launchActivePasteTarget = targetValue;
        toast.textContent = '正在读取剪贴板图片…';
        toast.classList.add('show');
        void readLaunchClipboardImages().then(files => {
          sendLaunchClipboardFilesToInput(targetValue, files);
        }).catch(error => {
          toast.textContent = error.message || '无法读取剪贴板图片，请改用 Ctrl+V';
          toast.classList.add('show');
        });
        return;
      }
      const toggleScene = event.target.closest('[data-launch-toggle-scene]');
      if (toggleScene) {
        const key = toggleScene.dataset.launchToggleScene;
        if (launchCollapsedSceneIds.has(key)) launchCollapsedSceneIds.delete(key);
        else launchCollapsedSceneIds.add(key);
        renderLaunchModal();
        return;
      }
      const toggleTheme = event.target.closest('[data-launch-toggle-theme]');
      if (toggleTheme) {
        const key = toggleTheme.dataset.launchToggleTheme;
        if (launchCollapsedThemeIds.has(key)) launchCollapsedThemeIds.delete(key);
        else launchCollapsedThemeIds.add(key);
        renderLaunchModal();
        return;
      }
      const previewImage = event.target.closest('[data-launch-preview-image]');
      if (previewImage) {
        const [kind, pathValue, imageIndex] = previewImage.dataset.launchPreviewImage.split('|');
        openLaunchLightbox(kind, pathValue, imageIndex);
        return;
      }
      const featuredPreview = event.target.closest('[data-launch-preview-featured]');
      if (featuredPreview) {
        const [collection, indexValue] = featuredPreview.dataset.launchPreviewFeatured.split('|');
        const key = collection === 'homepage' ? 'homepageFeaturedProducts' : 'offsiteFeaturedProducts';
        const images = (launchDraft?.[key] || []).map(item => item?.image).filter(Boolean);
        const current = launchDraft?.[key]?.[Number(indexValue)]?.image;
        const imageIndex = Math.max(0, images.indexOf(current));
        openLaunchLightboxImages(images, collection === 'homepage' ? '首页主推款' : '站外推广主推款', imageIndex);
        return;
      }
      const clearScenes = event.target.closest('[data-launch-clear-scenes]');
      if (clearScenes) {
        const path = clearScenes.dataset.launchClearScenes;
        launchModalBody.querySelectorAll(`[data-launch-scene-option="${path}"]`).forEach(input => { input.checked = false; });
        updateLaunchSceneFromControls(path);
        return;
      }
      const addScene = event.target.closest('[data-launch-add-scene]');
      if (addScene) { launchDraft.segments[Number(addScene.dataset.launchAddScene)].scenes.push(normalizeLaunchScene()); scheduleLaunchDraftSave(); renderLaunchModal(); return; }
      const removeScene = event.target.closest('[data-launch-remove-scene]');
      if (removeScene) {
        const path = removeScene.dataset.launchRemoveScene;
        const [s,c] = launchPath(path);
        const scene = launchDraft.segments[s]?.scenes?.[c];
        const name = launchSceneDisplayName(scene) || scene?.name || '未命名场景';
        void confirmLaunchEntityDelete(path, '场景', { alwaysConfirm:true, name, consequence:'该场景下的所有主题、参考图片和款式资料也会一起删除。' }).then(confirmed => { if (!confirmed || !launchDraft) return; launchDraft.segments[s].scenes.splice(c,1); scheduleLaunchDraftSave(); renderLaunchModal(); });
        return;
      }
      const addTheme = event.target.closest('[data-launch-add-theme]');
      if (addTheme) { const [s,c] = launchPath(addTheme.dataset.launchAddTheme); launchDraft.segments[s].scenes[c].themes.push(emptyLaunchTheme()); scheduleLaunchDraftSave(); renderLaunchModal(); return; }
      const removeTheme = event.target.closest('[data-launch-remove-theme]');
      if (removeTheme) {
        const path = removeTheme.dataset.launchRemoveTheme;
        const [s,c,t] = launchPath(path);
        const theme = launchDraft.segments[s]?.scenes?.[c]?.themes?.[t];
        const name = theme?.name?.trim() || '未命名主题';
        void confirmLaunchEntityDelete(path, '主题', { alwaysConfirm:true, name, consequence:'该主题下的参考图片、开发款及已填写资料也会一起删除。' }).then(confirmed => { if (!confirmed || !launchDraft) return; launchDraft.segments[s].scenes[c].themes.splice(t,1); scheduleLaunchDraftSave(); renderLaunchModal(); });
        return;
      }
      const addStyle = event.target.closest('[data-launch-add-style]');
      if (addStyle) {
        const [s,c,t] = launchPath(addStyle.dataset.launchAddStyle);
        const theme = launchDraft.segments[s]?.scenes[c]?.themes[t];
        if (!theme) return;
        if (theme.styles.length >= 50) { toast.textContent = '每个主题最多添加50款资料'; toast.classList.add('show'); return; }
        theme.styles.push(emptyLaunchStyle()); scheduleLaunchDraftSave(); renderLaunchModal(); return;
      }
      const removeStyle = event.target.closest('[data-launch-remove-style]');
      if (removeStyle) {
        const path = removeStyle.dataset.launchRemoveStyle;
        const [s,c,t,p] = launchPath(path);
        const style = launchDraft.segments[s]?.scenes?.[c]?.themes?.[t]?.styles?.[p];
        const name = style?.name?.trim() || `开发款 ${String(p + 1).padStart(2, '0')}`;
        void confirmLaunchEntityDelete(path, '开发款', { alwaysConfirm:true, name, consequence:'该开发款已填写的产品资料将一并删除。' }).then(confirmed => { if (!confirmed || !launchDraft) return; launchDraft.segments[s].scenes[c].themes[t].styles.splice(p,1); scheduleLaunchDraftSave(); renderLaunchModal(); });
        return;
      }
      const addBasicProduct = event.target.closest('[data-launch-add-basic-product]');
      if (addBasicProduct) {
        const products = addBasicProduct.dataset.launchAddBasicProduct === 'subwave' ? launchDraft.subwaveBasicProducts : launchDraft.basicProducts;
        products.push(emptyBasicProduct()); scheduleLaunchDraftSave(); renderLaunchModal(); return;
      }
      const removeBasicProduct = event.target.closest('[data-launch-remove-basic-product]');
      if (removeBasicProduct) {
        const productPath = removeBasicProduct.dataset.launchRemoveBasicProduct;
        const products = launchBasicProductCollection(productPath);
        const productIndex = Number(String(productPath).split(':').at(-1));
        const product = products?.[productIndex];
        const name = product?.name?.trim() || `基本款 ${String(productIndex + 1).padStart(2, '0')}`;
        void confirmLaunchEntityDelete(`basic:${productPath}`, '基本款', { alwaysConfirm:true, name, consequence:'该基本款的参考图、成品设计稿及全部款式资料也会一起删除。' }).then(confirmed => { if (!confirmed || !launchDraft) return; products?.splice(productIndex, 1); scheduleLaunchDraftSave(); renderLaunchModal(); });
        return;
      }
      const removeFeatured = event.target.closest('[data-launch-remove-featured]');
      if (removeFeatured) {
        const [collection, indexValue] = removeFeatured.dataset.launchRemoveFeatured.split('|');
        const key = collection === 'homepage' ? 'homepageFeaturedProducts' : 'offsiteFeaturedProducts';
        const index = Number(indexValue);
        void confirmLaunchEntityDelete(`featured:${collection}:${index}`, '这个主推款').then(confirmed => {
          if (!confirmed || !launchDraft) return;
          if (launchDraft[key]?.[index]) launchDraft[key][index] = emptyFeaturedProduct();
          scheduleLaunchDraftSave();
          renderLaunchModal();
        });
        return;
      }
      const removeImage = event.target.closest('[data-launch-remove-image]');
      if (removeImage) {
        const [kind, pathValue, imageIndex] = removeImage.dataset.launchRemoveImage.split('|');
        const isCompetitorReference = kind === 'competitorReferenceImages';
        const isPlanReference = ['ajidouReferenceImages', 'cycleReferenceImages', 'accentColorAnalysisImages', 'baseColorAnalysisImages'].includes(kind) || isCompetitorReference;
        const isBasicProductImage = ['basicProductImages', 'basicReferenceImages', 'basicPersonaImages'].includes(kind);
        const targetTheme = isPlanReference || isBasicProductImage ? null : launchThemeAt(pathValue);
        const imageTarget = isCompetitorReference ? launchDraft.competitorReferenceGroups?.[Number(pathValue)] : isPlanReference ? launchDraft : isBasicProductImage ? launchBasicProductAt(pathValue) : ['heroShootImages', 'detailVisualImages', 'influencerImages', 'faceImages'].includes(kind) ? targetTheme?.advice : targetTheme;
        const basicImageFields = { basicProductImages:'images', basicReferenceImages:'referenceImages', basicPersonaImages:'personaImages' };
        const imageField = isCompetitorReference ? 'images' : isBasicProductImage ? basicImageFields[kind] : kind;
        void confirmLaunchEntityDelete(pathValue || '*', '这组图片').then(confirmed => { if (!confirmed || !launchDraft) return; if (imageTarget?.[imageField]) imageTarget[imageField].splice(Number(imageIndex), 1); if (kind === 'referenceImages' && targetTheme?.referenceImageDetails) targetTheme.referenceImageDetails.splice(Number(imageIndex), 1); scheduleLaunchDraftSave(); renderLaunchModal(); });
      }
    });

    launchCloseBtn.addEventListener('click', closeLaunchModal);
    launchCancelBtn.addEventListener('click', closeLaunchModal);
    launchSaveBtn.addEventListener('click', () => { void saveLaunchPlan(true, false); });
    launchModalBackdrop.addEventListener('click', event => { if (event.target === launchModalBackdrop) closeLaunchModal(); });
    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'hidden' && launchDraftHasChanges()) {
        saveLaunchDraftLocally();
        void saveLaunchPlan(false, true);
      }
    });
    window.addEventListener('beforeunload', event => {
      if (!launchDraftHasChanges() && !launchSaveRunner) return;
      saveLaunchDraftLocally();
      event.preventDefault();
      event.returnValue = '';
    });
    launchLightboxClose.addEventListener('click', closeLaunchLightbox);
    launchLightboxPrev.addEventListener('click', () => moveLaunchLightbox(-1));
    launchLightboxNext.addEventListener('click', () => moveLaunchLightbox(1));
    launchLightboxImage.addEventListener('mouseleave', () => { if (launchImageLightbox.classList.contains('show')) closeLaunchLightbox(); });
    launchImageLightbox.addEventListener('click', event => { if (event.target === launchImageLightbox) closeLaunchLightbox(); });
    document.addEventListener('keydown', event => {
      if (launchImageLightbox.classList.contains('show')) {
        if (event.key === 'Escape') closeLaunchLightbox();
        else if (event.key === 'ArrowLeft') moveLaunchLightbox(-1);
        else if (event.key === 'ArrowRight') moveLaunchLightbox(1);
        return;
      }
      if (event.key === 'Escape' && launchModalBackdrop.classList.contains('show')) closeLaunchModal();
    });

    pageContent.addEventListener('input', event => {
      const profitRate = event.target.closest('[data-profit-rate]');
      if (profitRate) {
        const [platformKey, costKey] = profitRate.dataset.profitRate.split(':');
        const model = getProfitModel();
        model.platforms[platformKey].rates[costKey] = Math.max(0, Number(profitRate.value) || 0);
        updateProfitModelView();
        clearTimeout(pageContent.profitSaveTimer);
        pageContent.profitSaveTimer = setTimeout(saveState, 300);
        return;
      }
      const profitPrice = event.target.closest('[data-profit-price]');
      if (profitPrice) {
        const model = getProfitModel();
        model.prices[Number(profitPrice.dataset.profitPrice)] = Math.max(0, Number(profitPrice.value) || 0);
        updateProfitModelView();
        stateClient.scheduleProfitPrices(model.prices);
        return;
      }
      const note = event.target.closest('[data-note]');
      if (!note) return;
      state[currentId] ||= { notes: {}, checks: {} };
      state[currentId].notes[note.dataset.note] = note.value;
      if (note.matches('[data-annual-sku]')) {
        refreshAnnualTrendChart();
        clearTimeout(pageContent.saveTimer);
        stateClient.scheduleSave(state);
        return;
      }
      if (sections.find(item => item.id === currentId)?.choices) updateChoiceCard(Number(note.dataset.note));
      clearTimeout(pageContent.saveTimer);
      pageContent.saveTimer = setTimeout(saveState, 350);
    });

    pageContent.addEventListener('change', event => {
      const profitPrice = event.target.closest('[data-profit-price]');
      if (profitPrice) {
        void stateClient.flushProfitPricesNow();
        return;
      }
      const annualSku = event.target.closest('[data-annual-sku]');
      if (annualSku) {
        // The input handler has already queued the latest state. Flush that exact
        // value now so a quick page refresh cannot restore the previous SKU.
        void stateClient.flushNow();
        return;
      }
      const poolInput = event.target.closest('[data-style-pool-input]');
      if (poolInput) {
        const styleKey = poolInput.dataset.stylePoolInput;
        const files = [...poolInput.files];
        if (!files.length || !appApi) return;
        void (async () => {
          poolInput.disabled = true;
          let savedCount = 0;
          const failedFiles = [];
          try {
            for (let fileIndex = 0; fileIndex < files.length; fileIndex += 1) {
              toast.textContent = `正在上传并自动保存 ${fileIndex + 1} / ${files.length} 张…`;
              toast.classList.add('show');
              try {
                const savedImage = await appApi.addStylePoolImage('angelmyth', styleKey, files[fileIndex]);
                const bucket = styleKey === 'ajidou' ? ajidouPoolData : stylePoolData[styleKey];
                bucket.images.unshift(savedImage);
                bucket.total += 1;
                savedCount += 1;
                toast.textContent = `第 ${fileIndex + 1} / ${files.length} 张已自动保存到服务器`;
              } catch (error) {
                failedFiles.push(files[fileIndex].name);
                console.error(`Unable to save style pool image: ${files[fileIndex].name}`, error);
              }
            }
            await loadStylePool(true);
            await navigate('style-hit-pool', false);
            toast.textContent = failedFiles.length
              ? `已自动保存 ${savedCount} 张，${failedFiles.length} 张上传失败，请重新选择失败图片`
              : `已自动保存 ${savedCount} 张图片，刷新页面后仍会保留`;
          } catch (error) {
            toast.textContent = error.message || '图片自动保存失败，请稍后重试';
          } finally {
            poolInput.disabled = false;
            clearTimeout(saveState.timer);
            saveState.timer = setTimeout(() => toast.classList.remove('show'), 2200);
          }
        })();
        return;
      }
      const check = event.target.closest('[data-check]');
      if (!check) return;
      state[currentId] ||= { notes: {}, checks: {} };
      state[currentId].checks[check.dataset.check] = check.checked;
      saveState();
      const section = sections.find(item => item.id === currentId);
      const complete = section.prompts.filter((_, i) => state[currentId].checks?.[i]).length;
      const progress = pageContent.querySelector('.progress-copy strong');
      if (progress) progress.textContent = `${complete} / ${section.prompts.length}`;
    });

    pageContent.addEventListener('click', event => {
      const annualAction = event.target.closest('[data-annual-plan-action]');
      if (annualAction) {
        // 产品开发计划由波段企划打包模块接管，并打开对应月份的完整总报告。
        if (annualAction.dataset.annualPlanAction === 'product') return;
        toast.textContent = '产品推广计划展开内容待配置';
        toast.classList.add('show');
        return;
      }
      const poolPreview = event.target.closest('[data-style-pool-preview]');
      if (poolPreview) {
        const [styleKey, imageIndex] = poolPreview.dataset.stylePoolPreview.split('|');
        const definition = stylePoolDefinitions.find(item => item.key === styleKey);
        const images = stylePoolData[styleKey]?.images.map(image => image.url) || [];
        openLaunchLightboxImages(images, definition?.title || '爆款池图片', Number(imageIndex));
        return;
      }
      const ajidouPreview = event.target.closest('[data-ajidou-pool-preview]');
      if (ajidouPreview) {
        openLaunchLightboxImages(ajidouPoolData.images.map(image => image.url), 'AJIDOU品牌爆品池', Number(ajidouPreview.dataset.ajidouPoolPreview));
        return;
      }
      const ajidouMore = event.target.closest('[data-ajidou-pool-more]');
      if (ajidouMore) {
        void (async () => { await loadMoreAjidouPool(); await navigate('style-hit-pool', false); })();
        return;
      }
      const poolMore = event.target.closest('[data-style-pool-more]');
      if (poolMore) {
        void (async () => { await loadMoreStylePool(poolMore.dataset.stylePoolMore); await navigate('style-hit-pool', false); })();
        return;
      }
      const poolRemove = event.target.closest('[data-style-pool-remove]');
      if (poolRemove && appApi) {
        const [styleKey, imageId] = poolRemove.dataset.stylePoolRemove.split('|');
        if (!confirm('确定从爆款池中删除这张图片吗？')) return;
        void (async () => {
          try {
            await appApi.deleteStylePoolImage('angelmyth', imageId);
            const bucket = styleKey === 'ajidou' ? ajidouPoolData : stylePoolData[styleKey];
            bucket.images = bucket.images.filter(image => image.id !== imageId);
            bucket.total = Math.max(0, bucket.total - 1);
            await navigate('style-hit-pool', false);
          } catch (error) {
            toast.textContent = error.message || '图片删除失败';
            toast.classList.add('show');
          }
        })();
        return;
      }
      const addPrice = event.target.closest('[data-profit-add-price]');
      if (addPrice) {
        const model = getProfitModel();
        if (model.prices.length >= 8) { toast.textContent='最多保留8个测算售价';toast.classList.add('show');setTimeout(()=>{toast.classList.remove('show');toast.textContent='已保存';},1200);return; }
        model.prices.push(model.prices.at(-1) || 100);
        stateClient.scheduleProfitPrices(model.prices);
        navigate('profit', false);
        return;
      }
      const removePrice = event.target.closest('[data-profit-remove-price]');
      if (removePrice) {
        const model = getProfitModel();
        if (model.prices.length <= 1) return;
        model.prices.splice(Number(removePrice.dataset.profitRemovePrice),1);
        stateClient.scheduleProfitPrices(model.prices);
        navigate('profit', false);
        return;
      }
      const resetProfit = event.target.closest('[data-profit-reset]');
      if (resetProfit) {
        state.profitModel = cloneProfitModel();
        saveState();
        navigate('profit', false);
      }
    });

    menuBtn.addEventListener('click', () => {
      const open = sidebar.classList.toggle('open');
      backdrop.classList.toggle('show', open);
      menuBtn.setAttribute('aria-expanded', String(open));
    });
    backdrop.addEventListener('click', closeMenu);

    accountBtn.addEventListener('click', async () => {
      if (!appApi) { alert('当前为本机保存模式，开发计划文字、AJIDOU参考，以及四个风格板块的品牌名称与竞品图片会保存在这台电脑上。'); return; }
      const action = prompt(`${appUser.displayName}\n输入 1 修改密码，输入 2 退出登录，其他内容取消。`);
      if (action === '1') {
        const currentPassword = prompt('请输入当前密码');
        if (!currentPassword) return;
        const newPassword = prompt('请输入新密码（至少3位）');
        if (!newPassword) return;
        try { await appApi.changePassword(currentPassword, newPassword); alert('密码修改成功'); }
        catch (error) { alert(error.message || '密码修改失败'); }
      } else if (action === '2') {
        await appApi.logout();
        location.reload();
      }
    });

    document.getElementById('exportBtn').addEventListener('click', () => {
      const payload = {
        brand: 'AngelMyth',
        version: 'V0.1',
        exportedAt: new Date().toISOString(),
        sections: sections.slice(1).filter(section => section.prompts).map(section => ({
          id: section.id,
          title: section.label,
          prompts: section.prompts.map((prompt, i) => ({
            topic: prompt[0],
            completed: section.decisions
              ? true
              : Array.isArray(section.choices)
                ? Boolean(state[section.id]?.selections?.[i]?.length || state[section.id]?.notes?.[i]?.trim())
                : Boolean(state[section.id]?.checks?.[i]),
            selectedAnswers: Array.isArray(section.choices)
              ? (state[section.id]?.selections?.[i] || []).map(choiceIndex => section.choices[i][choiceIndex]?.[0]).filter(Boolean)
              : [],
            note: section.decisions?.[i]?.conclusion || state[section.id]?.notes?.[i] || ''
          }))
        })),
        productLaunchPlans: getLaunchPlans(),
        profitModel: getProfitModel()
      };
      const blob = new Blob([JSON.stringify(payload, null, 2)], { type: 'application/json' });
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.download = 'angelmyth-brand-plan-v01.json';
      link.click();
      URL.revokeObjectURL(link.href);
      toast.textContent = '工作记录已导出';
      toast.classList.add('show');
      setTimeout(() => { toast.classList.remove('show'); toast.textContent = '已保存'; }, 1200);
    });

    window.addEventListener('hashchange', () => void navigate(location.hash.slice(1), false));
    void navigate(currentId, false);
}
